/**
 * GENERATED FILE — Hungarian exception lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run.ts from UniMorph hun
 * (https://github.com/unimorph/hun @ 20d5e04211bbab3dd689c99637356a8eab7c5fd7).
 * Data license: CC BY-SA 3.0 — see LICENSE-DATA.md at the repository root.
 *
 * Format (one lemma per line): `lemma|flag[,flag…]` where
 *   l — lowering · s:STEM — shortening · v:STEM — v-stem · f:STEM — fleeting
 *   h:b / h:f — lexical harmony override (back / front)
 */
import type { StemFlags } from "./stems.js";

const STEM_DATA = `0-s|h:b
a-moll|j
ábécé|l,h:f
ábécéskönyv|l
ablakzár|l
ábránd|j
abszint|j
absztrakt|j
acél|j
acélkék|l,h:f
acélmű|l,f:acélműv
acetilén|j
aceton|j
acetonom|l
achát|j
adag|j
ádámkosztüm|j
adattárház|l
adatvédelem|f:adatvédelm
admin|j
adum|l
adunk|l
aerobik|j
afgán|j
afrikai|l
ág|l
agár|s:agar
agát|j
agátok|l
agg|j
aggodalom|l,f:aggodalm
aggszűz|s:aggszüz
agility|l,h:f
ágrólszakadt|l,j
agy|l
ágy|l
agyag|j
agyar|l
agykéreg|f:agykérg
ágyláb|l
ágytál|l
ágyúnaszád|j
agyvérzés|lp,h:f
aj|l
ajak|l,f:ajk
ajakír|j
ajándékbolt|j
ajándéktárgy|l
ajánlólevél|s:ajánlólevel
ajk|l
ajkai|l
ajtófél|s:ajtófel,h:f
akciófilm|l,h:f
akcse|l,h:b
akkord|j
akkreditív|j
akol|f:akl
ákombákom|j
akrosztichon|j
akt|j
akvamarin|j
akvarell|j
alagút|s:alagut
alak|j
alap|j
alapbér|lp,h:f
alapfém|l,h:f
alapszint|l,j,h:f
alapvonal|l
alátét|l,h:f
albán|j
albániai|l
alcím|l,h:f
alföld|l,j
alföldi|l
algériai|l
álhír|lp,h:f
alj|l
alkalmazott|l,j
alkalom|l,f:alkalm
alkancellár|j
alkar|j
alkarcsont|j
alkatrész|lp,h:f
alkén|lp,h:f
alkoholtartalom|l,f:alkoholtartalm
alkoholtilalom|l,f:alkoholtilalm
alkotórész|lp,h:f
áll|l
államcsíny|lp,h:f
államkincstár|l
államtitok|f:államtitk
államvasút|s:államvasut
állatidomár|j
állatkórház|l
állatmenhely|l
állatnév|s:állatnev,h:f
állatok|l
állatöv|l
állcsont|j
állkapocs|f:állkapcs
állkapocscsont|j
állóhely|l
állókép|l,h:f
allomorf|j
állunk|l
almalé|s:almalev,h:f
almanach|j
almasav|l
almazöld|l
álnév|s:álnev,h:f
alom|f:alm
álom|f:álm
álomgyár|l
alsóház|l
alsónadrág|j
álszent|j
alt|j
aludttej|l
alulírott|l,j
alumínium-nitrid|l,h:f
amazon|j
ámen|j
amerikai|l
ametiszt|j
amfetamin|j
amid|j
amin|j
aminosav|l
analízis|lp,h:f
andorrai|l
angol|j
ankét|j
antihisztamin|lp,j,h:f
antilop|j
antimon|j
antitézis|lp,h:f
anyaföld|l
anyagi|l
anyakönyv|l
apanév|s:apanev,h:f
apát|j
apatit|j
apátok|l
aperitif|j
apokalipszis|lp,h:f
ápolt|l,j
app|j
apród|j
aprópénz|lp,h:f
ár|l
arab|j
arabeszk|j
árad|l
arany|l
aranyér|f:aranyer,h:f
aranyérem|f:aranyérm
aranyhal|l
aranylakodalom|l,f:aranylakodalm
aranyláz|l
aranysakál|j
aratógép|l,h:f
arcizom|f:arcizm
arckép|l,h:f
arcszín|lp,h:f
argon|j
árkád|j
árny|l
árnyékszék|l,h:f
árok|f:árk
árpacukor|f:árpacukr
árpádsáv|j
arszlán|j
ártalom|l,f:ártalm
ártatlan|j
árucikk|l,h:f
áruház|l
áruk|l
árum|l
árunk|l
árusítóhely|l
árvaház|l
árvíz|s:árviz,h:f
arzén|lp,j,h:f
ásványvíz|s:ásványviz,h:f
aszkézis|lp,h:f
aszkorbinsav|l
aszpirin|lp,j,h:f
asszaszin|j
asszonynép|l,h:f
asztalom|l
asztrahán|j
asztrakán|j
átalag|j
átkelőhely|l
átkozott|l,j
átok|f:átk
atom|j
atomerőmű|l,f:atomerőműv
atomhatalom|l,f:atomhatalm
attak|j
áttét|l,h:f
átvevőhely|l
audiokommentár|j
ausztrál|j
ausztriai|l
autógyár|l
avantgárd|j
avar|j
axon|j
ázsiai|l
bab|j
báb|j
babám|l
babér|j
babérlevél|s:babérlevel
babzsák|j
bácsi|l
bagdadi|l
bagoly|f:bagly
bagolyfészek|f:bagolyfészk
bagolyvár|l
báj|l
bajadér|j
bajai|l
bajom|l
bajonett|j
bajor|j
bajtárs|l
bak|j
bakom|l
bál|j
balek|la,j,h:b
balett|j
balkon|j
ballépés|lp,h:f
ballonkabát|j
baloldal|l
bálterem|f:bálterm
balti|l
bán|j
banán|j
banánhéj|l
bandikut|j
bank|j
bankett|j
bankom|l
bántalom|l,f:bántalm
bányásznap|j
bár|j
barack|j
baracklekvár|j
barbár|j
bárd|j
barikád|j
barit|j
barlang|j
barokk|j
barom|f:barm
bárszék|l,h:f
baseball|j
baskír|j
baszk|j
basszusgitár|j
bát|j
báty|j
bauxit|j
beavatott|l,j
bébi|h:f
bécsi|l
becsvágy|l
bégum|j
behemót|j
békedíj|l,h:b
bél|f:bel
belépődíj|l,h:b
bélféreg|f:bélférg
bélfodor|f:bélfodr
belföld|l,j
belügy|l
benini|l
bennszülött|l
benzin|j
benzinkút|s:benzinkut
benzoesav|l
benzol|j
beosztott|l
bér|h:f
berek|f:berk
bérház|l
berill|j
berillium-nitrid|l,h:f
berlini|l
bét|j
betegágy|l
beton|j
betűszemét|s:betűszemet
betűtalp|l
betyár|j
bevásárlókosár|s:bevásárlókosar
bevásárlóközpont|j
bibircsók|j
bicepsz|l
bicikli|h:f
biliárd|j
bilincs|h:f
billiárd|j
binom|j
birodalom|l,f:birodalm
birs|l
bit|j
bizalom|l,f:bizalm
bizánci|l
bizmut|j
blatt|j
blog|j
blokád|j
blokk|j
blöff|j
blues|h:b
bob|j
bodnár|j
bogár|s:bogar
bogatir|j
bognár|j
bohém|j
bohóchal|l
boholy|f:bolyh
bojkott|j
bojt|j
bojtorján|j
bók|j
bokor|f:bokr
bokszzsák|j
bolgár|j
bolond|j
bolt|j
bonszai|k
bonyodalom|l,f:bonyodalm
bór|j
bordásfal|l
bordélyház|l
boríték|j
borkősav|l
bornit|j
borospohár|s:borospohar
borostyán|j
borostyánkő|l,f:borostyánköv
bórsav|l
borsikafű|l,f:borsikafüv
borsócsont|j
borsuk|l
borzalom|l,f:borzalm
bosnyák|j
bot|j
botswanai|l
böjt|j
bölcs|l
bölcsességfog|l
bölényszárny|l
bőregér|s:bőreger
bőrgyár|l
bőrönd|j
brazil|j
brémai|l
brexit|j
brigád|j
bróm|j
bronzérem|f:bronzérm
brüsszeli|l
búb|j
budapesti|l
budoár|j
bukósisak|j
bukószél|s:bukószel,h:f
buldog|j
bumeráng|j
búr|j
burgonyaszirom|f:burgonyaszirm
burkom|l
burnót|j
burok|f:burk
butadién|lp,h:f
bután|j
butik|j
bútordarab|j
búvármadár|s:búvármadar
búvóhely|l
búzaföld|l
búzaliszt|l,j,h:f
buzgalom|l,f:buzgalm
bükk|j
bűnbak|j
bűntárs|l
bűnügy|l
bürök|f:bürk
cadik|j
cajg|j
capin|j
cár|j
cég|h:f
cél|j
celofán|j
célpont|j
cent|j
centigramm|j
cet|j
chat|l,h:f
chilei|l
chip|j
chips|l
cián|j
cigánykerék|s:cigánykerek
cigarettacsikk|l,h:f
cikcakk|j
cikk|h:f
ciklámen|j
ciklohexán|f:cyclohexán
ciklon|j
cím|h:f
cimbalom|f:cimbalm
címlap|j
címszó|s:címszav
címzett|j
cin|j
cingár|j
cink|j
cinterem|f:cinterm
cipőkanál|s:cipőkanal
cipőtalp|l
cipzár|l
cisz|h:f
citrom|j
citromfagylalt|j
citromfű|l,f:citromfüv
citromlé|s:citromlev,h:f
citromsav|l
cókmók|j
col|j
colstok|j
comb|j
combcsont|j
combizom|f:combizm
copf|j
cowboykalap|j
cúg|j
cukkini|la,h:f
cukor|f:cukr
cukorgyár|lp
cukormáz|l
cukornád|l,j
cukorsav|l
csáb|j
csador|j
családnév|s:családnev,h:f
családtag|j
családtalan|j
csalán|j
csalétek|f:csalétk
csap|j
csáp|j
csapágy|l
csapatépítés|lp,h:f
csapattárs|l
csaplyuk|l
csapvíz|s:csapviz,h:f
császári|l
császármadár|s:császármadar
császárpingvin|lp,j,h:f
csat|j
csatabárd|j
csataló|l,f:csatalov
csatatér|s:csatater,h:f
csavar|j
cseber|f:csebr
csecsen|j
csehszlovák|j
csekk|j
cseléd|j
csend|j
csép|j
csepp|j
cser|j
cserebogár|s:cserebogar
cserekereskedelem|f:cserekereskedelm
cserép|s:cserep
csészealj|l
csi|h:f
csibuk|j
csík|j
csikk|h:f
csikóhal|lp
csillagfény|lp,h:f
csillaghatszög|l
csillagkép|l,h:f
csillagtérkép|l,h:f
csillagtök|j
csillár|j
csín|la,j,h:b
csíny|h:f
csip|j
csípés|h:f
csipet|j
csípőbél|f:csípőbel
csipsz|l
csirkeszárny|l
csodabogár|s:csodabogar
csók|j
csokinyúl|s:csokinyul
csokoládéfagylalt|j
csokoládémáz|l
csokoládényúl|s:csokoládényul
csokor|f:csokr
csomag|j
csombord|j
csónak|j
csónakház|l
csont|j
csontrák|j
csontváz|l
csoport|j
csoporttárs|l
cső|l,f:csöv
csöbör|f:csöbr
csőd|j
csőharang|j
csönd|l,j
csörgődob|j
csőváz|l
csúcsdísz|lp,h:f
csúcsforgalom|l,f:csúcsforgalm
csúfnév|s:csúfnev,h:f
csukamájolaj|l
csupor|f:csupr
csúszópénz|lp,h:f
csücsök|f:csücsk
dalmű|l,f:dalműv
dalom|l
dalszínház|l
dám|j
damaszkuszi|l
damaszt|j
dámvad|l,j
dandár|j
darab|j
darázs|s:darazs
darázscsípés|lp,h:f
darázsfészek|f:darázsfészk
darázskürt|j
datolyacukor|f:datolyacukr
decibel|j
decigramm|j
defekt|j
dekagramm|j
dékán|j
dél-afrikai|l
dél-amerikai|l
dél-szudáni|l
dél|s:del
délelőtt|j
delfin|j
délibáb|j
délkelet|j
deltoid|j
délután|j
demizson|j
dér|s:der
derék|s:derek
derékalj|l
derékszög|l
derivált|l
design|la,j,h:b
desszert|j
dezoxiribonukleinsav|l
diadalív|l,h:f
diadalom|l,f:diadalm
diagram|j
diák|j
diapozitív|j
dietilamid|j
differenciál|j
díj|l
dinamit|j
diófacincér|lp,h:f
diófalevél|s:diófalevel
dióhéj|l
diplomagyár|l
dísz|h:f
disznóhal|l
disznóól|l,j
disznósajt|j
disznózsír|j
disszidens|l
díván|j
divat|j
dízel|j
dízelmotor|j
dob|j
dobjuk|l
dobod|l
dobom|l
dobunk|l
dohánygyár|lp
dokk|j
dokumentumfilm|l,j,h:f
dollár|j
dolog|f:dolg
dóm|j
domb|j
domboldal|lp
dombvidék|l,h:f
domén|lp,j,h:f
dominikai|l
đồng|h:b
dongaláb|l
doromb|j
dorong|j
dózse|l,h:b
dörgedelem|f:dörgedelm
drágakő|l,f:drágaköv
drágám|l
dramaturg|j
drinápolyi|l
drog|j
dromedár|j
drót|j
duett|j
dugipénz|lp,h:f
dunántúli|l
dunszt|j
dúr|j
duttyán|j
düftin|j
dzsem|j
dzsihád|j
dzsinn|j
dzsip|j
dzsogging|j
e-könyv|l
e-mail-cím|l,h:f
e-mail|lp,j,h:f
ebéd|j
ebihal|l
ecetgyár|l
ecetsav|l
ecuadori|l
edényalátét|l,h:f
édesgyökér|s:édesgyöker
édeskevés|f:édeskeves
édesvíz|s:édesviz
edzőterem|f:edzőterm
eff|j
ég-föld|s:eget-föld
ég|s:eg
égbolt|j
egér|s:eger
egérút|s:egérut
égés|h:f
egész|l
egészségügy|l
égöv|l
egri|l
égtáj|l
egyen|j
egyén|j
egyenesszög|l
egyenlőségjel|l
egyház|l
egyiptomi|l
egysejtű|l
együgyű|l
éhbél|f:éhbel
éhkopp|j
éhség|h:f
éhségsztrájk|j
éjfél|j
ejj|l
ékcsont|j
ekecsont|j
elefánt|j
elefántcsonttorony|f:elefántcsonttorny
elég|s:eleg
elégtelen|j
elektrokardiogram|j
elektron|j
elektronvolt|j
elektrosokk|j
élelem|f:élelm
élelmiszer-kereskedelem|f:élelmiszer-kereskedelm
élelmiszerbolt|j
élés|h:f
élesztőpehely|f:élesztőpelyh
életcél|h:b
életfogytiglan|j
életszínvonal|l
élettárs|l
élettér|s:életter
életút|s:életut
elhunyt|l,j
elipszilon|j
elixír|j
ell|l,j
ellenfél|s:ellenfel
ellenforradalom|l,f:ellenforradalm
ellenméreg|f:ellenmérg
ellenzéki|l
ellipszilon|j
elnökjelölt|l
előadóterem|f:előadóterm
előd|j
élőfej|l
előjel|l
élőláb|l
előtér|s:előter
elsőbb|l
élünk|l
elvtárs|l
elly|l
email|j
emberkereskedelem|f:emberkereskedelm
emelőrúd|s:emelőrud
emeszai|l
emésztőgödör|f:emésztőgödr
emlékmű|l,f:emlékműv
emlékoldal|lp
emléktárgy|l
emm|j
emotikon|j
én|j
énekesmadár|s:énekesmadar
energiaigény|lp,h:f
engedelem|f:engedelm
enn|l,j
enny|l,j
epehólyag|j
epekő|l,f:epeköv
eper|f:epr
eperfagylalt|j
építés|h:f
epizód|j
epszilon|j
ér|f:er
érc|h:f
erdélyi|l
erdőtűz|s:erdőtüz
érem|f:érm
érés|h:f
érettségizett|j
érinthetetlen|j
erőd|j
erőmű|l,f:erőműv
err|l,j
érték|h:f
értéktárgy|l
értelem|f:értelm
értés|h:f
érzék|h:f
érzelem|f:érzelm
esküdt|l,j
esőcsepp|j
esőkabát|j
esővíz|s:esőviz
ess|l
est|j
ész|s:esz
észak-afrikai|l
észak|j
északi|l
északkelet|j
eszcájg|j
eszköztár|l
essz|l
észt|j
eszünk|l
etanol|j
étek|f:étk
etikett|j
etióp|j
étlap|j
étterem|f:étterm
étvágy|l
eunuch|j
eurázsiai|l
európai|l
évad|j
evet|j
évfolyamtárs|l
évkönyv|l
evőkanál|s:evőkanal
exférj|l
export|j
exporttilalom|l,f:exporttilalm
ezán|j
ezer|f:ezr
ezerszög|l
ezüst|j
ezüstérem|f:ezüstérm
ezüstlakodalom|l,f:ezüstlakodalm
f-moll|j
faág|l
fácán|j
facsavar|j
fád|l
faeper|f:faepr
fagott|j
fagyal|j
fagylalt|j
fahéj|l
fahíd|s:fahid
fajd|j
fájdalom|l,f:fájdalm
fájdalomdíj|l
fájl|j
fájlnév|s:fájlnev,h:f
fakanál|s:fakanal
fakír|j
fáklyafény|lp,h:f
fal|l
falam|l
falatok|l
falcsont|j
falevél|s:falevel
faló|l,f:falov
faluk|l
falunk|l
falusi|l
fám|l
fánk|j
farész|lp,h:f
fark|l
farkaséhség|l,h:f
farkaskölyök|f:farkaskölyk
farm|j
farmernadrág|j
farok|l,f:fark
farokcsont|j
fasírt|j
faszén|s:faszen,h:f
faszfej|l
fatörzs|l
favorit|j
fazék|s:fazek
február|j
fedél|s:fedel
fegyelem|f:fegyelm
fegyvertárs|l
fehér|l
fehérarany|l
fehérjetartalom|l,f:fehérjetartalm
fehérvérsejt|j
fej|l
fejedelem|f:fejedelm
fejescsont|j
fejőstehén|s:fejőstehen
fejünk|l
fék|h:f
fékpedál|j
fekvőhely|l
fél|s:fel
féldrágakő|l,f:féldrágaköv
félelem|f:félelm
féleszű|l
félgömb|j
felhám|j
felhasználónév|s:felhasználónev,h:f
félhold|l,j
felhúzókötél|s:felhúzókötel
félidézőjel|l
felkar|j
felkarcsont|j
felkiáltójel|l
félkvirt|j
felnőtt|l,j
feloldójel|l
félsík|h:b
felsőház|l
félsz|l
felvonóhíd|s:felvonóhid
fém|h:f
fémháromszög|l
fémszál|l
fen|j
fenék|s:fenek
fenevad|l
fennsík|la,j,h:b
fenti|l
fény|h:f
fénycső|l,f:fénycsöv
fénykard|j
fényreklám|j
fényrúd|s:fényrud
fénysugár|s:fénysugar
féreg|f:férg
férfi|l
férfinév|s:férfinev
férj|l
feromon|j
feröeri|l
fészek|f:fészk
fesztivál|j
fi|l,h:b
fiad|l
fiam|l
fiastyúk|j
fiatal|j
figyelem|f:figyelm
filantróp|j
filctoll|l
film|j
filmszínház|l
fing|la,j,h:b
finn|l,j
fiók|j
fiuk|l
fiunk|l
fjord|j
flakon|j
flamand|j
fluorit|j
fodor|f:fodr
fodrászszalon|j
fog|l
fogad|l
fogadalom|l,f:fogadalm
fogalom|l,f:fogalm
fogaskerék|s:fogaskerek
fogatok|l
fogkrém|l,j,h:f
foglalkoztatott|l,j
foglyuk|l
fogmeder|f:fogmedr
fogoly|f:fogly
fogselyem|f:fogselym
fogunk|l
fogvatartott|l
fogyasztóvédelem|f:fogyasztóvédelm
foggyökér|s:foggyöker
fokhagymaprés|lp,h:f
fokom|l
fóliasátor|s:fóliasátr
folklór|j
folpack|j
folsav|l
folt|j
folyómeder|f:folyómedr
folyópart|j
folyóvíz|s:folyóviz,h:f
fón|j
fonal|l
fonál|s:fonal
font|j
forgalom|l,f:forgalm
forgatókönyv|l
forgólant|j
forgószék|l,h:f
forgószél|s:forgószel,h:f
forint|j
formatál|l
forradalom|l,f:forradalm
forráskód|j
forrásvíz|s:forrásviz,h:f
fotóblog|j
fotogram|j
foton|j
fotoszintézis|lp,h:f
foxtrott|j
főd|l
föl|l
föld|l,j
földesúr|s:földesur
földieper|f:földiepr
földkéreg|f:földkérg
földszint|j
földút|s:földut
főn|j
főnév|s:főnev
föníciai|l
főnixmadár|s:főnixmadar
főoldal|lp
főpap|j
főtér|s:főter
főút|s:főut
fővárosi|l
főzőkanál|s:főzőkanal
franciaágy|l
friss|l
friuli|l
front|j
funkcionál|j
furgon|j
fúrófej|l
fúrógép|l,h:f
fúrólyuk|l
fuser|j
futómű|l,f:futóműv
futópad|j
futószalag|j
futószár|l
futótűz|s:futótüz
fuvalom|l,f:fuvalm
fű|l,f:füv
függőágy|l
függőhíd|s:függőhid,h:b
függőkosár|s:függőkosar
fül|l
fülcsepp|j
fülesbagoly|f:fülesbagly
fültő|l,f:fültöv
fülzsír|h:b
fürdőkád|l,j
fűrészmalom|f:fűrészmalm
fürj|l
fürt|j
füst|j
fűz|s:füz
gabonapehely|f:gabonapelyh
gácsér|j
gael|j
galamb|j
galandféreg|f:galandférg
gall|j
gallér|j
gályarab|j
gally|l
gambiai|l
gametofiton|j
gang|j
gardrób|j
garnélarák|j
gát|l,j
gél|j
gém|h:f
gémeskút|s:gémeskut
gemkapocs|f:gemkapcs
gén|j
genfi|l
genom|j
genny|l
gép|h:f
gepárd|j
gépgyár|l
gépjármű|l,f:gépjárműv
gerezd|j
ghánai|l
ginzeng|j
gipsz|l
gipszkarton|j
gitár|j
glutamin|j
gól|j
golf|j
gólyahír|lp,h:f
gólyaláb|l
golyóscsapágy|l
golyóstoll|l
gomb|j
gomblyuk|l
gond|j
gondolatjel|l
gondozott|l,j
górcső|l,f:górcsöv
gordon|j
gödi|l
gödör|f:gödr
gőg|j
gömb|j
görög|j
gráf|j
grafikon|j
gramm|j
gránit|j
gregorián|j
griff|j
griffmadár|s:griffmadar
gróf|j
guatemalai|l
gubacsdarázs|s:gubacsdarazs
gudzsaráti|l
gumicsónak|j
gúnár|j
gúnynév|s:gúnynev,h:f
gurum|l
gyalog|j
gyalogátkelőhely|l
gyám|j
gyanúsított|l,j
gyapot|j
gyár|l
gyarmatbirodalom|l,f:gyarmatbirodalm
gyémánt|j
gyermekláncfű|l,f:gyermekláncfüv
gyermekvédelem|f:gyermekvédelm
gyertyán|j
gyík|j
gyógyfű|l,f:gyógyfüv
gyógyír|j
gyógyszerkönyv|l
gyógyszertár|l
gyógyvíz|s:gyógyviz,h:f
gyom|j
gyomor|f:gyomr
gyomorégés|lp,h:f
gyomorhurut|j
gyorsétterem|f:gyorsétterm
gyorsítótár|l
gyökér|s:gyöker
gyökérkönyvtár|l
gyöngybagoly|f:gyöngybagly
gyöngyház|l
gyöngytyúk|j
gyötrelem|f:gyötrelm
győzelem|f:győzelm
gyufagyár|l
gyufaszál|l
gyűjtőér|f:gyűjtőer
gyűjtőnév|s:gyűjtőnev
gyümölcscukor|f:gyümölcscukr
gyümölcskosár|s:gyümölcskosar
gyümölcslé|s:gyümölcslev
gyűrűsujj|l
hab|j
habcsók|j
habkő|l,f:habköv
had|l
hadifogoly|f:hadifogly
hadúr|s:hadur
haj|l
háj|l
hajad|l
hajam|l
hajcsár|j
hajcsat|j
hajdísz|lp,h:f
hajék|l,h:f
hajfény|lp,h:f
hajfodor|f:hajfodr
hajfürt|j
hajgyökér|s:hajgyöker
hajhab|j
hajlakk|j
hajléktalan|j
hajlítóizom|f:hajlítóizm
hajótörött|l,j
hajszál|l
hajszalag|j
hajszálcső|l,f:hajszálcsöv
hajszálér|f:hajszáler,h:f
hajszín|lp,h:f
hajtincs|l,h:f
hal|l
halad|l
halálfej|l
halálhír|lp,h:f
halálraítélt|l,h:f
halántékcsont|j
halántékizom|f:halántékizm
hálapénz|lp,h:f
halászbagoly|f:halászbagly
halászlé|l,h:f
halásznadrág|j
halásznyest|j
halhatatlan|j
hall|j
hallé|l,h:f
halljuk|l
hallod|l
hallom|l
hallotok|l
halloween|j
hallucinogén|lp,h:f
hallunk|l
halogén|lp,j,h:f
hálóing|l,h:f
halom|f:halm
halott|l,j
halottkém|l,h:f
hálózsák|j
halpénz|lp,h:f
haltál|l
halunk|l
hályog|j
hám|j
hamag|j
hamszin|j
hamv|l
hamvad|l
háncsrész|lp,h:f
handzsár|j
hang|j
hangár|j
hangfal|l
hangosfilm|l,j,h:f
hangoskönyv|l
hangtál|l
hangulatjel|l
hangulatkép|l,h:f
hangversenyterem|f:hangversenyterm
hangyasav|l
hangyászsün|j
hant|j
hantmadár|s:hantmadar
harag|j
harang|j
harangtorony|f:harangtorny
harcoshal|l
hárem|j
harmatcsepp|j
hármatok|l
harminc|l
harmincharmadik|l
harminchárom|l,f:harminchárm
harminchét|s:harminchet,h:f
harmincnégy|l,h:f
harmincnyolc|l
harmincnyolcadik|l
harmincszög|l
hármójuk|l
hármónk|l
hármótok|l
hármuk|l
hármunk|l
három|l,f:hárm
háromszáz|l
háromszög|l
hárs|l
has|l
hasáb|j
hasad|l
hashtag|l,j,h:f
hasnyál|l
hasnyálmirigy|l,h:f
haszon|f:haszn
haszontalan|j
hát|l
hatalom|l,f:hatalm
határátkelőhely|l
határérték|l,h:f
hátfal|l
hátizsák|j
hatszög|l
háttér|s:hátter,h:f
hatvanharmadik|l
haver|la,j,h:b
ház|l
hazafi|l
házastárs|l
házépítés|lp,h:f
házinyúl|s:házinyul
házityúk|j
háztűz|s:háztüz
hazug|j
házsárt|j
hegyesszög|l
héj|l
hektár|j
hely|l
helyár|l
helybeli|l
helyesség|f:hhelyesség
helyezett|j
helységnév|s:helységnev
hem|j
hering|j
hermelin|j
hernyótalp|l
hét|s:het
hetilap|j
hétjük|l
hétköznap|j
hétszög|l
hetük|l
hetünk|l
hév|s:hev
hexán|j
hexánsav|l
híd|s:hid
hidrát|j
hidrogén|lp,j,h:f
hidrolízis|lp,h:f
hidroplán|j
hidzsáb|j
hiedelem|f:hiedelm
hígagyú|l
hígeszű|l
hígvelejű|l
hím|j
himlőhely|l
hintaszék|l,h:f
hipokotil|j
hipotézis|lp,h:f
hír|h:f
hírlap|j
hírlevél|s:hírlevel
hírnév|s:hírnev
hitellevél|s:hitellevel
hó|l,f:hav
hóbagoly|f:hóbagly
hobbit|j
hobbitok|l
hód|j
hófajd|j
hógömb|j
hogylét|l,h:f
hókócsag|j
hólapát|j
hold|l,j
holdascsont|j
holdfény|lp,h:f
holdkő|l,f:holdköv
holdnaptár|l
holdsugár|s:holdsugar
holdtérkép|l,h:f
holland|j
hollandiai|l
hollét|l,h:f
holnap|j
holnapután|j
holt|lp
holtpont|j
holttér|s:holtter,h:f
hólyag|j
homár|j
hombár|j
homlokcsont|j
homlokszíj|l
homok|j
homokkő|l,f:homokköv
homokvár|l
homorúszög|l
homszi|l
hónalj|l
hónap|j
hondurasi|l
honfitárs|l
honvágy|l
honvéd|l,j,h:f
honvédelem|f:honvédelm
honvédség|l,h:f
hópehely|f:hópelyh
hordágy|l
hordár|j
horgascsont|j
horizont|j
hormon|j
hormonkészítmény|lp,h:f
horog|f:horg
horogkereszt|j
horoszkóp|j
horrorfilm|l,h:f
horvát|j
hossz|l
hosszúlépés|lp,h:f
hotel|j
hozzáértés|lp,h:f
hozzáférés|lp,h:f
hölgy|l
húgycső|l,f:húgycsöv
húgyhólyag|j
húgysav|l
huligán|j
hullaház|l
hullámvasút|s:hullámvasut
humbug|j
humorérzék|l,h:f
humoreszk|j
hun|j
hungarocell|j
húr|j
hurok|f:hurk
hurrikán|j
hurut|j
husáng|j
húslé|l,h:f
húsvét|j
húsz|l
huszár|j
huszonharmadik|l
huszonhárom|l,f:huszonhárm
huszonhét|s:huszonhet,h:f
huszonnégy|l,h:f
huszonöt|j
huszonnyolc|l
huszonnyolcadik|l
húszszög|l
huzal|j
hüvelyk|j
hüvelykujj|l
idegen|j
idegenforgalom|l,f:idegenforgalm
idétlen|j
idézőjel|l
időpont|j
időrend|j
igaz|l
igazolványkép|l,h:f
igazságügy|l
igemód|j
igen|j
igenév|s:igenev
igény|h:f
íj|l
ijedelem|f:ijedelm
iker|f:ikr
ikon|j
iksz|l
illatszerbolt|j
illemhely|l
imád|l
imádott|l
imakönyv|l
imám|j
imamalom|f:imamalm
import|j
ín|lp,j,h:f
indiai|l
indíték|h:b
indonéz|lp,h:f
ing|h:f
integrál|j
intelem|f:intelm
intenzív|j
internetprotokoll|j
inverz|l
inzulin|j
iparág|l
iparvidék|l,h:f
ipszilon|j
irányár|l
írásjel|l
írásmű|l,f:írásműv
írástudatlan|j
iratkapocs|f:iratkapcs
irgalom|l,f:irgalm
írjuk|l
írod|l
irodalom|l,f:irodalm
irodaszék|l,h:f
írógép|l,h:f
írom|l
irón|j
írótoll|l
írunk|l
ispán|j
iszap|j
ítéletnap|j
ivarmirigy|l,h:f
ívhíd|s:ívhid,h:b
ivókút|s:ivókut
ivor|j
ivóvíz|s:ivóviz,h:f
izgalom|l,f:izgalm
izlandi|l
izom|f:izm
izomláz|l
izoprén|lp,j,h:f
izotóp|j
jacht|j
jackpot|j
jáde|l,h:b
jak|j
janicsár|j
január|j
japán|j
járdalap|j
jarmulke|l,h:b
jármű|l,f:járműv
járműforgalom|l,f:járműforgalm
járom|f:járm
jártad|l
jártam|l
jártatok|l
jártuk|l
jártunk|l
jasmak|j
jatagán|j
játékbolt|j
játékfilm|l,j,h:f
játékszín|lp,h:f
játszótárs|l
játszótér|s:játszóter,h:f
javak|s:jav
jázmin|j
jég|s:jeg
jégcsap|j
jégkorong|j
jégmadár|s:jégmadar
jégszobor|f:jégszobr
jégtömb|j
jegybank|j
jegypénztár|lp
jegyzőkönyv|l
jelentéstartalom|l,f:jelentéstartalm
jeles|l
jellemnév|s:jellemnev
jelölt|l,j
jelszó|l,f:jelszav
jelzőtűz|s:jelzőtüz
jemeni|l
jen|j
jeremiád|j
jobb|lp,j
jobblét|l,h:f
jobboldal|l
jód|j
joghurt|j
jóginí|la,h:f
jogosult|l,j
jogsértés|lp,h:f
jogvédelem|f:jogvédelm
jólét|l,h:f
jón|j
jordán|j
jövedelem|f:jövedelm
jövendőbeli|l
jugoszláv|j
juharcukor|f:juharcukr
juharlevél|s:juharlevel
juharszirup|j
jussunk|l
jutalom|l,f:jutalm
jüan|j
jüt|j
kabasólyom|f:kabasólym
kabát|j
kabinet|j
kacat|j
kacor|j
kád|l,j
kádár|j
kaftán|j
kagylóhéj|l
kaik|j
kaikdzsi|la,h:f
kajak|j
kajszibarack|j
kakaóvaj|l
kakukk|j
kakukkfű|l,f:kakukkfüv
kaland|j
kalap|j
kalcit|j
kalcium-nitrid|l,h:f
kaleidoszkóp|j
kaliforniai|l
kalpag|j
kamatláb|l
kaméleon|j
kamelot|j
kámfor|j
kamion|j
kan|j
kán|j
kanadai|l
kanál|s:kanal
kanalasgém|l,h:f
kanárimadár|s:kanárimadar
kancellár|j
kandúr|j
kankalin|j
kánkán|j
kantár|j
kantárszár|l
kantin|j
kanton|j
kanyon|j
kapocs|f:kapcs
kapor|f:kapr
kaposvári|l
kappan|j
kapronsav|l
kapualj|l
kapudrog|j
kapunk|l
karácsonyéj|lp,h:f
karácsonyest|j
karácsonyfadísz|lp,h:f
karambol|j
karamell|j
karantén|j
karát|j
karaván|j
kard|j
kardhal|l
kardigán|j
karfiol|j
karib|j
karing|l,h:f
karizom|f:karizm
karlyuk|l
kármin|j
karom|f:karm
károsult|l
karosszék|l,h:f
karszt|j
kartárs|l
kártérítés|lp,h:f
karton|j
karvalybagoly|f:karvalybagly
kaskavál|j
kasmír|j
kaszab|j
kaszt|j
katalán|j
katari|l
katicabogár|s:katicabogar
katlan|j
katódsugár|s:katódsugar
katódsugárcső|l,f:katódsugárcsöv
katonatiszt|l,j,h:f
kávébab|j
kávéház|l
kaviár|j
kazal|j
kazán|j
kazánház|l
kebel|f:kebl
kecskefűz|s:kecskefüz
kecskeszakáll|l
kedd|j
kedvezményezett|j
kefehaj|l
kefir|j
kegyelem|f:kegyelm
kehely|f:kelyh
kéjvágy|l
kék|j
keksz|l
kel|j
kelet-afrikai|l
kelet-délkelet|j
kelvin|j
kém|h:f
kémcső|l,f:kémcsöv
keményítőtartalom|l,f:keményítőtartalm
keménykalap|j
kemping|j
kémprogram|j
kén|j
kénkő|l,f:kénköv
kenőolaj|l
kénsav|l
kentaur|j
kénüszök|f:kénüszk
kényelem|f:kényelm
kenyér|s:kenyer
kenyérkosár|s:kenyérkosar
kép|h:f
képeskönyv|l
képeslap|j
képjel|l
képtár|l
képviselőház|l
képviselőjelölt|l
képzés|h:f
kérdezett|j
kérdőjel|l
kerecsensólyom|f:kerecsensólym
kéreg|f:kérg
kerék|s:kerek
kerékagy|l
kerékpár|j
kerékpáralkatrész|lp,h:f
kérelem|f:kérelm
kereskedelem|f:kereskedelm
keresőmotor|j
kereszt|j
keresztcsont|j
keresztespók|j
keresztlevél|s:keresztlevel
keresztnév|s:keresztnev
kereszttűz|s:kereszttüz
kerozin|j
kert|j
kés|h:f
késedelem|f:késedelm
késünk|l
készítmény|h:f
kétéltű|l
kétszáz|l
kétszázhúsz|l
kétszersült|l
kettejük|l
kettőjük|l
kettőnk|l
kettőspont|j
kettőtök|l
kéz|s:kez
kézfej|l
kézigránát|j
kézikönyv|l
kéziszótár|l
kézközép|s:kézközep
kézközépcsont|j
kéztő|l,f:kéztöv
kéztőcsont|j
kígyóméreg|f:kígyómérg
kilátótorony|f:kilátótorny
kilencven|l
kilencszög|l
kilogramm|j
kimenetoldal|lp
kín|j
kínai|l
kincs|h:f
kincstár|l
kioszk|j
királykék|l,j,h:f
kisagy|l
kisbolygóöv|l
kisfilm|j
kiskereskedelem|f:kiskereskedelm
kiskorú|l
kisujj|l
kisvak|j
kisvasút|s:kisvasut
kisszótár|l
kitartott|l,j
kiválasztott|l,j
kívánalom|l,f:kívánalm
kívánságod|l
klán|j
klarinét|j
klikk|j
klip|j
klór|j
kloroform|j
klub|j
koan|j
kobalt|j
kobaltkék|l,j,h:f
kobold|j
koboz|f:kobz
kockacukor|f:kockacukr
kockahas|l
kócsag|j
kocsiszín|lp,h:f
kód|j
koffein|j
koh|j
kojot|j
kokain|j
koktél|j
kókuszbél|f:kókuszbel,h:f
kókuszliszt|l,j,h:f
kókusztej|l
kókuszvíz|s:kókuszviz,h:f
kolesz|h:b
koleszterin|j
kolomp|j
kombájn|j
komment|j
kommentár|j
komp|j
kompliment|j
kompót|j
komputerközpont|j
koncert|j
koncertterem|f:koncertterm
kondenzcsík|h:b
konditerem|f:konditerm
kongói|l
konjugált|l,j
konkurens|l
konszern|j
kontakt|j
kontinuumhipotézis|lp,h:f
kontrafék|l,h:f
kontroll|j
konzervatív|j
konzervgyár|l
konzol|j
konzul|j
konyak|j
konyhaszék|l,h:f
kopt|j
kór|j
koraszülött|l,j
kordován|j
koreai|l
kórház|l
kormánykerék|s:kormánykerek
kormánypárt|j
kormorán|j
kornett|j
korom|f:korm
korong|j
kortárs|l
kórterem|f:kórterm
korund|j
kosár|s:kosar
kosztüm|j
kotangens|l
kotlóstyúk|j
kő|l,f:köv
köbcsont|j
köböl|f:köbl
kőhíd|s:kőhid,h:b
köldökzsinór|j
kölnivíz|s:kölniviz
kölök|f:kölk
kölyök|f:kölyk
kőműveskanál|s:kőműveskanal
könny|l
könnycsepp|j
könnycsont|j
könyv|l
könyvesbolt|j
könyvklub|j
könyvtár|l
kőpad|j
kőr|j
környezetvédelem|f:környezetvédelm
köröm|f:körm
körömágy|l
körömlakk|j
körözött|l
körszínház|l
körtér|s:körter
körút|s:körut
körük|l
körvonal|l
kötél|s:kötel
kötelem|f:kötelm
kötelezett|j
kötésszög|l
kötőjel|l
közalkalmazott|l,j
közegészségügy|l
közelebbi|l
közelmúlt|l
közép-afrikai|l
közép-ázsiai|l
közép-európai|l
közép|f:közep
középfül|l
középhatalom|l,f:középhatalm
középpont|j
középszint|j
közért|j
közhely|l
közjó|s:közjav
közkönyvtár|l
közkút|s:közkut
köznév|s:köznev
központ|j
krajcár|j
krapek|la,j,h:b
kredit|j
krém|j
krikett|j
krill|j
krinolin|j
kripton|j
kristálycukor|f:kristálycukr
krizantém|j
krokodil|j
krokodilkönny|l
króm|j
krumplibogár|s:krumplibogar
krumplicukor|f:krumplicukr
krumpliszirom|f:krumpliszirm
krupié|l,h:f
kubai|l
kuglóf|j
kujon|j
kukoricacső|l,f:kukoricacsöv
kulák|j
kulcscsont|j
kulcslyuk|l
kulcsszó|s:kulcsszav
kultfilm|l,h:f
kultuszfilm|l,h:f
kun|j
kuncsaft|j
kunsztstükk|j
kúp|j
kupak|j
kurd|j
kút|s:kut
kutad|l
kútház|l
kútvíz|s:kútviz,h:f
kutyakölyök|f:kutyakölyk
kutyaszán|j
küldött|l
külföld|l,j
külföldi|l
külkereskedelem|f:külkereskedelm
különnyugdíj|l
kültér|s:külter
külügy|l
kürt|j
küzdelem|f:küzdelm
küzdőtér|s:küzdőter
kvark|j
kvartett|j
kvint|j
kvirt|j
kvíz|h:f
láb|l
lábad|l
lábbilincs|l,h:f
lábfej|l
lábközép|s:lábközep
lábközépcsont|j
lábléc|l,h:f
labor|j
lábszár|l
lábtő|l,f:lábtöv
lábtőcsont|j
lábujj|l
ladik|j
lágyéksérv|l,h:f
lajdinánt|j
lajhár|j
lajt|j
lakat|j
lakbér|lp,h:f
lakcím|l,h:f
lakhely|l
lakk|j
lakmuszpapír|j
lakodalom|l,f:lakodalm
lakóház|l
lakóhely|l
lakom|l
lakótárs|l
lámpafény|lp,h:f
lámpaláz|l
lampion|j
lánchíd|s:lánchid
lánctalp|l
láng|j
lángész|s:lángesz,h:f
lant|j
lantán|j
lap|j
láp|j
laparoszkóp|j
lapát|j
lapockacsont|j
laposféreg|f:laposférg
lapp|j
laptop|j
lat|j
látássérült|l,j
latin|j
látószög|l
latyak|j
laurinsav|l
láz|l
lázad|l
lé|s:lev
léc|h:f
leckekönyv|l
lég|h:f
leg|j
léggömb|j
légszomj|l
légtér|s:légter
légy|s:legy
légyott|j
legyünk|l
lék|h:f
lekötelezett|j
lekvár|j
lélek|f:lelk
lelőhely|l
len|j
lencsecsont|j
lenvászon|l,f:lenvászn
leopárd|j
lépcsőház|l
lepel|f:lepl
lepényhal|l
lépés|h:f
léptek|s:lépt
lépünk|l
lét|h:f
letét|j
lett|j
levél|s:level
levélbogár|s:levélbogar
levélszemét|s:levélszemet
levéltár|l
lián|j
libanoni|l
lift|j
lignin|j
lik|l,h:b
likad|l
likőr|j
limit|j
limuzin|j
link|j
liszt|j
lítium-nitrid|l,h:f
litván|j
lív|h:f
lizergsav-dietilamid|j
lizin|j
ló|l,f:lov
lob|j
locsolócső|l,f:locsolócsöv
lódarázs|s:lódarazs
lófarok|l,f:lófark
logarléc|l,h:f
lóhát|l
lom|j
lomb|j
lombik|j
lombikbébi|la,h:f
lopótök|j
lord|j
lornyon|j
lovag|j
lovassport|j
lőszerraktár|lp
lövészárok|f:lövészárk
lucfajd|j
lucsok|f:lucsk
lúd|s:lud
lúdláb|l
lúg|j
luk|l
lump|j
luxemburgi|l
lyuk|l
lyukad|l
macedón|j
macskabagoly|f:macskabagly
macskagyökér|s:macskagyöker
macskakő|l,f:macskaköv
macskaköröm|f:macskakörm
madám|j
madár|s:madar
madrigál|j
madzag|j
madzsong|j
mag|j
magáncég|l,h:f
magánügy|l
magazin|j
magház|l
magnetofon|j
magtár|l
magzatburok|f:magzatburk
magyal|j
magyar|j
magyarországi|l
máj|l
májkapugyűjtőér|f:májkapugyűjtőer
majom|f:majm
majonéz|lp,h:f
major|j
mák|j
makett|j
makimajom|f:makimajm
makk|j
malátacukor|f:malátacukr
malom|f:malm
malomkő|l,f:malomköv
máltai|l
mályvacukor|f:mályvacukr
mameluk|j
mammut|j
mamut|j
mandarin|j
mandulakrém|l,h:f
mandulaolaj|l
mandulatej|l
mandulavaj|l
mandzsettagomb|j
mangán|j
mángold|j
manikűr|j
manzárd|j
mar|j
maraton|j
marcipán|j
margarin|j
marhasült|l,j
marionett|j
marketing|j
markom|l
marógép|l,h:f
marok|f:mark
maroken|j
marokkói|l
marsall|j
mártír|j
masamód|j
másfél|s:másfel,h:f
maszk|j
matek|h:b
mauritániai|l
máz|l
medencecsont|j
meder|f:medr
médiabirodalom|l,f:médiabirodalm
medvecukor|f:medvecukr
medvetalp|l
megállóhely|l
megapixel|j
megbízott|l,j
megkérdezett|j
megszállott|l,j
méh|h:f
méhkenyér|s:méhkenyer
melegágy|l
melegház|l
melegítőnadrág|j
melír|la,j,h:b
mell|l
mellcsont|j
mellékjel|l
melléknév|s:melléknev
mellékpajzsmirigy|l,h:f
mellékszög|l
mellékvesekéreg|f:mellékvesekérg
melly|l
mélypont|j
membrán|j
memoár|j
mén|j
menedékhely|l
menedékjog|f:hmenedékjog
menedzsment|j
menekült|l,j
menetlevél|s:menetlevel
menetrend|j
menhely|l
mentőcsónak|j
mentőöv|l
meny|l
menyét|j
menny|l
méreg|f:mérg
mérföld|l,j
mérföldkő|l,f:mérföldköv
merőkanál|s:merőkanal
mérőszalag|j
mersz|l
mesekönyv|l
mestermű|l,f:mesterműv
mész|s:mesz
mészárszék|l,h:f
mészkő|l,f:mészköv
metál|j
metán|j
metanol|j
meteor|j
metropolisztérség|l,h:f
metszőfog|l
mexikói|l
méz|l
mézeshetek|s:mézeshet
migrén|j
mikrofilm|l,j,h:f
mikrofon|j
mikrofonláz|l
mikroszkóp|j
milliárd|j
minaret|j
mindennap|j
mindhárom|l,f:mindhárm
miniatűr|j
minimálbér|lp,h:f
mínuszjel|l
mirigy|h:f
mispóche|l,h:b
misztrál|j
mizantróp|j
mobil|j
mobiltelefon|j
mocsár|s:mocsar
mocsok|f:mocsk
mód|j
modell|j
módosítójel|l
modul|j
mogul|j
mogyorókrém|l,h:f
mogyoróvaj|l
mohamedán|j
mohar|j
moholy|f:molyh
mokaszin|j
mokkacukor|f:mokkacukr
mókuskerék|s:mókuskerek
mól|j
molibdén|lp,h:f
moll|j
monacói|l
mondatrész|lp,h:f
mongol|j
monszun|j
mór|j
morfin|j
mosogatógép|l,h:f
mosógép|l,h:f
mostani|l
moszkvai|l
motor|j
motorbicikli|la,h:f
motorcsónak|j
motorkerékpár|j
motorolaj|l
mozaik|j
mozaikcsalád|j
mozambiki|l
mózeskosár|s:mózeskosar
mozgalom|l,f:mozgalm
mozgáskorlátozott|l
mozgássérült|l
mozgástér|s:mozgáster,h:f
mozgókép|l,h:f
mozgóképszínház|l
mozifilm|l,h:f
mozivászon|l,f:mozivászn
mozsár|s:mozsar
muff|j
muhar|j
múlt|l,j
munkaalkalom|l,f:munkaalkalm
munkabér|lp,h:f
munkagép|l,h:f
munkahely|l
munkahét|s:munkahet,h:f
munkanélküli|l
munkatárs|l
munkavédelem|f:munkavédelm
munkavégzés|lp,h:f
murok|f:murk
musical|lp,j,h:f
must|j
mustár|j
muszlim|j
muszlin|j
mutatóujj|l
muzulmán|j
műemlékvédelem|s:műemlékvédelm
müezzin|j
műfog|l
műhold|l,j
műjég|s:műjeg
műkő|l,f:műköv
műkönny|l
műköröm|f:műkörm
müncheni|l
műselyem|f:műselym
műszak|j
műszerfal|l
műtárgy|l
műterem|f:műterm
műút|s:műut
nábob|j
nád|l,j
nadálytő|l,f:nadálytöv
nádcukor|f:nádcukr
nadrág|j
nadrágszíj|l
nagy|j
nagyanyám|l
nagybáty|j
nagydíj|l
nagygép|l,h:f
nagyhatalom|l,f:nagyhatalm
nagyhét|s:nagyhet,h:f
nagyítógép|l,h:f
nagykabát|j
nagykerár|l
nagykereskedelem|f:nagykereskedelm
nagynéni|la,h:f
nagyszombat|j
nagyszótár|l
nagyterem|f:nagyterm
nagyujj|l
namíbiai|l
nap|j
naperőmű|l,f:naperőműv
napfény|lp,h:f
naphal|l
napilap|j
napirend|j
napsugár|s:napsugar
napszél|s:napszel,h:f
naptár|l
naptej|l
narancsdzsem|j
narancshéj|l
narancslé|s:narancslev,h:f
narvál|j
naszád|j
nászút|s:nászut
negatív|j
négy|h:f
négylábú|l
négyőjük|l
négyőtök|l
négyszög|l
négyük|l
négyünk|l
negyvenharmadik|l
negyvenhárom|l,f:negyvenhárm
negyvenhatodik|l
negyvenhét|s:negyvenhet
negyvenszög|l
negyvennyolc|l
negyvennyolcadik|l
nehéz|s:nehez
nejlon|j
nekrológ|j
némafilm|l,j,h:f
néni|h:f
neon|j
neonreklám|j
nép|h:f
nepáli|l
neutron|j
név|s:nev
névnap|j
névtér|s:névter
névutómelléknév|s:névutómelléknev
nézés|h:f
nézőtér|s:nézőter
nicaraguai|l
nikáb|j
nikotin|j
nikotintartalom|l,f:nikotintartalm
nímand|j
nincstelen|j
nitrid|h:f
nitrogén|lp,h:f
nomád|j
nonstop|j
norvég|j
norvégiai|l
nőmozgalom|l,f:nőmozgalm
nukleinsav|l
nulladik|l
nullhipotézis|lp,h:f
nyáj|l
nyák|j
nyak|l
nyakfodor|f:nyakfodr
nyakörv|l
nyaksál|l,j
nyakszirt|l,j,h:f
nyakszirtcsont|j
nyál|l
nyálmirigy|l,h:f
nyár|s:nyar
nyárs|l
nyél|s:nyel
nyelőcső|l,f:nyelőcsöv
nyelünk|l
nyelvcsont|j
nyelvkönyv|l
nyereg|f:nyerg
nyeregalátét|l,h:f
nyest|j
nyíl|s:nyil
nyilvánosház|l
nyíregyházi|l
nyírfajd|j
nyirok|f:nyirk
nyirokér|f:nyiroker,h:f
nyolc|l
nyolcszög|l
nyombél|f:nyombel,h:f
nyomdagép|l,h:f
nyomod|l
nyomom|l
nyomunk|l
nyugágy|l
nyugalom|l,f:nyugalm
nyugat-afrikai|l
nyugat-ázsiai|l
nyugat-európai|l
nyugdíj|l
nyúl|s:nyul
nyúltagy|l
nyuszt|j
nyűg|j
obeliszk|j
obszidián|j
óceán|j
óceánfenék|s:óceánfenek
óceánpart|j
ocelot|j
ócskavas|l
odaliszk|j
óév|l,h:f
ógörög|j
óír|lp,j,h:f
oklevél|s:oklevel
ókori|l
okostelefon|j
ól|l,j
olaj|l
olajkút|s:olajkut
olajsav|l
oldal|l
oldalág|l
olívaolaj|l
ólom|f:ólm
oltalom|l,f:oltalm
oltógyomor|f:oltógyomr
olvasóterem|f:olvasóterm
omikron|j
omlett|j
ón|j
opál|j
operaház|l
órabér|lp,h:f
óralap|j
óramű|l,f:óraműv
orangután|j
orgonabokor|f:orgonabokr
óriáskerék|s:óriáskerek
orkán|j
orom|f:orm
oroszlán|j
oroszlánrész|lp,h:f
orrcsont|j
orrlyuk|l
orrnyereg|f:orrnyerg
orrszarv|l
orrszíj|l
orrvérzés|lp,h:f
orsócsont|j
országút|s:országut
oslói|l
ostromzár|l
oszét|j
oszloprend|j
oszmán|j
osztályrész|lp,h:f
osztálytárs|l
osztályterem|f:osztályterm
osztják|j
osztrák|j
otkolon|j
ottani|l
ottlét|l,h:f
ottomán|j
oxid|j
oxigén|lp,h:f
oxigénsátor|s:oxigénsátr
ózon|j
ózonlyuk|l
öböl|f:öbl
ököl|f:ökl
ökör|f:ökr
ökörnyál|l
öl|l
ölősejt|j
öltönynadrág|j
ölünk|l
ölyv|l
őn|j
önarckép|l,h:f
önbizalom|l,f:önbizalm
önfegyelem|f:önfegyelm
öntözőcső|l,f:öntözőcsöv
önuralom|l,f:önuralm
önvédelem|f:önvédelm
ördöghal|l
öreglyuk|l
őrgróf|j
őrhely|l
örökzöld|l,j
örömkönny|l
örömtűz|s:örömtüz
őrtorony|f:őrtorny
őrült|l,j
örv|l
ősmagyar|j
őssejt|j
őstulok|f:őstulk
őszibarack|j
összeadásjel|l
összhang|j
ösztöndíj|l,h:b
ösztrogén|lp,j,h:f
ötötök|l
ötszáz|l
ötszög|l
ötük|l
ötünk|l
ötven|l
ötvenharmadik|l
ötvennyolcadik|l
öv|l
őz|l
pad|j
padisah|j
padlizsán|j
padom|l
pajesz|h:b
pajzsmirigy|l,h:f
pajzsmirigyhormon|j
pakisztáni|l
paksi|l
palack|j
palást|j
palesztin|la,j,h:b
palid|l
palim|l
palimadár|s:palimadar
pálmaolaj|l
palotaforradalom|l,f:palotaforradalm
pamut|j
panamakalap|j
panaszkönyv|l
páncél|j
pandit|j
panel|j
panelház|l
pánik|j
panorámakép|l,h:f
pánsíp|j
pap|j
pápai|l
papír|j
papírkép|l,h:f
papírkosár|s:papírkosar
papírpénz|lp,h:f
papírpohár|s:papírpohar
paplan|j
papucsférj|l,h:f
pár|j
paralízis|lp,h:f
paraszt|j
parasztház|l
páratartalom|l,f:páratartalm
paratölgy|l
parázs|s:parazs
párbeszédjel|l
park|j
parkolóház|l
parkolóhely|l
parlag|j
parlament|j
parmezán|j
part|j
párt|j
partizán|j
pártprogram|j
partvonal|lp
pascal|j
passzátszél|s:passzátszel,h:f
paszternák|j
pasztinák|j
patak|j
patakpart|j
patakvíz|s:patakviz,h:f
patkányméreg|f:patkánymérg
patkóbél|f:patkóbel,h:f
patogén|lp,j,h:f
pauszpapír|j
pávián|j
pázsit|j
pecek|f:peck
pecsét|j
pedál|j
pedikűr|j
pehely|f:pelyh
pehelypaplan|j
pék|j
példakép|l,h:f
pelikán|j
pénz|h:f
pénztár|l
pénztárgép|l,h:f
pénzügy|l
pép|j
perm|j
peron|j
perui|l
pesti|l
pészah|j
petefészek|f:petefészk
petrezselyem|f:petrezselym
pezsgőspohár|s:pezsgőspohar
pézsmatök|j
pézsmatulok|f:pézsmatulk
piactér|s:piacter,h:f
pikk|j
piknik|j
piktogram|j
piláf|j
pingpong|j
pingvin|j
pintér|j
pinty|h:f
pionír|j
pír|la,j,h:b
pirit|j
piszok|f:piszk
pisztráng|j
piton|j
pitypang|j
pixel|j
plafon|j
pláne|l,h:b
platform|j
pletykafészek|f:pletykafészk
pletykalap|j
pocak|j
pocegér|s:poceger
pocok|f:pock
podcast|j
poén|j
pofaszíj|l
pogrom|j
pohár|s:pohar
poháralátét|l,h:f
pók|j
pokol|f:pokl
pokolgép|l,h:f
polaroid|j
polgármesterjelölt|l
polgártárs|l
poligon|j
poligráf|j
póling|j
polinom|j
polip|j
pólóing|l,h:f
polyák|j
póniló|l,f:pónilov
pont|j
ponton|j
pop|j
pór|j
porcelán|j
porcelánbolt|j
porcukor|f:porcukr
porfészek|f:porfészk
porhó|l,f:porhav
pornófilm|l,h:f
porod|l
porom|l
porond|j
port|j
portál|j
portok|j
portugál|j
postafiók|j
poszméh|l,h:f
pótalkatrész|lp,h:f
potenciál|j
pótkerék|s:pótkerek
pótszög|l
pozsonyi|l
pöcegödör|f:pöcegödr
pöcök|f:pöck
pörkölt|j
prém|j
premier|j
prérityúk|j
prés|h:f
pribék|j
priccsesnadrág|j
prím|j
prof|j
profil|j
profit|j
program|j
projekt|j
promenád|j
prostituált|l,j
protein|j
protokoll|j
proton|j
pszichoanalízis|lp,h:f
puff|j
pulid|l
pult|j
púp|j
puplin|j
pünkösd|j
püspökbot|j
rab|j
rabszolga-társadalom|l,f:rabszolga-társadalm
radír|j
rádzsput|j
ráf|j
rag|j
ragadványnév|s:ragadványnev,h:f
rágalom|l,f:rágalm
raglán|j
rágóizom|f:rágóizm
rajt|j
rajzfilm|l,h:f
rajzszén|s:rajzszen,h:f
rajzszög|l
rák|j
raklap|j
rakodópart|j
rakpart|j
raktár|lp
ramadán|j
rang|j
rap|j
recept|j
recésgyomor|f:recésgyomr
redőnyzár|l
reflektorfény|lp,h:f
reform|j
régi|l
regiment|j
rejtekhely|l
rejtelem|f:rejtelm
rejtjel|l
rekeszizom|f:rekeszizm
reklám|j
reklámprogram|j
rekord|j
rémálom|f:rémálm
remekmű|l,f:remekműv
remetelak|j
remeterák|j
rén|j
rend|j
rendház|l
rendszermag|j
répacukor|f:répacukr
repertoár|j
reptér|s:repter
repülőgépgyár|l
repülőtér|s:repülőter
repülőút|s:repülőut
rész|h:f
reszort|j
rét|j
retek|f:retk
rétesliszt|j
rétoromán|j
réz|s:rez
rezsim|j
ricinusolaj|l
rigai|l
ring|j
riport|j
rizsföld|l,j
rizsliszt|j
rizspehely|f:rizspelyh
robot|j
rock|j
ród|l
rollfilm|l,j,h:f
rom|j
román|j
rost|j
rostacsont|j
rossz|l
rotring|j
rovarcsípés|lp,h:f
rozmár|j
rozmaring|j
rózsaolaj|l
rózsaszín|lp,h:f
rozskenyér|s:rozskenyer
rozsomák|j
röntgen|j
rövidnadrág|j
rövidzár|l
rubel|j
rubin|j
rúd|s:rud
rudam|l
ruhatár|l
ruhaujj|l
rulett|j
rum|j
rutin|j
rügy|l
sablon|j
sáfár|j
sah|j
sajkacsont|j
sajt|j
sakál|j
sakk-matt|j
sakk|j
sál|l,j
sámán|j
sampinyon|j
sampon|j
sáncárok|f:sáncárk
sanzon|j
sár|s:sar
sarad|l
saram|l
sárgabarack|j
sárgaláz|l
sárgaréz|s:sárgarez,h:f
sarj|l
sarjad|l
sárkánygyökér|s:sárkánygyöker
sarok|f:sark
sarokcsont|j
sarokház|l
saruk|l
sarunk|l
sátán|j
sátor|s:sátr
sáv|j
sav|l
savad|l
savam|l
savtartalom|l,f:savtartalm
script|j
sebhely|l
séf|j
seggfej|l
segglyuk|l
segítőtárs|l
sejk|j
sejt|j
sejtelem|f:sejtelm
sejtfal|l
sejtközpont|j
sejtmag|j
sejtmembrán|j
selyem|f:selym
selyemcukor|f:selyemcukr
sérelem|f:sérelm
seriff|j
sértés|h:f
sertéscomb|j
sertészsír|la,j,h:b
sértett|j
sérült|l,j
sérv|h:f
sétabot|j
sezlon|j
sifonér|j
sík|la,j,h:b
siketfajd|j
síkfilm|j
sikk|j
siklóvasút|s:siklóvasut
sílift|j
sín|j
sing|j
singcsont|j
síp|la,j,h:b
sípcsont|j
sír|j
siralom|l,f:siralm
sírhely|l
sírkő|l,f:sírköv
sisak|j
sitt|j
skalp|j
skandináv|j
skanzen|j
skót|j
skótfajd|j
skótom|l
slejm|j
slepp|j
smaragd|j
smink|j
smokk|j
snidling|j
sofőr|j
sógun|j
sokadalom|l,f:sokadalm
sokk|j
sokszög|l
sólet|j
sólyom|f:sólym
som|j
somogyi|l
soproni|l
sorrend|j
sorszámnév|s:sorszámnev,h:f
sort|j
sósav|l
soul|j
söralátét|l,h:f
sörbet|j
sörét|j
sörgyár|l
sörhab|l
sörhas|l
sötét|j
spam|l,h:f
spániel|j
spanyol|j
spanyolfal|l
sparhelt|j
spenót|j
spicc|h:f
spin|j
spion|j
spirál|j
sporofiton|j
sport|j
sportág|l
sporthír|lp,h:f
sportszív|l,h:f
stáb|j
stadion|j
stand|j
steampunk|j
stop|j
strand|j
sugár|s:sugar
sugaram|l
sugárhajtómű|l,f:sugárhajtóműv
súgógép|l,h:f
súgólyuk|l
sújtólég|l,h:f
sulid|l
sulyok|f:sulyk
súlypont|j
súlyvonal|l
súlyzórúd|s:súlyzórud
sül|j
sült|l,j
sün|j
sütőtök|j
süv|la
süvegcukor|f:süvegcukr
svájci|l
svéd|j
svihák|j
szabadalom|l,f:szabadalm
szabadnap|j
szabálysértés|lp,h:f
szabóizom|f:szabóizm
szaft|j
száj|l
szájfény|lp,h:f
szájkosár|s:szájkosar
szájmaszk|j
szájpad|j
szájpadcsont|j
szakácskönyv|l
szakáll|l
szakértelem|f:szakértelm
szakirodalom|l,f:szakirodalm
szakképzés|lp,h:f
szakkönyv|l
szál|l
szalag|j
szalicilsav|l
szalmakalap|j
szalmaláng|j
szalon|j
szaloncukor|f:szaloncukr
szalondarab|j
szalonkabát|j
szalonspicc|l,h:f
szamár|s:szamar
szamárfül|l
szamárhíd|s:szamárhid
szamárpingvin|lp,j,h:f
számítógép|l,h:f
számítógépközpont|j
szamizdat|j
számjel|l
számnév|s:számnev,h:f
számológép|l,h:f
szamovár|j
számszeríj|l,h:b
száműzött|l,j
szán|j
szánalom|l,f:szánalm
szandál|j
szandzsák|j
szanszkrit|j
szappanhab|j
szár|l
szárad|l
szárazföld|l,j
szárazjég|s:szárazjeg,h:f
szárítógép|l,h:f
szárítókötél|s:szárítókötel
szarkaláb|l
szárkapocs|f:szárkapcs
szárkapocscsont|j
szarkofág|j
szárny|l
szárnykürt|j
szaruk|l
szarunk|l
szarv|l
szarvasbogár|s:szarvasbogar
szarvastehén|s:szarvastehen
szatén|j
szatyor|f:szatyr
szattyán|j
szaxofon|j
száz|l
százezer|f:százezr
százezerszög|l
százlábú|l
százszorszép|l,h:f
szeder|f:szedr
szedéstükör|f:szedéstükr
szedőkanál|s:szedőkanal
széf|j
szegedi|l
szegycsont|j
szeizmográf|j
szék|h:f
szekér|s:szeker
székesegyház|l
székesfehérvári|l
székhely|l
szekund|j
szél|s:szel
szelén|j
szélmalom|f:szélmalm
szélsőbaloldal|lp
szélsőjobboldal|lp
szemcsepp|j
személygépjármű|l,f:személygépjárműv
személyjel|l
személynév|s:személynev
szemer|j
szemérem|f:szemérm
szeméremcsont|j
szeméremdomb|j
szemét|s:szemet
szemeteskosár|s:szemeteskosar
szemetesvödör|f:szemetesvödr
szemétkosár|s:szemétkosar
szemétvödör|f:szemétvödr
szemfog|l
szemhéj|l,h:b
szempillaspirál|j
szempont|j
szemszög|l
szemügy|l
szén|s:szen
szenegáli|l
szénhidrát|j
szénhidrogén|lp,j,h:f
szénsav|l
szénszál|l
szent|j
szenteltvíz|s:szenteltviz
szentfazék|s:szentfazek
szentjánosbogár|s:szentjánosbogar
szenvedelem|f:szenvedelm
szenny|l
szennyvíz|s:szennyviz
szépirodalom|l,f:szépirodalm
szépségszalon|j
szerb|j
szerbhorvát|j
szerelem|f:szerelm
szerpentin|j
szerszámgép|l,h:f
szervál|j
szerzetesrend|j
szesztilalom|l,f:szesztilalm
szexepil|j
szezám|j
szezámmag|j
szezon|j
sziámi|l
szibériai|l
szicíliai|l
szigeti|l
szigmabél|f:szigmabel,h:f
szíj|l,h:b
szil|j
szilánk|j
szilvalekvár|j
szín|h:f
színarany|l
színdarab|j
színész|h:f
szingapúri|l
színház|l
színhely|l
szinkronszínész|lp,h:f
színmű|l,f:színműv
szinonimaszótár|l
szint|j
szintézis|h:f
színvonal|l
szirén|j
szirom|f:szirm
szirt|j
szirup|j
szitok|f:szitk
szív|h:f
szivar|j
szívizom|f:szívizm
szívlapát|j
szívószál|l
szívügy|l
szleng|j
szlogen|j
szlovák|j
szlovén|j
szmoking|j
sznob|j
szóalak|j
szobatárs|l
szobor|f:szobr
szócikk|l,h:f
szogd|j
szójabab|j
szójatej|l
szóképzés|lp,h:f
szókincs|l,h:f
szol|j
szolnoki|l
szombat|j
szomj|l
szonett|j
szoprán|j
szórakozóhely|l
szorb|j
szórend|j
szorgalom|l,f:szorgalm
szorzásjel|l
szószék|l,h:f
szótag|j
szótár|l
szótő|l,f:szótöv
szóvég|l,h:f
szóvicc|l,h:f
szovjet|j
szög|l
szökőár|l,j
szökőkút|s:szökőkut
szökött|l,j
szőlőcukor|f:szőlőcukr
szőlőlé|s:szőlőlev
szőlőzsír|la,j,h:b
szörny|l
szörnyalak|j
szörp|j
szőrszál|l
szputnyik|j
sztár|j
sztereoszkóp|j
sztetoszkóp|j
sztrájk|j
sztrichnin|j
sztyepp|j
szuahéli|l,h:f
szudáni|l
szultán|j
szultánkenyér|f:szultánkenyer
szúnyog|j
szúnyogcsípés|lp,h:f
szuperhatalom|l,f:szuperhatalm
szupermarket|j
szupermodell|j
szurok|f:szurk
szuvenír|j
szüfrazsett|j
szügy|l
születésnap|j
szülőföld|l,j
szülött|l
szűröd|l
szűröm|l
szűrünk|l
szűz|s:szüz
táblagép|l,h:f
táborhely|l
tábortűz|s:tábortüz
tabum|l
tádzsik|j
tag|j
tagdíj|l
tagjelölt|l,j
táj|l
tájfun|j
tájkép|l,h:f
tájszótár|l
tajvani|l
takarékpénztár|l
takony|f:takny
tál|l
talár|j
talizmán|j
talp|l
talpam|l
támaszpont|j
tanácsterem|f:tanácsterm
táncospár|j
táncparkett|j
tánccsoport|j
tandíj|l
tanév|l,h:f
tank|j
tankönyv|l
tanszék|l,h:f
tantál|j
tantárgy|l
tanterem|f:tanterm
tanult|l
tanzániai|l
tányér|j
táp|j
tapír|j
taposómalom|f:taposómalm
táppénz|lp,h:f
tár|l
tárcsafék|l,h:f
tárgy|l
tárgyalóterem|f:tárgyalóterm
tárház|l
tárhely|l
tarkószíj|l
társ|l
társadalom|l,f:társadalm
társasház|l
tartalom|l,f:tartalm
tasak|j
tat|j
taum|l
táv|j
távcső|l,f:távcsöv
távollét|l,h:f
taxisofőr|j
teaház|l
tealevél|s:tealevel
teáskanál|s:teáskanal
teflon|j
téglaház|l
téglalap|j
tegnap|j
tegnapelőtt|j
tehén|s:tehen
teher|f:terh
tej|l
tejcukor|f:tejcukr
tejfog|l
tejsav|l
tejszín|j
tejszínhab|j
tekerőlant|j
tél|s:tel
telefon|j
telefonbetyár|j
telefonkönyv|l
telefonvonal|l
teleház|l
telek|f:telk
teleszkóp|j
telihold|l,j
télikabát|j
teljesszög|l
tellúr|j
temetőbogár|s:temetőbogar
tengelyhatalom|l,f:tengelyhatalm
tengerfenék|s:tengerfenek
tengerpart|j
tenyér|s:tenyer
teodolit|j
tépőzár|l
tér|s:ter
térdszalag|j
terem|s:term
térítés|h:f
terjedelem|f:terjedelm
térkép|h:f
természetbarát|j
természetvédelem|f:természetvédelm
termőföld|l
termünk|l
térség|h:f
térszög|l
teszt|j
tét|j
tettestárs|l
tettük|l
tettünk|l
tévút|s:tévut
thai|k
tik|h:b
tilalom|l,f:tilalm
tincs|h:f
tintahal|l
tipp|j
tiszt|h:f
tiszteletdíj|l,h:b
titán|j
titok|f:titk
tíz|l
tizenegyszög|l
tizenharmadik|l
tizenhárom|l,f:tizenhárm
tizenháromszög|l
tizenhatodik|l
tizenhatszög|l
tizenhét|s:tizenhet
tizenhétszög|l
tizenkétszög|l
tizenkilencszög|l
tizennégyszög|l
tizenötszög|l
tizennyolc|l
tizennyolcadik|l
tizennyolcszög|l
tízezer|f:tízezr
tízezerszög|l
tízszög|l
tó|l,f:tav
toalett|j
toalettpapír|j
tobogán|j
tobozmirigy|l,h:f
togói|l
tojáshéj|l
tojáslikőr|j
tok|j
tokom|l
toll|l
tolószék|l,h:f
tompaszög|l
tonhal|l
tópart|j
toportyán|j
toportyánféreg|f:toportyánférg
tornaterem|f:tornaterm
torok|f:tork
torokszíj|l
torony|f:torny
tortalapát|j
tory|j
tót|j
totál|j
további|l
továbbképzés|lp,h:f
tő|l,f:töv
több|l,j
többé|l,h:b
többi|l
többsejtű|l
tőgy|l
tőkehal|l
tökmag|j
tölgy|l
tölténytár|l
töltőtoll|l
tömb|j
tömbház|l
tömegsír|la,j,h:b
tönk|j
törésvonal|l
török|j
töröknyereg|f:töröknyerg
tört|l,j
történelem|f:történelm
történtek|s:történt
törtünk|l
törvénykönyv|l
törzs|l
törzshely|l
tőszámnév|f:tőszámnev,h:f
trágyadomb|j
transznemű|l
trapézcsont|j
treff|j
trend|j
tréning|j
trójai|l
tromf|j
trón|j
trónszék|l,h:f
trükk|j
tucat|j
tudásszomj|l
tudományág|l
tukán|j
tulajdonnév|s:tulajdonnev,h:f
tulajdonostárs|l
túlélés|lp,h:f
tulipán|j
tulok|f:tulk
túr|j
turbán|j
turf|j
turmixgép|l,h:f
turul|j
túzok|j
tücsök|f:tücsk
tükör|f:tükr
tülök|f:tülk
türelem|f:türelm
türkmén|j
tűsarok|l,f:tűsark
tűz|s:tüz
tűzcsap|j
tűzfal|l
tűzhal|l
tűzhely|l
tűzőkapocs|f:tűzőkapcs
tűzvédelem|f:tűzvédelm
tyúk|j
úd|j
udvarhölgy|l
ugor|j
ugrálóvár|l
ugrócsont|j
ugrókötél|s:ugrókötel
újév|l,h:f
újhold|l,j
ujj|l
újjáépítés|lp,h:f
újság|j
újságcikk|l,h:f
újszülött|l,j
ukrán|j
ultrahang|j
unalom|l,f:unalm
undi|l
úr|s:ur
uradalom|l,f:urodalm
uralkodócsalád|j
uralkodóház|l
uralom|l,f:uralm
uram|l
urán|j
út|s:ut
útdíj|l
útikönyv|l
útlevél|s:útlevel
utód|j
utóíz|lp,h:f
utónév|s:utónev,h:f
útvonal|l
üdvözlőlap|j
ügy|l
ügyfél|s:ügyfel
ülőcsont|j
ülőpad|j
ülősztrájk|j
ünnepnap|j
üpszilon|j
űrlap|j
üröm|f:ürm
ürömfajd|j
űrszemét|s:űrszemet
űrtartalom|l,f:űrtartalm
ürügy|l
űrügy|l
üst|j
üstdob|j
üszök|f:üszk
ütőér|f:ütőer
ütőgardon|j
üvegház|l
üzbég|j
üzelmek|s:üzelm
üzletág|l
váci|l
vad|l,j
vád|l,j
vadam|l
vadászgép|l,h:f
vadászkés|lp,h:f
vadászom|l
vadkan|j
vadszeder|f:vadszedr
vadtyúk|j
vágóhíd|s:vágóhid
vagon|j
vágy|l
vagyontalan|j
vagyontárgy|l
vaj|l
vájdling|j
vajling|j
vájling|j
vakbél|f:vakbel,h:f
vaker|la,j,h:b
vakolókanál|s:vakolókanal
vakond|j
választójel|l
választott|l,j
valin|j
váll|l
válogatott|l,j
valósi|l
váltópénz|lp,h:f
váltságdíj|l
vályogház|l
vám|j
vámpír|j
vandál|j
vándorgalamb|j
vándorsólyom|f:vándorsólym
vaníliafagylalt|j
vaníliarúd|s:vaníliarud
vár|l
váratok|l
városi|l
városnézés|lp,h:f
városrész|lp,h:f
várostérkép|l,h:f
váróterem|f:váróterm
varrógép|l,h:f
vártátok|l
várunk|l
vas|l
vásárhely|l
vasárnap|j
vásártér|s:vásárter,h:f
vasbeton|j
vascső|l,f:vascsöv
vasérc|l,h:f
vasgyár|l
vastagbél|s:vastagbel,h:f
vasút|s:vasut
vasútvonal|l
vászon|l,f:vászn
vasszűz|s:vasszüz
vattacukor|f:vattacukr
váz|l
védelem|f:védelm
veder|f:vedr
védőszent|j
vég|h:f
végbél|f:végbel
végpont|j
végtag|j
végzés|h:f
vegyértékű|l
vegyjel|l
vékonybél|s:vékonybel,h:f
vektortér|s:vektorter,h:f
vélelem|f:vélelm
velencei|l
velúr|j
vén|h:f
vend|j
vendégkönyv|l
verbunk|j
vércukor|f:vércukr
vércsepp|j
vércsoport|j
veréb|s:vereb
verem|f:verm
vérér|f:vérer
vermut|j
verőér|f:verőer
vers|l
vérsejt|j
versenyló|l,f:versenylov
versenymű|l,f:versenyműv
versenytárs|l
verszt|j
vért|j
vértest|j
verzál|j
vérzés|h:f
vesekő|l,f:veseköv
veszedelem|f:veszedelm
vészmadár|s:vészmadar
vesztünk|l
vétek|f:vétk
vételár|l
vetélytárs|l
veterán|j
vezetéknév|s:vezetéknev
viaszosvászon|l,f:viaszosvászn
vicc|h:f
vidék|h:f
videoklip|l,h:f
videóklip|l,j,h:f
videotelefon|j
videótelefon|j
vietnami|l
vietnámi|l
vigaszdíj|l
viharmadár|s:viharmadar
víkend|j
világfájdalom|l,f:világfájdalm
világhír|lp,h:f
világirodalom|l,f:világirodalm
világítócső|l,f:világítócsöv
világítórák|j
világítótorony|f:világítótorny
világrekord|j
világtáj|l
világtérkép|l,h:f
világűr|j
villacsont|j
villamosvonal|l
villamosszék|l,h:f
vilniusi|l
virágágy|l
virágcserép|s:virágcserep
virágcsokor|f:virágcsokr
virágvasárnap|j
vircsaft|j
visszaélés|lp,h:f
visszatérés|lp,h:f
visszatérítés|lp,h:f
visszér|f:visszer
visszhang|j
vitamin|j
vivát|j
víz|s:viz
vízcsap|j
vízcsepp|j
vízhólyag|j
víziló|l,f:vízilov
vízimadár|s:vízimadar
vízjel|l
vízkereszt|j
vízkő|l,f:vízköv
vízpart|j
víztorony|f:víztorny
vízügy|l
volt|j
von|j
vonal|l
vonalkód|j
vonjuk|l
vonod|l
vonom|l
vonunk|l
vonzalom|l,f:vonzalm
vöcsök|f:vöcsk
vödör|f:vödr
völgy|l
völgyhíd|s:völgyhid,h:b
vörösvérsejt|j
vörösvértest|j
vulkán|j
walesi|l
watt|j
web|j
weboldal|l
werkfilm|j
western|j
wikiszótár|l
workshop|j
xenon|j
xilofon|j
zab|j
zabliszt|l,j,h:f
zabpehely|f:zabpelyh
zafír|j
zaft|j
zálogház|l
zápfog|l
zár|l
záróvonal|l
zárunk|l
zászlóalj|l
zavarom|l
zavaros|lp
zebrapinty|l,h:f
zefír|j
zérushely|l
zombiapokalipszis|lp,h:f
zongorapad|j
zongoraszék|l,h:f
zöldfülű|l
zuhatag|j
zűr|j
zürjén|j
zsák|j
zsakett|j
zsandár|j
zsargon|j
zsarolóprogram|j
zsebszótár|l
zselatin|j
zseton|j
zsib|j
zsilip|j
zsinór|j
zsír|j
zsiráf|j
zsírkő|l,f:zsírköv
zsírsav|l
zsírtartalom|l,f:zsírtartalm
zsizsik|j
zsold|j
zsoltár|j
zsoltárkönyv|l
zsoltároskönyv|l
zsonglőr|j
zsorzsett|j
zsúp|j
zsúr|j
`;

const OVERRIDE_DATA = `ábécéskönyv|N;PSS2P;SG|ábécéskönyvetek
ablativus|N;INS;SG|ablativusszal
ablativus|N;TRANS;SG|ablativusszá
adatai|N;ACC;PL|adatait
adatai|N;AT+ABL;PL|adataitól
adatai|N;AT+ALL;PL|adataihoz
adatai|N;AT+ESS;PL|adatainál
adatai|N;DAT;PL|adatainak
adatai|N;FRML;PL|adataiként
adatai|N;IN+ABL;PL|adataiból
adatai|N;IN+ALL;PL|adataiba
adatai|N;IN+ESS;PL|adataiban
adatai|N;INS;PL|adataival
adatai|N;NOM;PL|adatai
adatai|N;ON+ABL;PL|adatairól
adatai|N;ON+ALL;PL|adataira
adatai|N;ON+ESS;PL|adatain
adatai|N;PRP;PL|adataiért
adatai|N;TERM;PL|adataiig
adatai|N;TRANS;PL|adataivá
adói|N;ACC;PL|adóit
adói|N;AT+ABL;PL|adóitól
adói|N;AT+ALL;PL|adóihoz
adói|N;AT+ESS;PL|adóinál
adói|N;DAT;PL|adóinak
adói|N;FRML;PL|adóiként
adói|N;IN+ABL;PL|adóiból
adói|N;IN+ALL;PL|adóiba
adói|N;IN+ESS;PL|adóiban
adói|N;INS;PL|adóival
adói|N;NOM;PL|adói
adói|N;ON+ABL;PL|adóiról
adói|N;ON+ALL;PL|adóira
adói|N;ON+ESS;PL|adóin
adói|N;PRP;PL|adóiért
adói|N;TERM;PL|adóiig
adói|N;TRANS;PL|adóivá
adui|N;ACC;PL|aduit
adui|N;AT+ABL;PL|aduitól
adui|N;AT+ALL;PL|aduihoz
adui|N;AT+ESS;PL|aduinál
adui|N;DAT;PL|aduinak
adui|N;FRML;PL|aduiként
adui|N;IN+ABL;PL|aduiból
adui|N;IN+ALL;PL|aduiba
adui|N;IN+ESS;PL|aduiban
adui|N;INS;PL|aduival
adui|N;NOM;PL|adui
adui|N;ON+ABL;PL|aduiról
adui|N;ON+ALL;PL|aduira
adui|N;ON+ESS;PL|aduin
adui|N;PRP;PL|aduiért
adui|N;TERM;PL|aduiig
adui|N;TRANS;PL|aduivá
afrikaans|N;INS;SG|afrikaansszal
afrikaans|N;TRANS;SG|afrikaansszá
afrikai|N;PSS1P;PL|afrikaijaink
afrikai|N;PSS1S;PL|afrikaijaim
afrikai|N;PSS2P;PL|afrikaijaitok
afrikai|N;PSS2S;PL|afrikaijaid
afrikai|N;PSS3P;PL|afrikaijaik
afrikai|N;PSS3S;PL|afrikaijai
agility|N;ACC;PL|agilityket
agility|N;ACC;SG|agilityt
agility|N;AT+ABL;PL|agilityktől
agility|N;AT+ALL;PL|agilitykhez
agility|N;AT+ESS;PL|agilityknél
agility|N;DAT;PL|agilityknek
agility|N;IN+ABL;PL|agilitykből
agility|N;IN+ALL;PL|agilitykbe
agility|N;IN+ESS;PL|agilitykben
agility|N;INS;PL|agilitykkel
agility|N;INS;SG|agilityvel
agility|N;NOM;PL|agilityk
agility|N;ON+ABL;PL|agilitykről
agility|N;ON+ALL;PL|agilitykre
agility|N;ON+ESS;PL|agilityken
agility|N;ON+ESS;SG|agilityn
agility|N;PRP;PL|agilitykért
agility|N;TERM;PL|agilitykig
agility|N;TRANS;PL|agilitykké
agility|N;TRANS;SG|agilityvé
aksi|N;PSS1P;PL|aksijaink
aksi|N;PSS1S;PL|aksijaim
aksi|N;PSS2P;PL|aksijaitok
aksi|N;PSS2S;PL|aksijaid
aksi|N;PSS3P;PL|aksijaik
aksi|N;PSS3S;PL|aksijai
alagút|N;PSS1P;PL|alagútjaink
alagút|N;PSS1S;PL|alagútjaim
alagút|N;PSS2P;PL|alagútjaitok
alagút|N;PSS2S;PL|alagútjaid
alagút|N;PSS3P;PL|alagútjaik
alagút|N;PSS3P;SG|alagútjuk
alagút|N;PSS3S;PL|alagútjai
alagút|N;PSS3S;SG|alagútja
albániai|N;PSS1P;PL|albániaijaink
albániai|N;PSS1S;PL|albániaijaim
albániai|N;PSS2P;PL|albániaijaitok
albániai|N;PSS2S;PL|albániaijaid
albániai|N;PSS3P;PL|albániaijaik
albániai|N;PSS3S;PL|albániaijai
alföld|N;PSS2P;SG|alföldetek
alföldi|N;PSS1P;PL|alföldijeink
alföldi|N;PSS1S;PL|alföldijeim
alföldi|N;PSS2P;PL|alföldijeitek
alföldi|N;PSS2S;PL|alföldijeid
alföldi|N;PSS3P;PL|alföldijeik
alföldi|N;PSS3S;PL|alföldijei
algériai|N;PSS1P;PL|algériaijaink
algériai|N;PSS1S;PL|algériaijaim
algériai|N;PSS2P;PL|algériaijaitok
algériai|N;PSS2S;PL|algériaijaid
algériai|N;PSS3P;PL|algériaijaik
algériai|N;PSS3S;PL|algériaijai
alkáli|N;PSS1P;PL|alkálijaink
alkáli|N;PSS1S;PL|alkálijaim
alkáli|N;PSS2P;PL|alkálijaitok
alkáli|N;PSS2S;PL|alkálijaid
alkáli|N;PSS3P;PL|alkálijaik
alkáli|N;PSS3S;PL|alkálijai
alkalmazott|N;AT+ABL;SG|alkalmazottól
alkotói|N;ACC;PL|alkotóit
alkotói|N;AT+ABL;PL|alkotóitól
alkotói|N;AT+ALL;PL|alkotóihoz
alkotói|N;AT+ESS;PL|alkotóinál
alkotói|N;DAT;PL|alkotóinak
alkotói|N;FRML;PL|alkotóiként
alkotói|N;IN+ABL;PL|alkotóiból
alkotói|N;IN+ALL;PL|alkotóiba
alkotói|N;IN+ESS;PL|alkotóiban
alkotói|N;INS;PL|alkotóival
alkotói|N;NOM;PL|alkotói
alkotói|N;ON+ABL;PL|alkotóiról
alkotói|N;ON+ALL;PL|alkotóira
alkotói|N;ON+ESS;PL|alkotóin
alkotói|N;PRP;PL|alkotóiért
alkotói|N;TERM;PL|alkotóiig
alkotói|N;TRANS;PL|alkotóivá
állatöv|N;PSS2P;SG|állatövetek
almai|N;ACC;PL|almait
almai|N;AT+ABL;PL|almaitól
almai|N;AT+ALL;PL|almaihoz
almai|N;AT+ESS;PL|almainál
almai|N;DAT;PL|almainak
almai|N;FRML;PL|almaiként
almai|N;IN+ABL;PL|almaiból
almai|N;IN+ALL;PL|almaiba
almai|N;IN+ESS;PL|almaiban
almai|N;INS;PL|almaival
almai|N;NOM;PL|almai
almai|N;ON+ABL;PL|almairól
almai|N;ON+ALL;PL|almaira
almai|N;ON+ESS;PL|almain
almai|N;PRP;PL|almaiért
almai|N;TERM;PL|almaiig
almai|N;TRANS;PL|almaivá
alulírott|N;AT+ABL;SG|alulírottól
amatőr|N;PSS3P;SG|amatőrjük
amatőr|N;PSS3S;SG|amatőrje
amcsi|N;PSS1P;PL|amcsijaink
amcsi|N;PSS1S;PL|amcsijaim
amcsi|N;PSS2P;PL|amcsijaitok
amcsi|N;PSS2S;PL|amcsijaid
amcsi|N;PSS3P;PL|amcsijaik
amcsi|N;PSS3S;PL|amcsijai
amerikai|N;PSS1P;PL|amerikaijaink
amerikai|N;PSS1S;PL|amerikaijaim
amerikai|N;PSS2P;PL|amerikaijaitok
amerikai|N;PSS2S;PL|amerikaijaid
amerikai|N;PSS3P;PL|amerikaijaik
amerikai|N;PSS3S;PL|amerikaijai
amulett|N;AT+ABL;SG|amulettől
anime|N;ACC;PL|animéket
anime|N;AT+ABL;PL|animéktől
anime|N;AT+ALL;PL|animékhez
anime|N;AT+ESS;PL|animéknél
anime|N;DAT;PL|animéknek
anime|N;IN+ABL;PL|animékből
anime|N;IN+ALL;PL|animékbe
anime|N;IN+ESS;PL|animékben
anime|N;INS;PL|animékkel
anime|N;ON+ABL;PL|animékről
anime|N;ON+ALL;PL|animékre
anime|N;ON+ESS;PL|animéken
anime|N;TRANS;PL|animékké
aranyérme|N;ACC;PL|aranyérméket
aranyérme|N;AT+ABL;PL|aranyérméktől
aranyérme|N;AT+ALL;PL|aranyérmékhez
aranyérme|N;AT+ESS;PL|aranyérméknél
aranyérme|N;DAT;PL|aranyérméknek
aranyérme|N;IN+ABL;PL|aranyérmékből
aranyérme|N;IN+ALL;PL|aranyérmékbe
aranyérme|N;IN+ESS;PL|aranyérmékben
aranyérme|N;INS;PL|aranyérmékkel
aranyérme|N;ON+ABL;PL|aranyérmékről
aranyérme|N;ON+ALL;PL|aranyérmékre
aranyérme|N;ON+ESS;PL|aranyérméken
aranyérme|N;TRANS;PL|aranyérmékké
arcai|N;ACC;PL|arcait
arcai|N;AT+ABL;PL|arcaitól
arcai|N;AT+ALL;PL|arcaihoz
arcai|N;AT+ESS;PL|arcainál
arcai|N;DAT;PL|arcainak
arcai|N;FRML;PL|arcaiként
arcai|N;IN+ABL;PL|arcaiból
arcai|N;IN+ALL;PL|arcaiba
arcai|N;IN+ESS;PL|arcaiban
arcai|N;INS;PL|arcaival
arcai|N;NOM;PL|arcai
arcai|N;ON+ABL;PL|arcairól
arcai|N;ON+ALL;PL|arcaira
arcai|N;ON+ESS;PL|arcain
arcai|N;PRP;PL|arcaiért
arcai|N;TERM;PL|arcaiig
arcai|N;TRANS;PL|arcaivá
árindex|N;INS;SG|árindexszel
árindex|N;TRANS;SG|árindexszé
átkozott|N;AT+ABL;SG|átkozottól
atya|N;PSS3P;SG|atyjuk
atya|N;PSS3S;SG|atyja
autógumi|N;PSS1P;PL|autógumijaink
autógumi|N;PSS1S;PL|autógumijaim
autógumi|N;PSS2P;PL|autógumijaitok
autógumi|N;PSS2S;PL|autógumijaid
autógumi|N;PSS3P;PL|autógumijaik
autógumi|N;PSS3S;PL|autógumijai
azeri|N;PSS1P;PL|azerijeink
azeri|N;PSS1S;PL|azerijeim
azeri|N;PSS2P;PL|azerijeitek
azeri|N;PSS2S;PL|azerijeid
azeri|N;PSS3P;PL|azerijeik
azeri|N;PSS3S;PL|azerijei
ázsiai|N;PSS1P;PL|ázsiaijaink
ázsiai|N;PSS1S;PL|ázsiaijaim
ázsiai|N;PSS2P;PL|ázsiaijaitok
ázsiai|N;PSS2S;PL|ázsiaijaid
ázsiai|N;PSS3P;PL|ázsiaijaik
ázsiai|N;PSS3S;PL|ázsiaijai
babakocsi|N;PSS1P;PL|babakocsijaink
babakocsi|N;PSS1S;PL|babakocsijaim
babakocsi|N;PSS2P;PL|babakocsijaitok
babakocsi|N;PSS2S;PL|babakocsijaid
babakocsi|N;PSS3P;PL|babakocsijaik
babakocsi|N;PSS3S;PL|babakocsijai
baci|N;PSS1P;PL|bacijaink
baci|N;PSS1S;PL|bacijaim
baci|N;PSS2P;PL|bacijaitok
baci|N;PSS2S;PL|bacijaid
baci|N;PSS3P;PL|bacijaik
baci|N;PSS3S;PL|bacijai
bácsi|N;PSS1P;PL|bácsijaink
bácsi|N;PSS1S;PL|bácsijaim
bácsi|N;PSS2P;PL|bácsijaitok
bácsi|N;PSS2S;PL|bácsijaid
bácsi|N;PSS3P;PL|bácsijaik
bácsi|N;PSS3S;PL|bácsijai
bagdadi|N;PSS1P;PL|bagdadijaink
bagdadi|N;PSS1S;PL|bagdadijaim
bagdadi|N;PSS2P;PL|bagdadijaitok
bagdadi|N;PSS2S;PL|bagdadijaid
bagdadi|N;PSS3P;PL|bagdadijaik
bagdadi|N;PSS3S;PL|bagdadijai
bajonett|N;AT+ABL;SG|bajonettől
baki|N;PSS1P;PL|bakijaink
baki|N;PSS1S;PL|bakijaim
baki|N;PSS2P;PL|bakijaitok
baki|N;PSS2S;PL|bakijaid
baki|N;PSS3P;PL|bakijaik
baki|N;PSS3S;PL|bakijai
balek|N;ACC;SG|balekot
balek|N;PSS1S;SG|balekom
balek|N;PSS2P;SG|balekotok
balek|N;PSS2S;SG|balekod
balerinazokni|N;PSS1P;PL|balerinazoknijaink
balerinazokni|N;PSS1S;PL|balerinazoknijaim
balerinazokni|N;PSS2P;PL|balerinazoknijaitok
balerinazokni|N;PSS2S;PL|balerinazoknijaid
balerinazokni|N;PSS3P;PL|balerinazoknijaik
balerinazokni|N;PSS3S;PL|balerinazoknijai
balett|N;AT+ABL;SG|balettől
baloldal|N;ACC;SG|baloldalt
balti|N;PSS1P;PL|baltijaink
balti|N;PSS1S;PL|baltijaim
balti|N;PSS2P;PL|baltijaitok
balti|N;PSS2S;PL|baltijaid
balti|N;PSS3P;PL|baltijaik
balti|N;PSS3S;PL|baltijai
bani|N;PSS1P;PL|banijaink
bani|N;PSS1S;PL|banijaim
bani|N;PSS2P;PL|banijaitok
bani|N;PSS2S;PL|banijaid
bani|N;PSS3P;PL|banijaik
bani|N;PSS3S;PL|banijai
bankett|N;AT+ABL;SG|bankettől
barát|N;PSS3P;SG|barátjuk
barát|N;PSS3S;SG|barátja
bari|N;PSS1P;PL|barijaink
bari|N;PSS1S;PL|barijaim
bari|N;PSS2P;PL|barijaitok
bari|N;PSS2S;PL|barijaid
bari|N;PSS3P;PL|barijaik
bari|N;PSS3S;PL|barijai
barokk|N;FRML;SG|barokként
baromfi|N;PSS1P;PL|baromfijaink
baromfi|N;PSS1S;PL|baromfijaim
baromfi|N;PSS2P;PL|baromfijaitok
baromfi|N;PSS2S;PL|baromfijaid
baromfi|N;PSS3P;PL|baromfijaik
baromfi|N;PSS3S;PL|baromfijai
basenji|N;PSS1P;PL|basenjijeink
basenji|N;PSS1S;PL|basenjijeim
basenji|N;PSS2P;PL|basenjijeitek
basenji|N;PSS2S;PL|basenjijeid
basenji|N;PSS3P;PL|basenjijeik
basenji|N;PSS3S;PL|basenjijei
bátor|N;PSS1P;SG|bátrunk
bátor|N;PSS1S;SG|bátram
bátor|N;PSS2P;SG|bátratok
bátor|N;PSS2S;SG|bátrad
bátor|N;PSS3P;SG|bátruk
bátor|N;PSS3S;SG|bátra
báty|N;PSS1P;PL|bátyáink
báty|N;PSS1P;SG|bátyánk
báty|N;PSS1S;PL|bátyáim
báty|N;PSS1S;SG|bátyám
báty|N;PSS2P;PL|bátyáitok
báty|N;PSS2P;SG|bátyátok
báty|N;PSS2S;PL|bátyáid
báty|N;PSS2S;SG|bátyád
báty|N;PSS3P;PL|bátyáik
báty|N;PSS3S;PL|bátyái
bátya|N;PSS1P;PL|bátyjaink
bátya|N;PSS1S;PL|bátyjaim
bátya|N;PSS2P;PL|bátyjaitok
bátya|N;PSS2S;PL|bátyjaid
bátya|N;PSS3P;PL|bátyjaik
bátya|N;PSS3P;SG|bátyjuk
bátya|N;PSS3S;PL|bátyjai
bátya|N;PSS3S;SG|bátyja
beavatott|N;AT+ABL;SG|beavatottól
bécsi|N;PSS1P;PL|bécsijeink
bécsi|N;PSS1S;PL|bécsijeim
bécsi|N;PSS2P;PL|bécsijeitek
bécsi|N;PSS2S;PL|bécsijeid
bécsi|N;PSS3P;PL|bécsijeik
bécsi|N;PSS3S;PL|bécsijei
bejgli|N;PSS1P;PL|bejglijeink
bejgli|N;PSS1S;PL|bejglijeim
bejgli|N;PSS2P;PL|bejglijeitek
bejgli|N;PSS2S;PL|bejglijeid
bejgli|N;PSS3P;PL|bejglijeik
bejgli|N;PSS3S;PL|bejglijei
belei|N;ACC;PL|beleit
belei|N;AT+ABL;PL|beleitől
belei|N;AT+ALL;PL|beleihez
belei|N;AT+ESS;PL|beleinél
belei|N;DAT;PL|beleinek
belei|N;FRML;PL|beleiként
belei|N;IN+ABL;PL|beleiből
belei|N;IN+ALL;PL|beleibe
belei|N;IN+ESS;PL|beleiben
belei|N;INS;PL|beleivel
belei|N;NOM;PL|belei
belei|N;ON+ABL;PL|beleiről
belei|N;ON+ALL;PL|beleire
belei|N;ON+ESS;PL|belein
belei|N;PRP;PL|beleiért
belei|N;TERM;PL|beleiig
belei|N;TRANS;PL|beleivé
beleid|N;ACC;PL|beleidet
beleid|N;AT+ABL;PL|beleidtől
beleid|N;AT+ALL;PL|beleidhez
beleid|N;AT+ESS;PL|beleidnél
beleid|N;DAT;PL|beleidnek
beleid|N;FRML;PL|beleidként
beleid|N;IN+ABL;PL|beleidből
beleid|N;IN+ALL;PL|beleidbe
beleid|N;IN+ESS;PL|beleidben
beleid|N;INS;PL|beleiddel
beleid|N;NOM;PL|beleid
beleid|N;ON+ABL;PL|beleidről
beleid|N;ON+ALL;PL|beleidre
beleid|N;ON+ESS;PL|beleiden
beleid|N;PRP;PL|beleidért
beleid|N;TERM;PL|beleidig
beleid|N;TRANS;PL|beleiddé
belföld|N;PSS2P;SG|belföldetek
belügy|N;PSS2P;SG|belügyetek
benini|N;PSS1P;PL|beninijeink
benini|N;PSS1S;PL|beninijeim
benini|N;PSS2P;PL|beninijeitek
benini|N;PSS2S;PL|beninijeid
benini|N;PSS3P;PL|beninijeik
benini|N;PSS3S;PL|beninijei
bennszülött|N;AT+ABL;SG|bennszülöttől
bennszülött|N;PSS2P;SG|bennszülöttetek
benzinkút|N;PSS1P;PL|benzinkútjaink
benzinkút|N;PSS1S;PL|benzinkútjaim
benzinkút|N;PSS2P;PL|benzinkútjaitok
benzinkút|N;PSS2S;PL|benzinkútjaid
benzinkút|N;PSS3P;PL|benzinkútjaik
benzinkút|N;PSS3P;SG|benzinkútjuk
benzinkút|N;PSS3S;PL|benzinkútjai
benzinkút|N;PSS3S;SG|benzinkútja
beosztott|N;AT+ABL;SG|beosztottól
bili|N;PSS1P;PL|bilijeink
bili|N;PSS1S;PL|bilijeim
bili|N;PSS2P;PL|bilijeitek
bili|N;PSS2S;PL|bilijeid
bili|N;PSS3P;PL|bilijeik
bili|N;PSS3S;PL|bilijei
bírói|N;ACC;PL|bíróit
bírói|N;AT+ABL;PL|bíróitól
bírói|N;AT+ALL;PL|bíróihoz
bírói|N;AT+ESS;PL|bíróinál
bírói|N;DAT;PL|bíróinak
bírói|N;FRML;PL|bíróiként
bírói|N;IN+ABL;PL|bíróiból
bírói|N;IN+ALL;PL|bíróiba
bírói|N;IN+ESS;PL|bíróiban
bírói|N;INS;PL|bíróival
bírói|N;NOM;PL|bírói
bírói|N;ON+ABL;PL|bíróiról
bírói|N;ON+ALL;PL|bíróira
bírói|N;ON+ESS;PL|bíróin
bírói|N;PRP;PL|bíróiért
bírói|N;TERM;PL|bíróiig
bírói|N;TRANS;PL|bíróivá
birok|N;ACC;SG|birkot
bizánci|N;PSS1P;PL|bizáncijaink
bizánci|N;PSS1S;PL|bizáncijaim
bizánci|N;PSS2P;PL|bizáncijaitok
bizánci|N;PSS2S;PL|bizáncijaid
bizánci|N;PSS3P;PL|bizáncijaik
bizánci|N;PSS3S;PL|bizáncijai
blatt|N;AT+ABL;SG|blattól
blokk|N;FRML;SG|blokként
blues|N;INS;SG|blueszal
blues|N;TRANS;SG|blueszá
bojkott|N;AT+ABL;SG|bojkottól
bokazokni|N;PSS1P;PL|bokazoknijaink
bokazokni|N;PSS1S;PL|bokazoknijaim
bokazokni|N;PSS2P;PL|bokazoknijaitok
bokazokni|N;PSS2S;PL|bokazoknijaid
bokazokni|N;PSS3P;PL|bokazoknijaik
bokazokni|N;PSS3S;PL|bokazoknijai
boksz|N;ACC;SG|bokszot
bonszai|N;INS;SG|bonszaijal
bonszai|N;ON+ESS;SG|bonszaion
bonszai|N;PSS1P;PL|bonszaiaink
bonszai|N;PSS1P;SG|bonszaiunk
bonszai|N;PSS1S;PL|bonszaiaim
bonszai|N;PSS1S;SG|bonszaiom
bonszai|N;PSS2P;PL|bonszaiaitok
bonszai|N;PSS2P;SG|bonszaiotok
bonszai|N;PSS2S;PL|bonszaiaid
bonszai|N;PSS2S;SG|bonszaiod
bonszai|N;PSS3P;PL|bonszaiaik
bonszai|N;PSS3P;SG|bonszaiuk
bonszai|N;PSS3S;PL|bonszaiai
bonszai|N;PSS3S;SG|bonszaia
bonszai|N;TRANS;SG|bonszaijá
borpince|N;ACC;PL|borpincéket
borpince|N;AT+ABL;PL|borpincéktől
borpince|N;AT+ALL;PL|borpincékhez
borpince|N;AT+ESS;PL|borpincéknél
borpince|N;DAT;PL|borpincéknek
borpince|N;IN+ABL;PL|borpincékből
borpince|N;IN+ALL;PL|borpincékbe
borpince|N;IN+ESS;PL|borpincékben
borpince|N;INS;PL|borpincékkel
borpince|N;ON+ABL;PL|borpincékről
borpince|N;ON+ALL;PL|borpincékre
borpince|N;ON+ESS;PL|borpincéken
borpince|N;TRANS;PL|borpincékké
bors|N;ACC;SG|borsot
borsikafű|N;PSS2P;SG|borsikafüvetek
borz|N;ACC;SG|borzot
botswanai|N;PSS1P;PL|botswanaijaink
botswanai|N;PSS1S;PL|botswanaijaim
botswanai|N;PSS2P;PL|botswanaijaitok
botswanai|N;PSS2S;PL|botswanaijaid
botswanai|N;PSS3P;PL|botswanaijaik
botswanai|N;PSS3S;PL|botswanaijai
boy|N;ACC;SG|boyt
boy|N;INS;SG|boyjal
boy|N;TRANS;SG|boyjá
bölcs|N;PSS2P;SG|bölcsetek
briganti|N;PSS1P;PL|brigantijaink
briganti|N;PSS1S;PL|brigantijaim
briganti|N;PSS2P;PL|brigantijaitok
briganti|N;PSS2S;PL|brigantijaid
briganti|N;PSS3P;PL|brigantijaik
briganti|N;PSS3S;PL|brigantijai
brikett|N;AT+ABL;SG|brikettől
brokkoli|N;PSS1P;PL|brokkolijaink
brokkoli|N;PSS1S;PL|brokkolijaim
brokkoli|N;PSS2P;PL|brokkolijaitok
brokkoli|N;PSS2S;PL|brokkolijaid
brokkoli|N;PSS3P;PL|brokkolijaik
brokkoli|N;PSS3S;PL|brokkolijai
bronz|N;ACC;SG|bronzot
brüsszeli|N;PSS1P;PL|brüsszelijeink
brüsszeli|N;PSS1S;PL|brüsszelijeim
brüsszeli|N;PSS2P;PL|brüsszelijeitek
brüsszeli|N;PSS2S;PL|brüsszelijeid
brüsszeli|N;PSS3P;PL|brüsszelijeik
brüsszeli|N;PSS3S;PL|brüsszelijei
bubi|N;PSS1P;PL|bubijaink
bubi|N;PSS1S;PL|bubijaim
bubi|N;PSS2P;PL|bubijaitok
bubi|N;PSS2S;PL|bubijaid
bubi|N;PSS3P;PL|bubijaik
bubi|N;PSS3S;PL|bubijai
budapesti|N;PSS1P;PL|budapestijeink
budapesti|N;PSS1S;PL|budapestijeim
budapesti|N;PSS2P;PL|budapestijeitek
budapesti|N;PSS2S;PL|budapestijeid
budapesti|N;PSS3P;PL|budapestijeik
budapesti|N;PSS3S;PL|budapestijei
budi|N;PSS1P;PL|budijaink
budi|N;PSS1S;PL|budijaim
budi|N;PSS2P;PL|budijaitok
budi|N;PSS2S;PL|budijaid
budi|N;PSS3P;PL|budijaik
budi|N;PSS3S;PL|budijai
bugyi|N;PSS1P;PL|bugyijaink
bugyi|N;PSS1S;PL|bugyijaim
bugyi|N;PSS2P;PL|bugyijaitok
bugyi|N;PSS2S;PL|bugyijaid
bugyi|N;PSS3P;PL|bugyijaik
bugyi|N;PSS3S;PL|bugyijai
buki|N;PSS1P;PL|bukijaink
buki|N;PSS1S;PL|bukijaim
buki|N;PSS2P;PL|bukijaitok
buki|N;PSS2S;PL|bukijaid
buki|N;PSS3P;PL|bukijaik
buki|N;PSS3S;PL|bukijai
buli|N;PSS1P;PL|bulijaink
buli|N;PSS1S;PL|bulijaim
buli|N;PSS2P;PL|bulijaitok
buli|N;PSS2S;PL|bulijaid
buli|N;PSS3P;PL|bulijaik
buli|N;PSS3S;PL|bulijai
buzi|N;PSS1P;PL|buzijaink
buzi|N;PSS1S;PL|buzijaim
buzi|N;PSS2P;PL|buzijaitok
buzi|N;PSS2S;PL|buzijaid
buzi|N;PSS3P;PL|buzijaik
buzi|N;PSS3S;PL|buzijai
bükk|N;FRML;SG|bükként
bűntett|N;AT+ABL;SG|bűntettől
bűnügy|N;PSS2P;SG|bűnügyetek
bűzösborz|N;ACC;SG|bűzösborzot
casco|N;ACC;PL|cascókat
casco|N;ACC;SG|cascót
casco|N;AT+ABL;PL|cascóktól
casco|N;AT+ABL;SG|cascótól
casco|N;AT+ALL;PL|cascókhoz
casco|N;AT+ALL;SG|cascóhoz
casco|N;AT+ESS;PL|cascóknál
casco|N;AT+ESS;SG|cascónál
casco|N;DAT;PL|cascóknak
casco|N;DAT;SG|cascónak
casco|N;IN+ABL;PL|cascókból
casco|N;IN+ABL;SG|cascóból
casco|N;IN+ALL;PL|cascókba
casco|N;IN+ALL;SG|cascóba
casco|N;IN+ESS;PL|cascókban
casco|N;IN+ESS;SG|cascóban
casco|N;INS;PL|cascókkal
casco|N;INS;SG|cascóval
casco|N;NOM;PL|cascók
casco|N;ON+ABL;PL|cascókról
casco|N;ON+ABL;SG|cascóról
casco|N;ON+ALL;PL|cascókra
casco|N;ON+ALL;SG|cascóra
casco|N;ON+ESS;PL|cascókon
casco|N;ON+ESS;SG|cascón
casco|N;PRP;PL|cascókért
casco|N;PRP;SG|cascóért
casco|N;TERM;PL|cascókig
casco|N;TERM;SG|cascóig
casco|N;TRANS;PL|cascókká
casco|N;TRANS;SG|cascóvá
céh|N;INS;SG|céhvel
céh|N;TRANS;SG|céhvé
cellux|N;INS;SG|celluxszal
cellux|N;TRANS;SG|celluxszá
centi|N;PSS1P;PL|centijeink
centi|N;PSS1S;PL|centijeim
centi|N;PSS2P;PL|centijeitek
centi|N;PSS2S;PL|centijeid
centi|N;PSS3P;PL|centijeik
centi|N;PSS3S;PL|centijei
cetli|N;PSS1P;PL|cetlijeink
cetli|N;PSS1S;PL|cetlijeim
cetli|N;PSS2P;PL|cetlijeitek
cetli|N;PSS2S;PL|cetlijeid
cetli|N;PSS3P;PL|cetlijeik
cetli|N;PSS3S;PL|cetlijei
chilei|N;PSS1P;PL|chileijeink
chilei|N;PSS1S;PL|chileijeim
chilei|N;PSS2P;PL|chileijeitek
chilei|N;PSS2S;PL|chileijeid
chilei|N;PSS3P;PL|chileijeik
chilei|N;PSS3S;PL|chileijei
cici|N;PSS1P;PL|cicijeink
cici|N;PSS1S;PL|cicijeim
cici|N;PSS2P;PL|cicijeitek
cici|N;PSS2S;PL|cicijeid
cici|N;PSS3P;PL|cicijeik
cici|N;PSS3S;PL|cicijei
cigi|N;PSS1P;PL|cigijeink
cigi|N;PSS1S;PL|cigijeim
cigi|N;PSS2P;PL|cigijeitek
cigi|N;PSS2S;PL|cigijeid
cigi|N;PSS3P;PL|cigijeik
cigi|N;PSS3S;PL|cigijei
cikcakk|N;FRML;SG|cikcakként
ciklohexán|N;ACC;SG|cyclohexánt
ciklohexán|N;AT+ABL;SG|cyclohexántól
ciklohexán|N;AT+ALL;SG|cyclohexánhoz
ciklohexán|N;AT+ESS;SG|cyclohexánnál
ciklohexán|N;DAT;SG|cyclohexánnak
ciklohexán|N;IN+ABL;SG|cyclohexánból
ciklohexán|N;IN+ALL;SG|cyclohexánba
ciklohexán|N;IN+ESS;SG|cyclohexánban
ciklohexán|N;INS;SG|cyclohexánnal
ciklohexán|N;ON+ABL;SG|cyclohexánról
ciklohexán|N;ON+ALL;SG|cyclohexánra
ciklohexán|N;PRP;SG|cyclohexánért
ciklohexán|N;TERM;SG|cyclohexánig
ciklohexán|N;TRANS;SG|cyclohexánná
címszó|N;ACC;SG|címszót
címszó|N;FRML;PL|címszókként
címzett|N;AT+ABL;SG|címzettől
cowboy|N;ACC;SG|cowboyt
cowboy|N;INS;SG|cowboyjal
cowboy|N;TRANS;SG|cowboyjá
cuki|N;PSS1P;PL|cukijaink
cuki|N;PSS1S;PL|cukijaim
cuki|N;PSS2P;PL|cukijaitok
cuki|N;PSS2S;PL|cukijaid
cuki|N;PSS3P;PL|cukijaik
cuki|N;PSS3S;PL|cukijai
cukkini|N;PSS1P;PL|cukkinijeink
cukkini|N;PSS1S;PL|cukkinijeim
cukkini|N;PSS2P;PL|cukkinijeitek
cukkini|N;PSS2S;PL|cukkinijeid
cukkini|N;PSS3P;PL|cukkinijeik
cukkini|N;PSS3S;PL|cukkinijei
cumi|N;PSS1P;PL|cumijaink
cumi|N;PSS1S;PL|cumijaim
cumi|N;PSS2P;PL|cumijaitok
cumi|N;PSS2S;PL|cumijaid
cumi|N;PSS3P;PL|cumijaik
cumi|N;PSS3S;PL|cumijai
cunami|N;PSS1P;PL|cunamijaink
cunami|N;PSS1S;PL|cunamijaim
cunami|N;PSS2P;PL|cunamijaitok
cunami|N;PSS2S;PL|cunamijaid
cunami|N;PSS3P;PL|cunamijaik
cunami|N;PSS3S;PL|cunamijai
családanya|N;PSS3P;SG|családanyjuk
családanya|N;PSS3S;SG|családanyja
családapa|N;PSS3P;SG|családapjuk
családapa|N;PSS3S;SG|családapja
csekk|N;FRML;SG|csekként
csi|N;PSS1P;PL|csijeink
csi|N;PSS1S;PL|csijeim
csi|N;PSS2P;PL|csijeitek
csi|N;PSS2S;PL|csijeid
csi|N;PSS3P;PL|csijeik
csi|N;PSS3S;PL|csijei
csili|N;PSS1P;PL|csilijeink
csili|N;PSS1S;PL|csilijeim
csili|N;PSS2P;PL|csilijeitek
csili|N;PSS2S;PL|csilijeid
csili|N;PSS3P;PL|csilijeik
csili|N;PSS3S;PL|csilijei
csín|N;ACC;SG|csínt
csín|N;PSS1S;SG|csínom
csín|N;PSS2P;SG|csínotok
csín|N;PSS2S;SG|csínod
csitri|N;PSS1P;PL|csitrijeink
csitri|N;PSS1S;PL|csitrijeim
csitri|N;PSS2P;PL|csitrijeitek
csitri|N;PSS2S;PL|csitrijeid
csitri|N;PSS3P;PL|csitrijeik
csitri|N;PSS3S;PL|csitrijei
csoki|N;PSS1P;PL|csokijaink
csoki|N;PSS1S;PL|csokijaim
csoki|N;PSS2P;PL|csokijaitok
csoki|N;PSS2S;PL|csokijaid
csoki|N;PSS3P;PL|csokijaik
csoki|N;PSS3S;PL|csokijai
csokoládényuszi|N;PSS1P;PL|csokoládényuszijaink
csokoládényuszi|N;PSS1S;PL|csokoládényuszijaim
csokoládényuszi|N;PSS2P;PL|csokoládényuszijaitok
csokoládényuszi|N;PSS2S;PL|csokoládényuszijaid
csokoládényuszi|N;PSS3P;PL|csokoládényuszijaik
csokoládényuszi|N;PSS3S;PL|csokoládényuszijai
cső|N;PSS2P;SG|csövetek
csönd|N;PSS2P;SG|csöndetek
csúzli|N;PSS1P;PL|csúzlijaink
csúzli|N;PSS1S;PL|csúzlijaim
csúzli|N;PSS2P;PL|csúzlijaitok
csúzli|N;PSS2S;PL|csúzlijaid
csúzli|N;PSS3P;PL|csúzlijaik
csúzli|N;PSS3S;PL|csúzlijai
dalmű|N;PSS2P;SG|dalművetek
damaszkuszi|N;PSS1P;PL|damaszkuszijaink
damaszkuszi|N;PSS1S;PL|damaszkuszijaim
damaszkuszi|N;PSS2P;PL|damaszkuszijaitok
damaszkuszi|N;PSS2S;PL|damaszkuszijaid
damaszkuszi|N;PSS3P;PL|damaszkuszijaik
damaszkuszi|N;PSS3S;PL|damaszkuszijai
dédanya|N;PSS3P;SG|dédanyjuk
dédanya|N;PSS3S;SG|dédanyja
dédi|N;PSS1P;PL|dédijeink
dédi|N;PSS1S;PL|dédijeim
dédi|N;PSS2P;PL|dédijeitek
dédi|N;PSS2S;PL|dédijeid
dédi|N;PSS3P;PL|dédijeik
dédi|N;PSS3S;PL|dédijei
dédnagyanya|N;PSS3P;SG|dédnagyanyjuk
dédnagyanya|N;PSS3S;SG|dédnagyanyja
dédnagyapa|N;PSS3P;SG|dédnagyapjuk
dédnagyapa|N;PSS3S;SG|dédnagyapja
dél-amerikai|N;PSS1P;PL|dél-amerikaijaink
dél-amerikai|N;PSS1S;PL|dél-amerikaijaim
dél-amerikai|N;PSS2P;PL|dél-amerikaijaitok
dél-amerikai|N;PSS2S;PL|dél-amerikaijaid
dél-amerikai|N;PSS3P;PL|dél-amerikaijaik
dél-amerikai|N;PSS3S;PL|dél-amerikaijai
délelőtt|N;AT+ABL;SG|délelőttől
derékszög|N;PSS2P;SG|derékszögetek
design|N;ACC;SG|designt
design|N;PSS1S;SG|designom
design|N;PSS2P;SG|designotok
design|N;PSS2S;SG|designod
dévadászi|N;PSS1P;PL|dévadászijaink
dévadászi|N;PSS1S;PL|dévadászijaim
dévadászi|N;PSS2P;PL|dévadászijaitok
dévadászi|N;PSS2S;PL|dévadászijaid
dévadászi|N;PSS3P;PL|dévadászijaik
dévadászi|N;PSS3S;PL|dévadászijai
dévanágari|N;PSS1P;PL|dévanágarijaink
dévanágari|N;PSS1S;PL|dévanágarijaim
dévanágari|N;PSS2P;PL|dévanágarijaitok
dévanágari|N;PSS2S;PL|dévanágarijaid
dévanágari|N;PSS3P;PL|dévanágarijaik
dévanágari|N;PSS3S;PL|dévanágarijai
dili|N;PSS1P;PL|dilijeink
dili|N;PSS1S;PL|dilijeim
dili|N;PSS2P;PL|dilijeitek
dili|N;PSS2S;PL|dilijeid
dili|N;PSS3P;PL|dilijeik
dili|N;PSS3S;PL|dilijei
dobjai|N;ACC;PL|dobjait
dobjai|N;AT+ABL;PL|dobjaitól
dobjai|N;AT+ALL;PL|dobjaihoz
dobjai|N;AT+ESS;PL|dobjainál
dobjai|N;DAT;PL|dobjainak
dobjai|N;FRML;PL|dobjaiként
dobjai|N;IN+ABL;PL|dobjaiból
dobjai|N;IN+ALL;PL|dobjaiba
dobjai|N;IN+ESS;PL|dobjaiban
dobjai|N;INS;PL|dobjaival
dobjai|N;NOM;PL|dobjai
dobjai|N;ON+ABL;PL|dobjairól
dobjai|N;ON+ALL;PL|dobjaira
dobjai|N;ON+ESS;PL|dobjain
dobjai|N;PRP;PL|dobjaiért
dobjai|N;TERM;PL|dobjaiig
dobjai|N;TRANS;PL|dobjaivá
doh|N;INS;SG|dohhal
doh|N;TRANS;SG|dohhá
doki|N;PSS1P;PL|dokijaink
doki|N;PSS1S;PL|dokijaim
doki|N;PSS2P;PL|dokijaitok
doki|N;PSS2S;PL|dokijaid
doki|N;PSS3P;PL|dokijaik
doki|N;PSS3S;PL|dokijai
dokk|N;FRML;SG|dokként
doksi|N;PSS1P;PL|doksijaink
doksi|N;PSS1S;PL|doksijaim
doksi|N;PSS2P;PL|doksijaitok
doksi|N;PSS2S;PL|doksijaid
doksi|N;PSS3P;PL|doksijaik
doksi|N;PSS3S;PL|doksijai
dolcsi|N;PSS1P;PL|dolcsijaink
dolcsi|N;PSS1S;PL|dolcsijaim
dolcsi|N;PSS2P;PL|dolcsijaitok
dolcsi|N;PSS2S;PL|dolcsijaid
dolcsi|N;PSS3P;PL|dolcsijaik
dolcsi|N;PSS3S;PL|dolcsijai
dolgozói|N;ACC;PL|dolgozóit
dolgozói|N;AT+ABL;PL|dolgozóitól
dolgozói|N;AT+ALL;PL|dolgozóihoz
dolgozói|N;AT+ESS;PL|dolgozóinál
dolgozói|N;DAT;PL|dolgozóinak
dolgozói|N;FRML;PL|dolgozóiként
dolgozói|N;IN+ABL;PL|dolgozóiból
dolgozói|N;IN+ALL;PL|dolgozóiba
dolgozói|N;IN+ESS;PL|dolgozóiban
dolgozói|N;INS;PL|dolgozóival
dolgozói|N;NOM;PL|dolgozói
dolgozói|N;ON+ABL;PL|dolgozóiról
dolgozói|N;ON+ALL;PL|dolgozóira
dolgozói|N;ON+ESS;PL|dolgozóin
dolgozói|N;PRP;PL|dolgozóiért
dolgozói|N;TERM;PL|dolgozóiig
dolgozói|N;TRANS;PL|dolgozóivá
dominikai|N;PSS1P;PL|dominikaijaink
dominikai|N;PSS1S;PL|dominikaijaim
dominikai|N;PSS2P;PL|dominikaijaitok
dominikai|N;PSS2S;PL|dominikaijaid
dominikai|N;PSS3P;PL|dominikaijaik
dominikai|N;PSS3S;PL|dominikaijai
drinápolyi|N;PSS1P;PL|drinápolyijaink
drinápolyi|N;PSS1S;PL|drinápolyijaim
drinápolyi|N;PSS2P;PL|drinápolyijaitok
drinápolyi|N;PSS2S;PL|drinápolyijaid
drinápolyi|N;PSS3P;PL|drinápolyijaik
drinápolyi|N;PSS3S;PL|drinápolyijai
duett|N;AT+ABL;SG|duettől
dutyi|N;PSS1P;PL|dutyijaink
dutyi|N;PSS1S;PL|dutyijaim
dutyi|N;PSS2P;PL|dutyijaitok
dutyi|N;PSS2S;PL|dutyijaid
dutyi|N;PSS3P;PL|dutyijaik
dutyi|N;PSS3S;PL|dutyijai
dzsámi|N;PSS1P;PL|dzsámijaink
dzsámi|N;PSS1S;PL|dzsámijaim
dzsámi|N;PSS2P;PL|dzsámijaitok
dzsámi|N;PSS2S;PL|dzsámijaid
dzsámi|N;PSS3P;PL|dzsámijaik
dzsámi|N;PSS3S;PL|dzsámijai
dzsentri|N;PSS1P;PL|dzsentrijeink
dzsentri|N;PSS1S;PL|dzsentrijeim
dzsentri|N;PSS2P;PL|dzsentrijeitek
dzsentri|N;PSS2S;PL|dzsentrijeid
dzsentri|N;PSS3P;PL|dzsentrijeik
dzsentri|N;PSS3S;PL|dzsentrijei
dzsinn|N;AT+ESS;SG|dzsinnél
dzsinn|N;DAT;SG|dzsinnek
dzsudogi|N;PSS1P;PL|dzsudogijaink
dzsudogi|N;PSS1S;PL|dzsudogijaim
dzsudogi|N;PSS2P;PL|dzsudogijaitok
dzsudogi|N;PSS2S;PL|dzsudogijaid
dzsudogi|N;PSS3P;PL|dzsudogijaik
dzsudogi|N;PSS3S;PL|dzsudogijai
édesanya|N;PSS3P;SG|édesanyjuk
édesanya|N;PSS3S;SG|édesanyja
édesapa|N;PSS3P;SG|édesapjuk
édesapa|N;PSS3S;SG|édesapja
ég-föld|N;ACC;PL|egeket-földeket
ég-föld|N;AT+ABL;PL|egektől-földektől
ég-föld|N;AT+ABL;SG|égtől-földtől
ég-föld|N;AT+ALL;PL|egekhez-földekhez
ég-föld|N;AT+ALL;SG|éghez-földhöz
ég-föld|N;AT+ESS;PL|egeknél-földeknél
ég-föld|N;AT+ESS;SG|égnél-földnél
ég-föld|N;DAT;PL|egeknek-földeknek
ég-föld|N;DAT;SG|égnek-földnek
ég-föld|N;IN+ABL;PL|egekből-földekből
ég-föld|N;IN+ABL;SG|égből-földből
ég-föld|N;IN+ALL;PL|egekbe-földekbe
ég-föld|N;IN+ALL;SG|égbe-földbe
ég-föld|N;IN+ESS;PL|egekben-földekben
ég-föld|N;IN+ESS;SG|égben-földben
ég-föld|N;INS;PL|egekkel-földekkel
ég-föld|N;INS;SG|éggel-földdel
ég-föld|N;NOM;PL|egek-földek
ég-föld|N;ON+ABL;PL|egekről-földekről
ég-föld|N;ON+ABL;SG|égről-földről
ég-föld|N;ON+ALL;PL|egekre-földekre
ég-föld|N;ON+ALL;SG|égre-földre
ég-föld|N;ON+ESS;PL|egeken-földeken
ég-föld|N;ON+ESS;SG|égen-földön
ég-föld|N;PRP;PL|egekért-földekért
ég-föld|N;PRP;SG|égért-földért
ég-föld|N;TERM;PL|egekig-földekig
ég-föld|N;TERM;SG|égig-földig
ég-föld|N;TRANS;PL|egekké-földekké
ég-föld|N;TRANS;SG|éggé-földdé
egérút|N;PSS1P;PL|egérútjaink
egérút|N;PSS1S;PL|egérútjaim
egérút|N;PSS2P;PL|egérútjaitok
egérút|N;PSS2S;PL|egérútjaid
egérút|N;PSS3P;PL|egérútjaik
egérút|N;PSS3P;SG|egérútjuk
egérút|N;PSS3S;PL|egérútjai
egérút|N;PSS3S;SG|egérútja
egészségügy|N;PSS2P;SG|egészségügyetek
égöv|N;PSS2P;SG|égövetek
egri|N;PSS1P;PL|egrijeink
egri|N;PSS1S;PL|egrijeim
egri|N;PSS2P;PL|egrijeitek
egri|N;PSS2S;PL|egrijeid
egri|N;PSS3P;PL|egrijeik
egri|N;PSS3S;PL|egrijei
egyenlítői|N;ACC;PL|egyenlítőit
egyenlítői|N;AT+ABL;PL|egyenlítőitől
egyenlítői|N;AT+ALL;PL|egyenlítőihez
egyenlítői|N;AT+ESS;PL|egyenlítőinél
egyenlítői|N;DAT;PL|egyenlítőinek
egyenlítői|N;FRML;PL|egyenlítőiként
egyenlítői|N;IN+ABL;PL|egyenlítőiből
egyenlítői|N;IN+ALL;PL|egyenlítőibe
egyenlítői|N;IN+ESS;PL|egyenlítőiben
egyenlítői|N;INS;PL|egyenlítőivel
egyenlítői|N;NOM;PL|egyenlítői
egyenlítői|N;ON+ABL;PL|egyenlítőiről
egyenlítői|N;ON+ALL;PL|egyenlítőire
egyenlítői|N;ON+ESS;PL|egyenlítőin
egyenlítői|N;PRP;PL|egyenlítőiért
egyenlítői|N;TERM;PL|egyenlítőiig
egyenlítői|N;TRANS;PL|egyenlítőivé
egyiptomi|N;PSS1P;PL|egyiptomijaink
egyiptomi|N;PSS1S;PL|egyiptomijaim
egyiptomi|N;PSS2P;PL|egyiptomijaitok
egyiptomi|N;PSS2S;PL|egyiptomijaid
egyiptomi|N;PSS3P;PL|egyiptomijaik
egyiptomi|N;PSS3S;PL|egyiptomijai
egységmátrix|N;INS;SG|egységmátrixszal
egységmátrix|N;TRANS;SG|egységmátrixszá
éh|N;INS;SG|éhhel
éh|N;TRANS;SG|éhhé
éjjel-nappali|N;PSS1P;PL|éjjel-nappalijaink
éjjel-nappali|N;PSS1S;PL|éjjel-nappalijaim
éjjel-nappali|N;PSS2P;PL|éjjel-nappalijaitok
éjjel-nappali|N;PSS2S;PL|éjjel-nappalijaid
éjjel-nappali|N;PSS3P;PL|éjjel-nappalijaik
éjjel-nappali|N;PSS3S;PL|éjjel-nappalijai
éjjeli|N;PSS1P;PL|éjjelijeink
éjjeli|N;PSS1S;PL|éjjelijeim
éjjeli|N;PSS2P;PL|éjjelijeitek
éjjeli|N;PSS2S;PL|éjjelijeid
éjjeli|N;PSS3P;PL|éjjelijeik
éjjeli|N;PSS3S;PL|éjjelijei
elektrosokk|N;FRML;SG|elektrosokként
elemi|N;PSS1P;PL|elemijeink
elemi|N;PSS1S;PL|elemijeim
elemi|N;PSS2P;PL|elemijeitek
elemi|N;PSS2S;PL|elemijeid
elemi|N;PSS3P;PL|elemijeik
elemi|N;PSS3S;PL|elemijei
életrajz|N;ACC;SG|életrajzot
előadói|N;ACC;PL|előadóit
előadói|N;AT+ABL;PL|előadóitól
előadói|N;AT+ALL;PL|előadóihoz
előadói|N;AT+ESS;PL|előadóinál
előadói|N;DAT;PL|előadóinak
előadói|N;FRML;PL|előadóiként
előadói|N;IN+ABL;PL|előadóiból
előadói|N;IN+ALL;PL|előadóiba
előadói|N;IN+ESS;PL|előadóiban
előadói|N;INS;PL|előadóival
előadói|N;NOM;PL|előadói
előadói|N;ON+ABL;PL|előadóiról
előadói|N;ON+ALL;PL|előadóira
előadói|N;ON+ESS;PL|előadóin
előadói|N;PRP;PL|előadóiért
előadói|N;TERM;PL|előadóiig
előadói|N;TRANS;PL|előadóivá
előfizetői|N;ACC;PL|előfizetőit
előfizetői|N;AT+ABL;PL|előfizetőitől
előfizetői|N;AT+ALL;PL|előfizetőihez
előfizetői|N;AT+ESS;PL|előfizetőinél
előfizetői|N;DAT;PL|előfizetőinek
előfizetői|N;FRML;PL|előfizetőiként
előfizetői|N;IN+ABL;PL|előfizetőiből
előfizetői|N;IN+ALL;PL|előfizetőibe
előfizetői|N;IN+ESS;PL|előfizetőiben
előfizetői|N;INS;PL|előfizetőivel
előfizetői|N;NOM;PL|előfizetői
előfizetői|N;ON+ABL;PL|előfizetőiről
előfizetői|N;ON+ALL;PL|előfizetőire
előfizetői|N;ON+ESS;PL|előfizetőin
előfizetői|N;PRP;PL|előfizetőiért
előfizetői|N;TERM;PL|előfizetőiig
előfizetői|N;TRANS;PL|előfizetőivé
elsőbb|N;IN+ABL;SG|elsőbből
elsőbb|N;IN+ALL;SG|elsőbbe
elsőbb|N;IN+ESS;SG|elsőbben
ementáli|N;PSS1P;PL|ementálijaink
ementáli|N;PSS1S;PL|ementálijaim
ementáli|N;PSS2P;PL|ementálijaitok
ementáli|N;PSS2S;PL|ementálijaid
ementáli|N;PSS3P;PL|ementálijaik
ementáli|N;PSS3S;PL|ementálijai
emeszai|N;PSS1P;PL|emeszaijaink
emeszai|N;PSS1S;PL|emeszaijaim
emeszai|N;PSS2P;PL|emeszaijaitok
emeszai|N;PSS2S;PL|emeszaijaid
emeszai|N;PSS3P;PL|emeszaijaik
emeszai|N;PSS3S;PL|emeszaijai
emlékmű|N;PSS2P;SG|emlékművetek
emodzsi|N;PSS1P;PL|emodzsijaink
emodzsi|N;PSS1S;PL|emodzsijaim
emodzsi|N;PSS2P;PL|emodzsijaitok
emodzsi|N;PSS2S;PL|emodzsijaid
emodzsi|N;PSS3P;PL|emodzsijaik
emodzsi|N;PSS3S;PL|emodzsijai
enn|N;AT+ESS;SG|ennél
enn|N;DAT;SG|ennek
epekő|N;PSS2P;SG|epekövetek
erdei|N;ACC;PL|erdeit
erdei|N;AT+ABL;PL|erdeitől
erdei|N;AT+ALL;PL|erdeihez
erdei|N;AT+ESS;PL|erdeinél
erdei|N;DAT;PL|erdeinek
erdei|N;FRML;PL|erdeiként
erdei|N;IN+ABL;PL|erdeiből
erdei|N;IN+ALL;PL|erdeibe
erdei|N;IN+ESS;PL|erdeiben
erdei|N;INS;PL|erdeivel
erdei|N;NOM;PL|erdei
erdei|N;ON+ABL;PL|erdeiről
erdei|N;ON+ALL;PL|erdeire
erdei|N;ON+ESS;PL|erdein
erdei|N;PRP;PL|erdeiért
erdei|N;TERM;PL|erdeiig
erdei|N;TRANS;PL|erdeivé
erdélyi|N;PSS1P;PL|erdélyijeink
erdélyi|N;PSS1S;PL|erdélyijeim
erdélyi|N;PSS2P;PL|erdélyijeitek
erdélyi|N;PSS2S;PL|erdélyijeid
erdélyi|N;PSS3P;PL|erdélyijeik
erdélyi|N;PSS3S;PL|erdélyijei
erdőtűz|N;AT+ALL;SG|erdőtűzhez
erdőtűz|N;ON+ESS;SG|erdőtűzen
erdőtűz|N;PSS2P;SG|erdőtüzetek
eredeti|N;PSS1P;PL|eredetijeink
eredeti|N;PSS1S;PL|eredetijeim
eredeti|N;PSS2P;PL|eredetijeitek
eredeti|N;PSS2S;PL|eredetijeid
eredeti|N;PSS3P;PL|eredetijeik
eredeti|N;PSS3S;PL|eredetijei
érettségizett|N;AT+ABL;SG|érettségizettől
érintett|N;AT+ABL;SG|érintettől
erőmű|N;PSS2P;SG|erőművetek
err|N;ON+ABL;SG|erről
err|N;ON+ALL;SG|erre
esküdt|N;PSS2P;SG|esküdtetek
esküvői|N;ACC;PL|esküvőit
esküvői|N;AT+ABL;PL|esküvőitől
esküvői|N;AT+ALL;PL|esküvőihez
esküvői|N;AT+ESS;PL|esküvőinél
esküvői|N;DAT;PL|esküvőinek
esküvői|N;FRML;PL|esküvőiként
esküvői|N;IN+ABL;PL|esküvőiből
esküvői|N;IN+ALL;PL|esküvőibe
esküvői|N;IN+ESS;PL|esküvőiben
esküvői|N;INS;PL|esküvőivel
esküvői|N;NOM;PL|esküvői
esküvői|N;ON+ABL;PL|esküvőiről
esküvői|N;ON+ALL;PL|esküvőire
esküvői|N;ON+ESS;PL|esküvőin
esküvői|N;PRP;PL|esküvőiért
esküvői|N;TERM;PL|esküvőiig
esküvői|N;TRANS;PL|esküvőivé
estélyi|N;PSS1P;PL|estélyijeink
estélyi|N;PSS1S;PL|estélyijeim
estélyi|N;PSS2P;PL|estélyijeitek
estélyi|N;PSS2S;PL|estélyijeid
estélyi|N;PSS3P;PL|estélyijeik
estélyi|N;PSS3S;PL|estélyijei
északi|N;PSS1P;PL|északijaink
északi|N;PSS1S;PL|északijaim
északi|N;PSS2P;PL|északijaitok
északi|N;PSS2S;PL|északijaid
északi|N;PSS3P;PL|északijaik
északi|N;PSS3S;PL|északijai
etikett|N;AT+ABL;SG|etikettől
étkezőkocsi|N;PSS1P;PL|étkezőkocsijaink
étkezőkocsi|N;PSS1S;PL|étkezőkocsijaim
étkezőkocsi|N;PSS2P;PL|étkezőkocsijaitok
étkezőkocsi|N;PSS2S;PL|étkezőkocsijaid
étkezőkocsi|N;PSS3P;PL|étkezőkocsijaik
étkezőkocsi|N;PSS3S;PL|étkezőkocsijai
étolaj|N;ACC;SG|étolajat
eurázsiai|N;PSS1P;PL|eurázsiaijaink
eurázsiai|N;PSS1S;PL|eurázsiaijaim
eurázsiai|N;PSS2P;PL|eurázsiaijaitok
eurázsiai|N;PSS2S;PL|eurázsiaijaid
eurázsiai|N;PSS3P;PL|eurázsiaijaik
eurázsiai|N;PSS3S;PL|eurázsiaijai
európai|N;PSS1P;PL|európaijaink
európai|N;PSS1S;PL|európaijaim
európai|N;PSS2P;PL|európaijaitok
európai|N;PSS2S;PL|európaijaid
európai|N;PSS3P;PL|európaijaik
európai|N;PSS3S;PL|európaijai
eurós|N;ACC;SG|eurósot
ex|N;INS;SG|exszel
ex|N;TRANS;SG|exszé
fagott|N;AT+ABL;SG|fagottól
fagyi|N;PSS1P;PL|fagyijaink
fagyi|N;PSS1S;PL|fagyijaim
fagyi|N;PSS2P;PL|fagyijaitok
fagyi|N;PSS2S;PL|fagyijaid
fagyi|N;PSS3P;PL|fagyijaik
fagyi|N;PSS3S;PL|fagyijai
fahíd|N;PSS1P;PL|fahídjaink
fahíd|N;PSS1S;PL|fahídjaim
fahíd|N;PSS2P;PL|fahídjaitok
fahíd|N;PSS2S;PL|fahídjaid
fahíd|N;PSS3P;PL|fahídjaik
fahíd|N;PSS3P;SG|fahídjuk
fahíd|N;PSS3S;PL|fahídjai
fahíd|N;PSS3S;SG|fahídja
fáid|N;ACC;PL|fáidat
fáid|N;AT+ABL;PL|fáidtól
fáid|N;AT+ALL;PL|fáidhoz
fáid|N;AT+ESS;PL|fáidnál
fáid|N;DAT;PL|fáidnak
fáid|N;FRML;PL|fáidként
fáid|N;IN+ABL;PL|fáidból
fáid|N;IN+ALL;PL|fáidba
fáid|N;IN+ESS;PL|fáidban
fáid|N;INS;PL|fáiddal
fáid|N;NOM;PL|fáid
fáid|N;ON+ABL;PL|fáidról
fáid|N;ON+ALL;PL|fáidra
fáid|N;ON+ESS;PL|fáidon
fáid|N;PRP;PL|fáidért
fáid|N;TERM;PL|fáidig
fáid|N;TRANS;PL|fáiddá
falai|N;ACC;PL|falait
falai|N;AT+ABL;PL|falaitól
falai|N;AT+ALL;PL|falaihoz
falai|N;AT+ESS;PL|falainál
falai|N;DAT;PL|falainak
falai|N;FRML;PL|falaiként
falai|N;IN+ABL;PL|falaiból
falai|N;IN+ALL;PL|falaiba
falai|N;IN+ESS;PL|falaiban
falai|N;INS;PL|falaival
falai|N;NOM;PL|falai
falai|N;ON+ABL;PL|falairól
falai|N;ON+ALL;PL|falaira
falai|N;ON+ESS;PL|falain
falai|N;PRP;PL|falaiért
falai|N;TERM;PL|falaiig
falai|N;TRANS;PL|falaivá
fals|N;ACC;SG|falsot
falusi|N;PSS1P;PL|falusijaink
falusi|N;PSS1S;PL|falusijaim
falusi|N;PSS2P;PL|falusijaitok
falusi|N;PSS2S;PL|falusijaid
falusi|N;PSS3P;PL|falusijaik
falusi|N;PSS3S;PL|falusijai
fatörzs|N;PSS2P;SG|fatörzsetek
fax|N;INS;SG|faxszal
fax|N;TRANS;SG|faxszá
fejlesztői|N;ACC;PL|fejlesztőit
fejlesztői|N;AT+ABL;PL|fejlesztőitől
fejlesztői|N;AT+ALL;PL|fejlesztőihez
fejlesztői|N;AT+ESS;PL|fejlesztőinél
fejlesztői|N;DAT;PL|fejlesztőinek
fejlesztői|N;FRML;PL|fejlesztőiként
fejlesztői|N;IN+ABL;PL|fejlesztőiből
fejlesztői|N;IN+ALL;PL|fejlesztőibe
fejlesztői|N;IN+ESS;PL|fejlesztőiben
fejlesztői|N;INS;PL|fejlesztőivel
fejlesztői|N;NOM;PL|fejlesztői
fejlesztői|N;ON+ABL;PL|fejlesztőiről
fejlesztői|N;ON+ALL;PL|fejlesztőire
fejlesztői|N;ON+ESS;PL|fejlesztőin
fejlesztői|N;PRP;PL|fejlesztőiért
fejlesztői|N;TERM;PL|fejlesztőiig
fejlesztői|N;TRANS;PL|fejlesztőivé
feketebors|N;ACC;SG|feketeborsot
felnőtt|N;AT+ABL;SG|felnőttől
felnőtt|N;PSS2P;SG|felnőttetek
felvételi|N;PSS1P;PL|felvételijeink
felvételi|N;PSS1S;PL|felvételijeim
felvételi|N;PSS2P;PL|felvételijeitek
felvételi|N;PSS2S;PL|felvételijeid
felvételi|N;PSS3P;PL|felvételijeik
felvételi|N;PSS3S;PL|felvételijei
felvonóhíd|N;PSS1P;PL|felvonóhídjaink
felvonóhíd|N;PSS1S;PL|felvonóhídjaim
felvonóhíd|N;PSS2P;PL|felvonóhídjaitok
felvonóhíd|N;PSS2S;PL|felvonóhídjaid
felvonóhíd|N;PSS3P;PL|felvonóhídjaik
felvonóhíd|N;PSS3P;SG|felvonóhídjuk
felvonóhíd|N;PSS3S;PL|felvonóhídjai
felvonóhíd|N;PSS3S;SG|felvonóhídja
fémháromszög|N;PSS2P;SG|fémháromszögetek
fennsík|N;ACC;SG|fennsíkot
fennsík|N;PSS1S;SG|fennsíkom
fennsík|N;PSS2P;SG|fennsíkotok
fennsík|N;PSS2S;SG|fennsíkod
fénycső|N;PSS2P;SG|fénycsövetek
fényrúd|N;PSS1P;PL|fényrúdjaink
fényrúd|N;PSS1S;PL|fényrúdjaim
fényrúd|N;PSS2P;PL|fényrúdjaitok
fényrúd|N;PSS2S;PL|fényrúdjaid
fényrúd|N;PSS3P;PL|fényrúdjaik
fényrúd|N;PSS3P;SG|fényrúdjuk
fényrúd|N;PSS3S;PL|fényrúdjai
fényrúd|N;PSS3S;SG|fényrúdja
feröeri|N;PSS1P;PL|feröerijeink
feröeri|N;PSS1S;PL|feröerijeim
feröeri|N;PSS2P;PL|feröerijeitek
feröeri|N;PSS2S;PL|feröerijeid
feröeri|N;PSS3P;PL|feröerijeik
feröeri|N;PSS3S;PL|feröerijei
festői|N;ACC;PL|festőit
festői|N;AT+ABL;PL|festőitől
festői|N;AT+ALL;PL|festőihez
festői|N;AT+ESS;PL|festőinél
festői|N;DAT;PL|festőinek
festői|N;FRML;PL|festőiként
festői|N;IN+ABL;PL|festőiből
festői|N;IN+ALL;PL|festőibe
festői|N;IN+ESS;PL|festőiben
festői|N;INS;PL|festőivel
festői|N;NOM;PL|festői
festői|N;ON+ABL;PL|festőiről
festői|N;ON+ALL;PL|festőire
festői|N;ON+ESS;PL|festőin
festői|N;PRP;PL|festőiért
festői|N;TERM;PL|festőiig
festői|N;TRANS;PL|festőivé
fi|N;PSS1P;PL|fiaink
fi|N;PSS1S;PL|fiaim
fi|N;PSS2P;PL|fiaitok
fi|N;PSS2S;PL|fiaid
fi|N;PSS3P;PL|fiaik
fi|N;PSS3S;PL|fiai
fiai|N;ACC;PL|fiait
fiai|N;AT+ABL;PL|fiaitól
fiai|N;AT+ALL;PL|fiaihoz
fiai|N;AT+ESS;PL|fiainál
fiai|N;DAT;PL|fiainak
fiai|N;FRML;PL|fiaiként
fiai|N;IN+ABL;PL|fiaiból
fiai|N;IN+ALL;PL|fiaiba
fiai|N;IN+ESS;PL|fiaiban
fiai|N;INS;PL|fiaival
fiai|N;NOM;PL|fiai
fiai|N;ON+ABL;PL|fiairól
fiai|N;ON+ALL;PL|fiaira
fiai|N;ON+ESS;PL|fiain
fiai|N;PRP;PL|fiaiért
fiai|N;TERM;PL|fiaiig
fiai|N;TRANS;PL|fiaivá
fing|N;ACC;SG|fingot
fing|N;PSS1S;SG|fingom
fing|N;PSS2P;SG|fingotok
fing|N;PSS2S;SG|fingod
finn|N;AT+ESS;SG|finnél
finn|N;DAT;SG|finnek
fix|N;INS;SG|fixszel
fix|N;TRANS;SG|fixszé
flex|N;INS;SG|flexszel
flex|N;TRANS;SG|flexszé
flopi|N;PSS1P;PL|flopijaink
flopi|N;PSS1S;PL|flopijaim
flopi|N;PSS2P;PL|flopijaitok
flopi|N;PSS2S;PL|flopijaid
flopi|N;PSS3P;PL|flopijaik
flopi|N;PSS3S;PL|flopijai
foci|N;PSS1P;PL|focijaink
foci|N;PSS1S;PL|focijaim
foci|N;PSS2P;PL|focijaitok
foci|N;PSS2S;PL|focijaid
foci|N;PSS3P;PL|focijaik
foci|N;PSS3S;PL|focijai
foglalkoztatott|N;AT+ABL;SG|foglalkoztatottól
fogvatartott|N;AT+ABL;SG|fogvatartottól
fogyasztói|N;ACC;PL|fogyasztóit
fogyasztói|N;AT+ABL;PL|fogyasztóitól
fogyasztói|N;AT+ALL;PL|fogyasztóihoz
fogyasztói|N;AT+ESS;PL|fogyasztóinál
fogyasztói|N;DAT;PL|fogyasztóinak
fogyasztói|N;FRML;PL|fogyasztóiként
fogyasztói|N;IN+ABL;PL|fogyasztóiból
fogyasztói|N;IN+ALL;PL|fogyasztóiba
fogyasztói|N;IN+ESS;PL|fogyasztóiban
fogyasztói|N;INS;PL|fogyasztóival
fogyasztói|N;NOM;PL|fogyasztói
fogyasztói|N;ON+ABL;PL|fogyasztóiról
fogyasztói|N;ON+ALL;PL|fogyasztóira
fogyasztói|N;ON+ESS;PL|fogyasztóin
fogyasztói|N;PRP;PL|fogyasztóiért
fogyasztói|N;TERM;PL|fogyasztóiig
fogyasztói|N;TRANS;PL|fogyasztóivá
forgatókönyv|N;PSS2P;SG|forgatókönyvetek
forrásvíz|N;AT+ABL;SG|forrászvíztől
forrásvíz|N;AT+ALL;SG|forrászvízhez
forrásvíz|N;AT+ESS;SG|forrászvíznél
forrásvíz|N;DAT;SG|forrászvíznek
forrásvíz|N;FRML;SG|forrászvízként
forrásvíz|N;IN+ABL;SG|forrászvízből
forrásvíz|N;IN+ALL;SG|forrászvízbe
forrásvíz|N;IN+ESS;SG|forrászvízben
forrásvíz|N;INS;SG|forrászvízzel
forrásvíz|N;ON+ABL;SG|forrászvízről
forrásvíz|N;ON+ALL;SG|forrászvízre
forrásvíz|N;ON+ESS;SG|forrászvízen
forrásvíz|N;PRP;SG|forrászvízért
forrásvíz|N;TERM;SG|forrászvízig
forrásvíz|N;TRANS;SG|forrászvízzé
foxtrott|N;AT+ABL;SG|foxtrottól
föl|N;ACC;SG|fölt
föl|N;PSS2P;SG|föletek
föld|N;PSS2P;SG|földetek
földi|N;PSS1P;PL|földijeink
földi|N;PSS1S;PL|földijeim
földi|N;PSS2P;PL|földijeitek
földi|N;PSS2S;PL|földijeid
földi|N;PSS3P;PL|földijeik
földi|N;PSS3S;PL|földijei
földrajz|N;ACC;SG|földrajzot
földút|N;PSS1P;PL|földútjaink
földút|N;PSS1S;PL|földútjaim
földút|N;PSS2P;PL|földútjaitok
földút|N;PSS2S;PL|földútjaid
földút|N;PSS3P;PL|földútjaik
földút|N;PSS3P;SG|földútjuk
földút|N;PSS3S;PL|földútjai
földút|N;PSS3S;SG|földútja
főmufti|N;PSS1P;PL|főmuftijaink
főmufti|N;PSS1S;PL|főmuftijaim
főmufti|N;PSS2P;PL|főmuftijaitok
főmufti|N;PSS2S;PL|főmuftijaid
főmufti|N;PSS3P;PL|főmuftijaik
főmufti|N;PSS3S;PL|főmuftijai
föníciai|N;PSS1P;PL|föníciaijaink
föníciai|N;PSS1S;PL|föníciaijaim
föníciai|N;PSS2P;PL|föníciaijaitok
föníciai|N;PSS2S;PL|föníciaijaid
föníciai|N;PSS3P;PL|föníciaijaik
föníciai|N;PSS3S;PL|föníciaijai
főnix|N;INS;SG|főnixszel
főnix|N;TRANS;SG|főnixszé
főút|N;PSS1P;PL|főútjaink
főút|N;PSS1S;PL|főútjaim
főút|N;PSS2P;PL|főútjaitok
főút|N;PSS2S;PL|főútjaid
főút|N;PSS3P;PL|főútjaik
főút|N;PSS3P;SG|főútjuk
főút|N;PSS3S;PL|főútjai
főút|N;PSS3S;SG|főútja
fővárosi|N;PSS1P;PL|fővárosijaink
fővárosi|N;PSS1S;PL|fővárosijaim
fővárosi|N;PSS2P;PL|fővárosijaitok
fővárosi|N;PSS2S;PL|fővárosijaid
fővárosi|N;PSS3P;PL|fővárosijaik
fővárosi|N;PSS3S;PL|fővárosijai
friuli|N;PSS1P;PL|friulijaink
friuli|N;PSS1S;PL|friulijaim
friuli|N;PSS2P;PL|friulijaitok
friuli|N;PSS2S;PL|friulijaid
friuli|N;PSS3P;PL|friulijaik
friuli|N;PSS3S;PL|friulijai
frufru|N;PSS1P;PL|frufrujaink
frufru|N;PSS1S;PL|frufrujaim
frufru|N;PSS2P;PL|frufrujaitok
frufru|N;PSS2S;PL|frufrujaid
frufru|N;PSS3P;PL|frufrujaik
frufru|N;PSS3S;PL|frufrujai
futótűz|N;PSS2P;SG|futótüzetek
fű-fa|N;ACC;SG|fűt-fát
fű-fa|N;AT+ABL;SG|fűtől-fától
fű-fa|N;AT+ALL;SG|fűhöz-fához
fű-fa|N;AT+ESS;SG|fűnél-fánál
fű-fa|N;DAT;SG|fűnek-fának
fű-fa|N;IN+ABL;SG|fűből-fából
fű-fa|N;IN+ALL;SG|fűbe-fába
fű-fa|N;IN+ESS;SG|fűben-fában
fű-fa|N;INS;SG|fűvel-fával
fű-fa|N;ON+ABL;SG|fűről-fáról
fű-fa|N;ON+ALL;SG|fűre-fára
fű-fa|N;ON+ESS;SG|fűn-fán
fű-fa|N;PRP;SG|fűért-fáért
fű-fa|N;TERM;SG|fűig-fáig
fű-fa|N;TRANS;SG|fűvé-fává
fű|N;PSS2P;SG|füvetek
függőhíd|N;PSS1P;PL|függőhídjaink
függőhíd|N;PSS1S;PL|függőhídjaim
függőhíd|N;PSS2P;PL|függőhídjaitok
függőhíd|N;PSS2S;PL|függőhídjaid
függőhíd|N;PSS3P;PL|függőhídjaik
függőhíd|N;PSS3P;SG|függőhídjuk
függőhíd|N;PSS3S;PL|függőhídjai
függőhíd|N;PSS3S;SG|függőhídja
fül|N;PSS2P;SG|fületek
fültő|N;PSS2P;SG|fültövetek
fürj|N;PSS2P;SG|fürjetek
fűz|N;PSS2P;SG|füzetek
galeri|N;PSS1P;PL|galerijaink
galeri|N;PSS1S;PL|galerijaim
galeri|N;PSS2P;PL|galerijaitok
galeri|N;PSS2S;PL|galerijaid
galeri|N;PSS3P;PL|galerijaik
galeri|N;PSS3S;PL|galerijai
gaztett|N;AT+ABL;SG|gaztettől
geci|N;PSS1P;PL|gecijeink
geci|N;PSS1S;PL|gecijeim
geci|N;PSS2P;PL|gecijeitek
geci|N;PSS2S;PL|gecijeid
geci|N;PSS3P;PL|gecijeik
geci|N;PSS3S;PL|gecijei
gémeskút|N;PSS1P;PL|gémeskútjaink
gémeskút|N;PSS1S;PL|gémeskútjaim
gémeskút|N;PSS2P;PL|gémeskútjaitok
gémeskút|N;PSS2S;PL|gémeskútjaid
gémeskút|N;PSS3P;PL|gémeskútjaik
gémeskút|N;PSS3P;SG|gémeskútjuk
gémeskút|N;PSS3S;PL|gémeskútjai
gémeskút|N;PSS3S;SG|gémeskútja
genfi|N;PSS1P;PL|genfijeink
genfi|N;PSS1S;PL|genfijeim
genfi|N;PSS2P;PL|genfijeitek
genfi|N;PSS2S;PL|genfijeid
genfi|N;PSS3P;PL|genfijeik
genfi|N;PSS3S;PL|genfijei
gépkocsi|N;PSS1P;PL|gépkocsijaink
gépkocsi|N;PSS1S;PL|gépkocsijaim
gépkocsi|N;PSS2P;PL|gépkocsijaitok
gépkocsi|N;PSS2S;PL|gépkocsijaid
gépkocsi|N;PSS3P;PL|gépkocsijaik
gépkocsi|N;PSS3S;PL|gépkocsijai
ghánai|N;PSS1P;PL|ghánaijaink
ghánai|N;PSS1S;PL|ghánaijaim
ghánai|N;PSS2P;PL|ghánaijaitok
ghánai|N;PSS2S;PL|ghánaijaid
ghánai|N;PSS3P;PL|ghánaijaik
ghánai|N;PSS3S;PL|ghánaijai
gimi|N;PSS1P;PL|gimijeink
gimi|N;PSS1S;PL|gimijeim
gimi|N;PSS2P;PL|gimijeitek
gimi|N;PSS2S;PL|gimijeid
gimi|N;PSS3P;PL|gimijeik
gimi|N;PSS3S;PL|gimijei
go|N;ACC;PL|gókat
go|N;ACC;SG|gót
go|N;AT+ABL;PL|góktól
go|N;AT+ABL;SG|gótól
go|N;AT+ALL;PL|gókhoz
go|N;AT+ALL;SG|góhoz
go|N;AT+ESS;PL|góknál
go|N;AT+ESS;SG|gónál
go|N;DAT;PL|góknak
go|N;DAT;SG|gónak
go|N;FRML;PL|gókként
go|N;FRML;SG|góként
go|N;IN+ABL;PL|gókból
go|N;IN+ABL;SG|góból
go|N;IN+ALL;PL|gókba
go|N;IN+ALL;SG|góba
go|N;IN+ESS;PL|gókban
go|N;IN+ESS;SG|góban
go|N;INS;PL|gókkal
go|N;INS;SG|góval
go|N;NOM;PL|gók
go|N;ON+ABL;PL|gókról
go|N;ON+ABL;SG|góról
go|N;ON+ALL;PL|gókra
go|N;ON+ALL;SG|góra
go|N;ON+ESS;PL|gókon
go|N;ON+ESS;SG|gón
go|N;PRP;PL|gókért
go|N;PRP;SG|góért
go|N;PSS1P;PL|góink
go|N;PSS1P;SG|gónk
go|N;PSS1S;PL|góim
go|N;PSS1S;SG|góm
go|N;PSS2P;PL|góitok
go|N;PSS2P;SG|gótok
go|N;PSS2S;PL|góid
go|N;PSS2S;SG|gód
go|N;PSS3P;PL|góik
go|N;PSS3P;SG|gójuk
go|N;PSS3S;PL|gói
go|N;PSS3S;SG|gója
go|N;TERM;PL|gókig
go|N;TERM;SG|góig
go|N;TRANS;PL|gókká
go|N;TRANS;SG|góvá
gólyaorr|N;ACC;SG|gólyaorrot
gólyaorr|N;ON+ABL;SG|gólyaorról
gólyaorr|N;ON+ALL;SG|gólyaorra
gombaféle|N;ACC;PL|gombaféléket
gombaféle|N;AT+ABL;PL|gombaféléktől
gombaféle|N;AT+ALL;PL|gombafélékhez
gombaféle|N;AT+ESS;PL|gombaféléknél
gombaféle|N;DAT;PL|gombaféléknek
gombaféle|N;IN+ABL;PL|gombafélékből
gombaféle|N;IN+ALL;PL|gombafélékbe
gombaféle|N;IN+ESS;PL|gombafélékben
gombaféle|N;INS;PL|gombafélékkel
gombaféle|N;ON+ABL;PL|gombafélékről
gombaféle|N;ON+ALL;PL|gombafélékre
gombaféle|N;ON+ESS;PL|gombaféléken
gombaféle|N;TRANS;PL|gombafélékké
gondozott|N;AT+ABL;SG|gondozottól
gonosztett|N;AT+ABL;SG|gonosztettől
górcső|N;PSS2P;SG|górcsövetek
gudzsaráti|N;PSS1P;PL|gudzsarátijaink
gudzsaráti|N;PSS1S;PL|gudzsarátijaim
gudzsaráti|N;PSS2P;PL|gudzsarátijaitok
gudzsaráti|N;PSS2S;PL|gudzsarátijaid
gudzsaráti|N;PSS3P;PL|gudzsarátijaik
gudzsaráti|N;PSS3S;PL|gudzsarátijai
gumi|N;PSS1P;PL|gumijaink
gumi|N;PSS1S;PL|gumijaim
gumi|N;PSS2P;PL|gumijaitok
gumi|N;PSS2S;PL|gumijaid
gumi|N;PSS3P;PL|gumijaik
gumi|N;PSS3S;PL|gumijai
gurui|N;ACC;PL|guruit
gurui|N;AT+ABL;PL|guruitól
gurui|N;AT+ALL;PL|guruihoz
gurui|N;AT+ESS;PL|guruinál
gurui|N;DAT;PL|guruinak
gurui|N;FRML;PL|guruiként
gurui|N;IN+ABL;PL|guruiból
gurui|N;IN+ALL;PL|guruiba
gurui|N;IN+ESS;PL|guruiban
gurui|N;INS;PL|guruival
gurui|N;NOM;PL|gurui
gurui|N;ON+ABL;PL|guruiról
gurui|N;ON+ALL;PL|guruira
gurui|N;ON+ESS;PL|guruin
gurui|N;PRP;PL|guruiért
gurui|N;TERM;PL|guruiig
gurui|N;TRANS;PL|guruivá
gyakorlat|N;PSS1P;PL|gyarkorlataink
gyakorlat|N;PSS1P;SG|gyarkorlatunk
gyakorlat|N;PSS1S;PL|gyarkorlataim
gyakorlat|N;PSS1S;SG|gyarkorlatom
gyakorlat|N;PSS2P;PL|gyarkorlataitok
gyakorlat|N;PSS2P;SG|gyarkorlatotok
gyakorlat|N;PSS2S;PL|gyarkorlataid
gyakorlat|N;PSS2S;SG|gyarkorlatod
gyakorlat|N;PSS3P;PL|gyarkorlataik
gyakorlat|N;PSS3P;SG|gyarkorlatuk
gyakorlat|N;PSS3S;PL|gyarkorlatai
gyakorlat|N;PSS3S;SG|gyarkorlata
gyanúsított|N;AT+ABL;SG|gyanúsítottól
gyászmise|N;ACC;PL|gyászmiséket
gyászmise|N;AT+ABL;PL|gyászmiséktől
gyászmise|N;AT+ALL;PL|gyászmisékhez
gyászmise|N;AT+ESS;PL|gyászmiséknél
gyászmise|N;DAT;PL|gyászmiséknek
gyászmise|N;IN+ABL;PL|gyászmisékből
gyászmise|N;IN+ALL;PL|gyászmisékbe
gyászmise|N;IN+ESS;PL|gyászmisékben
gyászmise|N;INS;PL|gyászmisékkel
gyászmise|N;ON+ABL;PL|gyászmisékről
gyászmise|N;ON+ALL;PL|gyászmisékre
gyászmise|N;ON+ESS;PL|gyászmiséken
gyászmise|N;TRANS;PL|gyászmisékké
gyógyfű|N;PSS2P;SG|gyógyfüvetek
gyors|N;ACC;SG|gyorsot
hajgumi|N;PSS1P;PL|hajgumijaink
hajgumi|N;PSS1S;PL|hajgumijaim
hajgumi|N;PSS2P;PL|hajgumijaitok
hajgumi|N;PSS2S;PL|hajgumijaid
hajgumi|N;PSS3P;PL|hajgumijaik
hajgumi|N;PSS3S;PL|hajgumijai
hajlakk|N;FRML;SG|hajlakként
hajótörött|N;AT+ABL;SG|hajótöröttől
hajótörött|N;PSS2P;SG|hajótöröttetek
hajszálcső|N;PSS2P;SG|hajszálcsövetek
hallgatói|N;ACC;PL|hallgatóit
hallgatói|N;AT+ABL;PL|hallgatóitól
hallgatói|N;AT+ALL;PL|hallgatóihoz
hallgatói|N;AT+ESS;PL|hallgatóinál
hallgatói|N;DAT;PL|hallgatóinak
hallgatói|N;FRML;PL|hallgatóiként
hallgatói|N;IN+ABL;PL|hallgatóiból
hallgatói|N;IN+ALL;PL|hallgatóiba
hallgatói|N;IN+ESS;PL|hallgatóiban
hallgatói|N;INS;PL|hallgatóival
hallgatói|N;NOM;PL|hallgatói
hallgatói|N;ON+ABL;PL|hallgatóiról
hallgatói|N;ON+ALL;PL|hallgatóira
hallgatói|N;ON+ESS;PL|hallgatóin
hallgatói|N;PRP;PL|hallgatóiért
hallgatói|N;TERM;PL|hallgatóiig
hallgatói|N;TRANS;PL|hallgatóivá
hálókocsi|N;PSS1P;PL|hálókocsijaink
hálókocsi|N;PSS1S;PL|hálókocsijaim
hálókocsi|N;PSS2P;PL|hálókocsijaitok
hálókocsi|N;PSS2S;PL|hálókocsijaid
hálókocsi|N;PSS3P;PL|hálókocsijaik
hálókocsi|N;PSS3S;PL|hálókocsijai
hálóköntös|N;ACC;SG|hálóköntösöt
halott|N;AT+ABL;SG|halottól
halottaskocsi|N;PSS1P;PL|halottaskocsijaink
halottaskocsi|N;PSS1S;PL|halottaskocsijaim
halottaskocsi|N;PSS2P;PL|halottaskocsijaitok
halottaskocsi|N;PSS2S;PL|halottaskocsijaid
halottaskocsi|N;PSS3P;PL|halottaskocsijaik
halottaskocsi|N;PSS3S;PL|halottaskocsijai
hanti|N;PSS1P;PL|hantijaink
hanti|N;PSS1S;PL|hantijaim
hanti|N;PSS2P;PL|hantijaitok
hanti|N;PSS2S;PL|hantijaid
hanti|N;PSS3P;PL|hantijaik
hanti|N;PSS3S;PL|hantijai
hapták|N;PSS3P;SG|haptákjuk
hapták|N;PSS3S;SG|haptákja
harckocsi|N;PSS1P;PL|harckocsijaink
harckocsi|N;PSS1S;PL|harckocsijaim
harckocsi|N;PSS2P;PL|harckocsijaitok
harckocsi|N;PSS2S;PL|harckocsijaid
harckocsi|N;PSS3P;PL|harckocsijaik
harckocsi|N;PSS3S;PL|harckocsijai
harmincadik|N;ACC;SG|harmincadikat
háromszög|N;PSS2P;SG|háromszögetek
hatszög|N;PSS2P;SG|hatszögetek
haver|N;ACC;SG|havert
haver|N;PSS1S;SG|haverom
haver|N;PSS2P;SG|haverotok
haver|N;PSS2S;SG|haverod
hazafi|N;PSS1P;PL|hazafijaink
hazafi|N;PSS1S;PL|hazafijaim
hazafi|N;PSS2P;PL|hazafijaitok
hazafi|N;PSS2S;PL|hazafijaid
hazafi|N;PSS3P;PL|hazafijaik
hazafi|N;PSS3S;PL|hazafijai
házimozi|N;PSS1P;PL|házimozijaink
házimozi|N;PSS1S;PL|házimozijaim
házimozi|N;PSS2P;PL|házimozijaitok
házimozi|N;PSS2S;PL|házimozijaid
házimozi|N;PSS3P;PL|házimozijaik
házimozi|N;PSS3S;PL|házimozijai
hefti|N;PSS1P;PL|heftijeink
hefti|N;PSS1S;PL|heftijeim
hefti|N;PSS2P;PL|heftijeitek
hefti|N;PSS2S;PL|heftijeid
hefti|N;PSS3P;PL|heftijeik
hefti|N;PSS3S;PL|heftijei
hegyesszög|N;PSS2P;SG|hegyesszögetek
hegyrajz|N;ACC;SG|hegyrajzot
helybeli|N;PSS1P;PL|helybelijeink
helybeli|N;PSS1S;PL|helybelijeim
helybeli|N;PSS2P;PL|helybelijeitek
helybeli|N;PSS2S;PL|helybelijeid
helybeli|N;PSS3P;PL|helybelijeik
helybeli|N;PSS3S;PL|helybelijei
helyesség|N;AT+ABL;SG|hhelyességtől
helyesség|N;AT+ALL;SG|hhelyességhez
helyesség|N;AT+ESS;SG|hhelyességnél
helyesség|N;DAT;SG|hhelyességnek
helyesség|N;IN+ABL;SG|hhelyességből
helyesség|N;IN+ALL;SG|hhelyességbe
helyesség|N;IN+ESS;SG|hhelyességben
helyesség|N;INS;SG|hhelyességgel
helyesség|N;ON+ABL;SG|hhelyességről
helyesség|N;ON+ALL;SG|hhelyességre
helyesség|N;PRP;SG|hhelyességért
helyesség|N;TERM;SG|hhelyességig
helyesség|N;TRANS;SG|hhelyességgé
helyezett|N;AT+ABL;SG|helyezettől
helyrajz|N;ACC;SG|helyrajzot
henry|N;ACC;PL|henryket
henry|N;ACC;SG|henryt
henry|N;AT+ABL;PL|henryktől
henry|N;AT+ALL;PL|henrykhez
henry|N;AT+ESS;PL|henryknél
henry|N;DAT;PL|henryknek
henry|N;IN+ABL;PL|henrykből
henry|N;IN+ALL;PL|henrykbe
henry|N;IN+ESS;PL|henrykben
henry|N;INS;PL|henrykkel
henry|N;INS;SG|henryvel
henry|N;NOM;PL|henryk
henry|N;ON+ABL;PL|henrykről
henry|N;ON+ALL;PL|henrykre
henry|N;ON+ESS;PL|henryken
henry|N;ON+ESS;SG|henryn
henry|N;PRP;PL|henrykért
henry|N;TERM;PL|henrykig
henry|N;TRANS;PL|henrykké
henry|N;TRANS;SG|henryvé
hercegnői|N;ACC;PL|hercegnőit
hercegnői|N;AT+ABL;PL|hercegnőitől
hercegnői|N;AT+ALL;PL|hercegnőihez
hercegnői|N;AT+ESS;PL|hercegnőinél
hercegnői|N;DAT;PL|hercegnőinek
hercegnői|N;FRML;PL|hercegnőiként
hercegnői|N;IN+ABL;PL|hercegnőiből
hercegnői|N;IN+ALL;PL|hercegnőibe
hercegnői|N;IN+ESS;PL|hercegnőiben
hercegnői|N;INS;PL|hercegnőivel
hercegnői|N;NOM;PL|hercegnői
hercegnői|N;ON+ABL;PL|hercegnőiről
hercegnői|N;ON+ALL;PL|hercegnőire
hercegnői|N;ON+ESS;PL|hercegnőin
hercegnői|N;PRP;PL|hercegnőiért
hercegnői|N;TERM;PL|hercegnőiig
hercegnői|N;TRANS;PL|hercegnőivé
híd|N;PSS1P;PL|hídjaink
híd|N;PSS1S;PL|hídjaim
híd|N;PSS2P;PL|hídjaitok
híd|N;PSS2S;PL|hídjaid
híd|N;PSS3P;PL|hídjaik
híd|N;PSS3P;SG|hídjuk
híd|N;PSS3S;PL|hídjai
híd|N;PSS3S;SG|hídja
hifi|N;PSS1P;PL|hifijeink
hifi|N;PSS1S;PL|hifijeim
hifi|N;PSS2P;PL|hifijeitek
hifi|N;PSS2S;PL|hifijeid
hifi|N;PSS3P;PL|hifijeik
hifi|N;PSS3S;PL|hifijei
hindi|N;PSS1P;PL|hindijeink
hindi|N;PSS1S;PL|hindijeim
hindi|N;PSS2P;PL|hindijeitek
hindi|N;PSS2S;PL|hindijeid
hindi|N;PSS3P;PL|hindijeik
hindi|N;PSS3S;PL|hindijei
hindu|N;PSS1P;PL|hindujaink
hindu|N;PSS1S;PL|hindujaim
hindu|N;PSS2P;PL|hindujaitok
hindu|N;PSS2S;PL|hindujaid
hindu|N;PSS3P;PL|hindujaik
hindu|N;PSS3S;PL|hindujai
hiszti|N;PSS1P;PL|hisztijeink
hiszti|N;PSS1S;PL|hisztijeim
hiszti|N;PSS2P;PL|hisztijeitek
hiszti|N;PSS2S;PL|hisztijeid
hiszti|N;PSS3P;PL|hisztijeik
hiszti|N;PSS3S;PL|hisztijei
hitei|N;ACC;PL|hiteit
hitei|N;AT+ABL;PL|hiteitől
hitei|N;AT+ALL;PL|hiteihez
hitei|N;AT+ESS;PL|hiteinél
hitei|N;DAT;PL|hiteinek
hitei|N;FRML;PL|hiteiként
hitei|N;IN+ABL;PL|hiteiből
hitei|N;IN+ALL;PL|hiteibe
hitei|N;IN+ESS;PL|hiteiben
hitei|N;INS;PL|hiteivel
hitei|N;NOM;PL|hitei
hitei|N;ON+ABL;PL|hiteiről
hitei|N;ON+ALL;PL|hiteire
hitei|N;ON+ESS;PL|hitein
hitei|N;PRP;PL|hiteiért
hitei|N;TERM;PL|hiteiig
hitei|N;TRANS;PL|hiteivé
hokedli|N;PSS1P;PL|hokedlijeink
hokedli|N;PSS1S;PL|hokedlijeim
hokedli|N;PSS2P;PL|hokedlijeitek
hokedli|N;PSS2S;PL|hokedlijeid
hokedli|N;PSS3P;PL|hokedlijeik
hokedli|N;PSS3S;PL|hokedlijei
holdkő|N;PSS2P;SG|holdkövetek
holdnaptár|N;ACC;SG|holdnaptárt
hollandiai|N;PSS1P;PL|hollandiaijaink
hollandiai|N;PSS1S;PL|hollandiaijaim
hollandiai|N;PSS2P;PL|hollandiaijaitok
hollandiai|N;PSS2S;PL|hollandiaijaid
hollandiai|N;PSS3P;PL|hollandiaijaik
hollandiai|N;PSS3S;PL|hollandiaijai
holmi|N;PSS1P;PL|holmijaink
holmi|N;PSS1S;PL|holmijaim
holmi|N;PSS2P;PL|holmijaitok
holmi|N;PSS2S;PL|holmijaid
holmi|N;PSS3P;PL|holmijaik
holmi|N;PSS3S;PL|holmijai
holt|N;ACC;SG|holtat
holta|N;PSS1P;SG|holtunk
holta|N;PSS1S;SG|holtom
holta|N;PSS2P;SG|holtotok
holta|N;PSS2S;SG|holtod
holta|N;PSS3P;SG|holtuk
holta|N;PSS3S;SG|holta
homokkő|N;PSS2P;SG|homokkövetek
homszi|N;PSS1P;PL|homszijaink
homszi|N;PSS1S;PL|homszijaim
homszi|N;PSS2P;PL|homszijaitok
homszi|N;PSS2S;PL|homszijaid
homszi|N;PSS3P;PL|homszijaik
homszi|N;PSS3S;PL|homszijai
honfi|N;PSS1P;PL|honfijaink
honfi|N;PSS1S;PL|honfijaim
honfi|N;PSS2P;PL|honfijaitok
honfi|N;PSS2S;PL|honfijaid
honfi|N;PSS3P;PL|honfijaik
honfi|N;PSS3S;PL|honfijai
hópihe|N;ACC;PL|hópihéket
hópihe|N;AT+ABL;PL|hópihéktől
hópihe|N;AT+ALL;PL|hópihékhez
hópihe|N;AT+ESS;PL|hópihéknél
hópihe|N;DAT;PL|hópihéknek
hópihe|N;IN+ABL;PL|hópihékből
hópihe|N;IN+ALL;PL|hópihékbe
hópihe|N;IN+ESS;PL|hópihékben
hópihe|N;INS;PL|hópihékkel
hópihe|N;ON+ABL;PL|hópihékről
hópihe|N;ON+ALL;PL|hópihékre
hópihe|N;ON+ESS;PL|hópihéken
hópihe|N;TRANS;PL|hópihékké
hölgy|N;PSS2P;SG|hölgyetek
hölgyeim|N;ACC;PL|hölgyeimet
hölgyeim|N;AT+ABL;PL|hölgyeimtől
hölgyeim|N;AT+ALL;PL|hölgyeimhez
hölgyeim|N;AT+ESS;PL|hölgyeimnél
hölgyeim|N;DAT;PL|hölgyeimnek
hölgyeim|N;FRML;PL|hölgyeimként
hölgyeim|N;IN+ABL;PL|hölgyeimből
hölgyeim|N;IN+ALL;PL|hölgyeimbe
hölgyeim|N;IN+ESS;PL|hölgyeimben
hölgyeim|N;INS;PL|hölgyeimmel
hölgyeim|N;NOM;PL|hölgyeim
hölgyeim|N;ON+ABL;PL|hölgyeimről
hölgyeim|N;ON+ALL;PL|hölgyeimre
hölgyeim|N;ON+ESS;PL|hölgyeimen
hölgyeim|N;PRP;PL|hölgyeimért
hölgyeim|N;TERM;PL|hölgyeimig
hölgyeim|N;TRANS;PL|hölgyeimmé
hullámvasút|N;PSS1P;PL|hullámvasútjaink
hullámvasút|N;PSS1S;PL|hullámvasútjaim
hullámvasút|N;PSS2P;PL|hullámvasútjaitok
hullámvasút|N;PSS2S;PL|hullámvasútjaid
hullámvasút|N;PSS3P;PL|hullámvasútjaik
hullámvasút|N;PSS3P;SG|hullámvasútjuk
hullámvasút|N;PSS3S;PL|hullámvasútjai
hullámvasút|N;PSS3S;SG|hullámvasútja
huszadik|N;ACC;SG|huszadikat
identitásmátrix|N;INS;SG|identitásmátrixszal
identitásmátrix|N;TRANS;SG|identitásmátrixszá
igazgatói|N;ACC;PL|igazgatóit
igazgatói|N;AT+ABL;PL|igazgatóitól
igazgatói|N;AT+ALL;PL|igazgatóihoz
igazgatói|N;AT+ESS;PL|igazgatóinál
igazgatói|N;DAT;PL|igazgatóinak
igazgatói|N;FRML;PL|igazgatóiként
igazgatói|N;IN+ABL;PL|igazgatóiból
igazgatói|N;IN+ALL;PL|igazgatóiba
igazgatói|N;IN+ESS;PL|igazgatóiban
igazgatói|N;INS;PL|igazgatóival
igazgatói|N;NOM;PL|igazgatói
igazgatói|N;ON+ABL;PL|igazgatóiról
igazgatói|N;ON+ALL;PL|igazgatóira
igazgatói|N;ON+ESS;PL|igazgatóin
igazgatói|N;PRP;PL|igazgatóiért
igazgatói|N;TERM;PL|igazgatóiig
igazgatói|N;TRANS;PL|igazgatóivá
igazi|N;PSS1P;PL|igazijaink
igazi|N;PSS1S;PL|igazijaim
igazi|N;PSS2P;PL|igazijaitok
igazi|N;PSS2S;PL|igazijaid
igazi|N;PSS3P;PL|igazijaik
igazi|N;PSS3S;PL|igazijai
illóolaj|N;ACC;SG|illóolajat
imádott|N;AT+ABL;SG|imádottól
imamalom|N;ON+ESS;SG|imamalomon
index|N;INS;SG|indexszel
index|N;TRANS;SG|indexszé
indexei|N;ACC;PL|indexeit
indexei|N;AT+ABL;PL|indexeitől
indexei|N;AT+ALL;PL|indexeihez
indexei|N;AT+ESS;PL|indexeinél
indexei|N;DAT;PL|indexeinek
indexei|N;FRML;PL|indexeiként
indexei|N;IN+ABL;PL|indexeiből
indexei|N;IN+ALL;PL|indexeibe
indexei|N;IN+ESS;PL|indexeiben
indexei|N;INS;PL|indexeivel
indexei|N;NOM;PL|indexei
indexei|N;ON+ABL;PL|indexeiről
indexei|N;ON+ALL;PL|indexeire
indexei|N;ON+ESS;PL|indexein
indexei|N;PRP;PL|indexeiért
indexei|N;TERM;PL|indexeiig
indexei|N;TRANS;PL|indexeivé
indiai|N;PSS1P;PL|indiaijaink
indiai|N;PSS1S;PL|indiaijaim
indiai|N;PSS2P;PL|indiaijaitok
indiai|N;PSS2S;PL|indiaijaid
indiai|N;PSS3P;PL|indiaijaik
indiai|N;PSS3S;PL|indiaijai
írásbeli|N;PSS1P;PL|írásbelijeink
írásbeli|N;PSS1S;PL|írásbelijeim
írásbeli|N;PSS2P;PL|írásbelijeitek
írásbeli|N;PSS2S;PL|írásbelijeid
írásbeli|N;PSS3P;PL|írásbelijeik
írásbeli|N;PSS3S;PL|írásbelijei
írói|N;ACC;PL|íróit
írói|N;AT+ABL;PL|íróitól
írói|N;AT+ALL;PL|íróihoz
írói|N;AT+ESS;PL|íróinál
írói|N;DAT;PL|íróinak
írói|N;FRML;PL|íróiként
írói|N;IN+ABL;PL|íróiból
írói|N;IN+ALL;PL|íróiba
írói|N;IN+ESS;PL|íróiban
írói|N;INS;PL|íróival
írói|N;NOM;PL|írói
írói|N;ON+ABL;PL|íróiról
írói|N;ON+ALL;PL|íróira
írói|N;ON+ESS;PL|íróin
írói|N;PRP;PL|íróiért
írói|N;TERM;PL|íróiig
írói|N;TRANS;PL|íróivá
isi|N;PSS1P;PL|isijeink
isi|N;PSS1S;PL|isijeim
isi|N;PSS2P;PL|isijeitek
isi|N;PSS2S;PL|isijeid
isi|N;PSS3P;PL|isijeik
isi|N;PSS3S;PL|isijei
ívhíd|N;PSS1P;PL|ívhídjaink
ívhíd|N;PSS1S;PL|ívhídjaim
ívhíd|N;PSS2P;PL|ívhídjaitok
ívhíd|N;PSS2S;PL|ívhídjaid
ívhíd|N;PSS3P;PL|ívhídjaik
ívhíd|N;PSS3P;SG|ívhídjuk
ívhíd|N;PSS3S;PL|ívhídjai
ívhíd|N;PSS3S;SG|ívhídja
izlandi|N;PSS1P;PL|izlandijaink
izlandi|N;PSS1S;PL|izlandijaim
izlandi|N;PSS2P;PL|izlandijaitok
izlandi|N;PSS2S;PL|izlandijaid
izlandi|N;PSS3P;PL|izlandijaik
izlandi|N;PSS3S;PL|izlandijai
jármű|N;PSS2P;SG|járművetek
járta|N;PSS1P;SG|jártunk
járta|N;PSS1S;SG|jártam
járta|N;PSS2P;SG|jártatok
járta|N;PSS2S;SG|jártad
járta|N;PSS3P;SG|jártuk
járta|N;PSS3S;SG|járta
java|N;PSS1P;PL|javaink
java|N;PSS1P;SG|javunk
java|N;PSS1S;PL|javaim
java|N;PSS1S;SG|javam
java|N;PSS2P;PL|javaitok
java|N;PSS2P;SG|javatok
java|N;PSS2S;PL|javaid
java|N;PSS2S;SG|javad
java|N;PSS3P;PL|javaik
java|N;PSS3P;SG|javuk
java|N;PSS3S;PL|javai
java|N;PSS3S;SG|java
jelölt|N;PSS2P;SG|jelöltetek
jelzőtűz|N;PSS2P;SG|jelzőtüzetek
jenki|N;PSS1P;PL|jenkijeink
jenki|N;PSS1S;PL|jenkijeim
jenki|N;PSS2P;PL|jenkijeitek
jenki|N;PSS2S;PL|jenkijeid
jenki|N;PSS3P;PL|jenkijeik
jenki|N;PSS3S;PL|jenkijei
jeti|N;PSS1P;PL|jetijeink
jeti|N;PSS1S;PL|jetijeim
jeti|N;PSS2P;PL|jetijeitek
jeti|N;PSS2S;PL|jetijeid
jeti|N;PSS3P;PL|jetijeik
jeti|N;PSS3S;PL|jetijei
jobb|N;ACC;SG|jobbat
jobb|N;IN+ABL;SG|jobból
jobb|N;IN+ALL;SG|jobba
jobb|N;IN+ESS;SG|jobban
jobboldal|N;ACC;SG|jobboldalt
jogai|N;ACC;PL|jogait
jogai|N;AT+ABL;PL|jogaitól
jogai|N;AT+ALL;PL|jogaihoz
jogai|N;AT+ESS;PL|jogainál
jogai|N;DAT;PL|jogainak
jogai|N;FRML;PL|jogaiként
jogai|N;IN+ABL;PL|jogaiból
jogai|N;IN+ALL;PL|jogaiba
jogai|N;IN+ESS;PL|jogaiban
jogai|N;INS;PL|jogaival
jogai|N;NOM;PL|jogai
jogai|N;ON+ABL;PL|jogairól
jogai|N;ON+ALL;PL|jogaira
jogai|N;ON+ESS;PL|jogain
jogai|N;PRP;PL|jogaiért
jogai|N;TERM;PL|jogaiig
jogai|N;TRANS;PL|jogaivá
jógi|N;PSS1P;PL|jógijaink
jógi|N;PSS1S;PL|jógijaim
jógi|N;PSS2P;PL|jógijaitok
jógi|N;PSS2S;PL|jógijaid
jógi|N;PSS3P;PL|jógijaik
jógi|N;PSS3S;PL|jógijai
jóginí|N;PSS1P;PL|jóginíjeink
jóginí|N;PSS1S;PL|jóginíjeim
jóginí|N;PSS2P;PL|jóginíjeitek
jóginí|N;PSS2S;PL|jóginíjeid
jóginí|N;PSS3P;PL|jóginíjeik
jóginí|N;PSS3S;PL|jóginíjei
jogsi|N;PSS1P;PL|jogsijaink
jogsi|N;PSS1S;PL|jogsijaim
jogsi|N;PSS2P;PL|jogsijaitok
jogsi|N;PSS2S;PL|jogsijaid
jogsi|N;PSS3P;PL|jogsijaik
jogsi|N;PSS3S;PL|jogsijai
jóni|N;PSS1P;PL|jónijaink
jóni|N;PSS1S;PL|jónijaim
jóni|N;PSS2P;PL|jónijaitok
jóni|N;PSS2S;PL|jónijaid
jóni|N;PSS3P;PL|jónijaik
jóni|N;PSS3S;PL|jónijai
jótett|N;AT+ABL;SG|jótettől
jövendőbeli|N;PSS1P;PL|jövendőbelijeink
jövendőbeli|N;PSS1S;PL|jövendőbelijeim
jövendőbeli|N;PSS2P;PL|jövendőbelijeitek
jövendőbeli|N;PSS2S;PL|jövendőbelijeid
jövendőbeli|N;PSS3P;PL|jövendőbelijeik
jövendőbeli|N;PSS3S;PL|jövendőbelijei
kábítószerfüggő|N;PSS2P;PL|kábítószerfüggőitok
kábítószerfüggő|N;PSS2P;SG|kábítószerfüggőtok
kábítószerfüggő|N;PSS3P;SG|kábítószerfüggőjuk
kábítószerfüggő|N;PSS3S;SG|kábítószerfüggőja
kádi|N;PSS1P;PL|kádijaink
kádi|N;PSS1S;PL|kádijaim
kádi|N;PSS2P;PL|kádijaitok
kádi|N;PSS2S;PL|kádijaid
kádi|N;PSS3P;PL|kádijaik
kádi|N;PSS3S;PL|kádijai
kajszi|N;PSS1P;PL|kajszijaink
kajszi|N;PSS1S;PL|kajszijaim
kajszi|N;PSS2P;PL|kajszijaitok
kajszi|N;PSS2S;PL|kajszijaid
kajszi|N;PSS3P;PL|kajszijaik
kajszi|N;PSS3S;PL|kajszijai
kaki|N;PSS1P;PL|kakijaink
kaki|N;PSS1S;PL|kakijaim
kaki|N;PSS2P;PL|kakijaitok
kaki|N;PSS2S;PL|kakijaid
kaki|N;PSS3P;PL|kakijaik
kaki|N;PSS3S;PL|kakijai
kakukk|N;FRML;SG|kakukként
kakukkfű|N;PSS2P;SG|kakukkfüvetek
kaliforniai|N;PSS1P;PL|kaliforniaijaink
kaliforniai|N;PSS1S;PL|kaliforniaijaim
kaliforniai|N;PSS2P;PL|kaliforniaijaitok
kaliforniai|N;PSS2S;PL|kaliforniaijaid
kaliforniai|N;PSS3P;PL|kaliforniaijaik
kaliforniai|N;PSS3S;PL|kaliforniaijai
kalucsni|N;PSS1P;PL|kalucsnijaink
kalucsni|N;PSS1S;PL|kalucsnijaim
kalucsni|N;PSS2P;PL|kalucsnijaitok
kalucsni|N;PSS2S;PL|kalucsnijaid
kalucsni|N;PSS3P;PL|kalucsnijaik
kalucsni|N;PSS3S;PL|kalucsnijai
kamaszdzseki|N;PSS1P;PL|kamaszdzsekijeink
kamaszdzseki|N;PSS1S;PL|kamaszdzsekijeim
kamaszdzseki|N;PSS2P;PL|kamaszdzsekijeitek
kamaszdzseki|N;PSS2S;PL|kamaszdzsekijeid
kamaszdzseki|N;PSS3P;PL|kamaszdzsekijeik
kamaszdzseki|N;PSS3S;PL|kamaszdzsekijei
kanadai|N;PSS1P;PL|kanadaijaink
kanadai|N;PSS1S;PL|kanadaijaim
kanadai|N;PSS2P;PL|kanadaijaitok
kanadai|N;PSS2S;PL|kanadaijaid
kanadai|N;PSS3P;PL|kanadaijaik
kanadai|N;PSS3S;PL|kanadaijai
kanári|N;PSS1P;PL|kanárijaink
kanári|N;PSS1S;PL|kanárijaim
kanári|N;PSS2P;PL|kanárijaitok
kanári|N;PSS2S;PL|kanárijaid
kanári|N;PSS3P;PL|kanárijaik
kanári|N;PSS3S;PL|kanárijai
kaposvári|N;PSS1P;PL|kaposvárijaink
kaposvári|N;PSS1S;PL|kaposvárijaim
kaposvári|N;PSS2P;PL|kaposvárijaitok
kaposvári|N;PSS2S;PL|kaposvárijaid
kaposvári|N;PSS3P;PL|kaposvárijaik
kaposvári|N;PSS3S;PL|kaposvárijai
kapucni|N;PSS1P;PL|kapucnijaink
kapucni|N;PSS1S;PL|kapucnijaim
kapucni|N;PSS2P;PL|kapucnijaitok
kapucni|N;PSS2S;PL|kapucnijaid
kapucni|N;PSS3P;PL|kapucnijaik
kapucni|N;PSS3S;PL|kapucnijai
kapui|N;ACC;PL|kapuit
kapui|N;AT+ABL;PL|kapuitól
kapui|N;AT+ALL;PL|kapuihoz
kapui|N;AT+ESS;PL|kapuinál
kapui|N;DAT;PL|kapuinak
kapui|N;FRML;PL|kapuiként
kapui|N;IN+ABL;PL|kapuiból
kapui|N;IN+ALL;PL|kapuiba
kapui|N;IN+ESS;PL|kapuiban
kapui|N;INS;PL|kapuival
kapui|N;NOM;PL|kapui
kapui|N;ON+ABL;PL|kapuiról
kapui|N;ON+ALL;PL|kapuira
kapui|N;ON+ESS;PL|kapuin
kapui|N;PRP;PL|kapuiért
kapui|N;TERM;PL|kapuiig
kapui|N;TRANS;PL|kapuivá
karai|N;ACC;PL|karait
karai|N;AT+ABL;PL|karaitól
karai|N;AT+ALL;PL|karaihoz
karai|N;AT+ESS;PL|karainál
karai|N;DAT;PL|karainak
karai|N;FRML;PL|karaiként
karai|N;IN+ABL;PL|karaiból
karai|N;IN+ALL;PL|karaiba
karai|N;IN+ESS;PL|karaiban
karai|N;INS;PL|karaival
karai|N;NOM;PL|karai
karai|N;ON+ABL;PL|karairól
karai|N;ON+ALL;PL|karaira
karai|N;ON+ESS;PL|karain
karai|N;PRP;PL|karaiért
karai|N;TERM;PL|karaiig
karai|N;TRANS;PL|karaivá
kari|N;PSS1P;PL|karijaink
kari|N;PSS1S;PL|karijaim
kari|N;PSS2P;PL|karijaitok
kari|N;PSS2S;PL|karijaid
kari|N;PSS3P;PL|karijaik
kari|N;PSS3S;PL|karijai
katódsugárcső|N;PSS2P;SG|katódsugárcsövetek
kávéscsésze|N;ACC;PL|kávéscsészéket
kávéscsésze|N;AT+ABL;PL|kávéscsészéktől
kávéscsésze|N;AT+ALL;PL|kávéscsészékhez
kávéscsésze|N;AT+ESS;PL|kávéscsészéknél
kávéscsésze|N;DAT;PL|kávéscsészéknek
kávéscsésze|N;IN+ABL;PL|kávéscsészékből
kávéscsésze|N;IN+ALL;PL|kávéscsészékbe
kávéscsésze|N;IN+ESS;PL|kávéscsészékben
kávéscsésze|N;INS;PL|kávéscsészékkel
kávéscsésze|N;ON+ABL;PL|kávéscsészékről
kávéscsésze|N;ON+ALL;PL|kávéscsészékre
kávéscsésze|N;ON+ESS;PL|kávéscsészéken
kávéscsésze|N;TRANS;PL|kávéscsészékké
kebelbarát|N;PSS3P;SG|kebelbarátjuk
kebelbarát|N;PSS3S;SG|kebelbarátja
kecskeszakáll|N;ACC;SG|kecskeszakállt
kedvezményezett|N;AT+ABL;SG|kedvezményezettől
kémcső|N;PSS2P;SG|kémcsövetek
képviselői|N;ACC;PL|képviselőit
képviselői|N;AT+ABL;PL|képviselőitől
képviselői|N;AT+ALL;PL|képviselőihez
képviselői|N;AT+ESS;PL|képviselőinél
képviselői|N;DAT;PL|képviselőinek
képviselői|N;FRML;PL|képviselőiként
képviselői|N;IN+ABL;PL|képviselőiből
képviselői|N;IN+ALL;PL|képviselőibe
képviselői|N;IN+ESS;PL|képviselőiben
képviselői|N;INS;PL|képviselőivel
képviselői|N;NOM;PL|képviselői
képviselői|N;ON+ABL;PL|képviselőiről
képviselői|N;ON+ALL;PL|képviselőire
képviselői|N;ON+ESS;PL|képviselőin
képviselői|N;PRP;PL|képviselőiért
képviselői|N;TERM;PL|képviselőiig
képviselői|N;TRANS;PL|képviselőivé
kérdezett|N;AT+ABL;SG|kérdezettől
keresztelő|N;PSS2P;PL|keresztelőitok
keresztelő|N;PSS2P;SG|keresztelőtok
keresztelő|N;PSS3P;SG|keresztelőjuk
keresztelő|N;PSS3S;SG|keresztelőja
kereszttűz|N;PSS2P;SG|kereszttüzetek
kései|N;ACC;PL|késeit
kései|N;AT+ABL;PL|késeitől
kései|N;AT+ALL;PL|késeihez
kései|N;AT+ESS;PL|késeinél
kései|N;DAT;PL|késeinek
kései|N;FRML;PL|késeiként
kései|N;IN+ABL;PL|késeiből
kései|N;IN+ALL;PL|késeibe
kései|N;IN+ESS;PL|késeiben
kései|N;INS;PL|késeivel
kései|N;NOM;PL|kései
kései|N;ON+ABL;PL|késeiről
kései|N;ON+ALL;PL|késeire
kései|N;ON+ESS;PL|késein
kései|N;PRP;PL|késeiért
kései|N;TERM;PL|késeiig
kései|N;TRANS;PL|késeivé
kézi|N;PSS1P;PL|kézijeink
kézi|N;PSS1S;PL|kézijeim
kézi|N;PSS2P;PL|kézijeitek
kézi|N;PSS2S;PL|kézijeid
kézi|N;PSS3P;PL|kézijeik
kézi|N;PSS3S;PL|kézijei
kézikönyv|N;PSS2P;SG|kézikönyvetek
kéztő|N;PSS2P;SG|kéztövetek
kick-box|N;INS;SG|kick-boxszal
kick-box|N;TRANS;SG|kick-boxszá
kifli|N;PSS1P;PL|kiflijeink
kifli|N;PSS1S;PL|kiflijeim
kifli|N;PSS2P;PL|kiflijeitek
kifli|N;PSS2S;PL|kiflijeid
kifli|N;PSS3P;PL|kiflijeik
kifli|N;PSS3S;PL|kiflijei
kínai|N;PSS1P;PL|kínaijaink
kínai|N;PSS1S;PL|kínaijaim
kínai|N;PSS2P;PL|kínaijaitok
kínai|N;PSS2S;PL|kínaijaid
kínai|N;PSS3P;PL|kínaijaik
kínai|N;PSS3S;PL|kínaijai
kisbolygóöv|N;PSS2P;SG|kisbolygóövetek
kitartott|N;AT+ABL;SG|kitartottól
kiválasztott|N;AT+ABL;SG|kiválasztottól
kivi|N;PSS1P;PL|kivijeink
kivi|N;PSS1S;PL|kivijeim
kivi|N;PSS2P;PL|kivijeitek
kivi|N;PSS2S;PL|kivijeid
kivi|N;PSS3P;PL|kivijeik
kivi|N;PSS3S;PL|kivijei
klikk|N;FRML;SG|klikként
klimax|N;INS;SG|klimaxszal
klimax|N;TRANS;SG|klimaxszá
klozett|N;AT+ABL;SG|klozettől
kocsi|N;PSS1P;PL|kocsijaink
kocsi|N;PSS1S;PL|kocsijaim
kocsi|N;PSS2P;PL|kocsijaitok
kocsi|N;PSS2S;PL|kocsijaid
kocsi|N;PSS3P;PL|kocsijaik
kocsi|N;PSS3S;PL|kocsijai
kódex|N;INS;SG|kódexszel
kódex|N;TRANS;SG|kódexszé
koksz|N;ACC;SG|kokszot
kókuszolaj|N;ACC;SG|kókuszolajat
kolibri|N;PSS1P;PL|kolibrijaink
kolibri|N;PSS1S;PL|kolibrijaim
kolibri|N;PSS2P;PL|kolibrijaitok
kolibri|N;PSS2S;PL|kolibrijaid
kolibri|N;PSS3P;PL|kolibrijaik
kolibri|N;PSS3S;PL|kolibrijai
kombi|N;PSS1P;PL|kombijaink
kombi|N;PSS1S;PL|kombijaim
kombi|N;PSS2P;PL|kombijaitok
kombi|N;PSS2S;PL|kombijaid
kombi|N;PSS3P;PL|kombijaik
kombi|N;PSS3S;PL|kombijai
kondi|N;PSS1P;PL|kondijaink
kondi|N;PSS1S;PL|kondijaim
kondi|N;PSS2P;PL|kondijaitok
kondi|N;PSS2S;PL|kondijaid
kondi|N;PSS3P;PL|kondijaik
kondi|N;PSS3S;PL|kondijai
kongói|N;PSS1P;PL|kongóijaink
kongói|N;PSS1S;PL|kongóijaim
kongói|N;PSS2P;PL|kongóijaitok
kongói|N;PSS2S;PL|kongóijaid
kongói|N;PSS3P;PL|kongóijaik
kongói|N;PSS3S;PL|kongóijai
korai|N;ACC;PL|korait
korai|N;AT+ABL;PL|koraitól
korai|N;AT+ALL;PL|koraihoz
korai|N;AT+ESS;PL|korainál
korai|N;DAT;PL|korainak
korai|N;FRML;PL|koraiként
korai|N;IN+ABL;PL|koraiból
korai|N;IN+ALL;PL|koraiba
korai|N;IN+ESS;PL|koraiban
korai|N;INS;PL|koraival
korai|N;NOM;PL|korai
korai|N;ON+ABL;PL|korairól
korai|N;ON+ALL;PL|koraira
korai|N;ON+ESS;PL|korain
korai|N;PRP;PL|koraiért
korai|N;TERM;PL|koraiig
korai|N;TRANS;PL|koraivá
koraszülött|N;AT+ABL;SG|koraszülöttől
koraszülött|N;PSS2P;SG|koraszülöttetek
koreai|N;PSS1P;PL|koreaijaink
koreai|N;PSS1S;PL|koreaijaim
koreai|N;PSS2P;PL|koreaijaitok
koreai|N;PSS2S;PL|koreaijaid
koreai|N;PSS3P;PL|koreaijaik
koreai|N;PSS3S;PL|koreaijai
kori|N;PSS1P;PL|korijaink
kori|N;PSS1S;PL|korijaim
kori|N;PSS2P;PL|korijaitok
kori|N;PSS2S;PL|korijaid
kori|N;PSS3P;PL|korijaik
kori|N;PSS3S;PL|korijai
kornett|N;AT+ABL;SG|kornettől
kő|N;PSS2P;SG|követek
kölni|N;PSS1P;PL|kölnijeink
kölni|N;PSS1S;PL|kölnijeim
kölni|N;PSS2P;PL|kölnijeitek
kölni|N;PSS2S;PL|kölnijeid
kölni|N;PSS3P;PL|kölnijeik
kölni|N;PSS3S;PL|kölnijei
költői|N;ACC;PL|költőit
költői|N;AT+ABL;PL|költőitől
költői|N;AT+ALL;PL|költőihez
költői|N;AT+ESS;PL|költőinél
költői|N;DAT;PL|költőinek
költői|N;FRML;PL|költőiként
költői|N;IN+ABL;PL|költőiből
költői|N;IN+ALL;PL|költőibe
költői|N;IN+ESS;PL|költőiben
költői|N;INS;PL|költőivel
költői|N;NOM;PL|költői
költői|N;ON+ABL;PL|költőiről
költői|N;ON+ALL;PL|költőire
költői|N;ON+ESS;PL|költőin
költői|N;PRP;PL|költőiért
költői|N;TERM;PL|költőiig
költői|N;TRANS;PL|költőivé
könny|N;PSS2P;SG|könnyetek
könyv|N;PSS2P;SG|könyvetek
kőolaj|N;ACC;SG|kőolajat
körömlakk|N;FRML;SG|körömlakként
körözött|N;AT+ABL;SG|körözöttől
körút|N;PSS1P;PL|körútjaink
körút|N;PSS1S;PL|körútjaim
körút|N;PSS2P;PL|körútjaitok
körút|N;PSS2S;PL|körútjaid
körút|N;PSS3P;PL|körútjaik
körút|N;PSS3P;SG|körútjuk
körút|N;PSS3S;PL|körútjai
körút|N;PSS3S;SG|körútja
kötelezett|N;AT+ABL;SG|kötelezettől
közalkalmazott|N;AT+ABL;SG|közalkalmazottól
közegészségügy|N;PSS2P;SG|közegészségügyetek
közelebbi|N;PSS1P;PL|közelebbijeink
közelebbi|N;PSS1S;PL|közelebbijeim
közelebbi|N;PSS2P;PL|közelebbijeitek
közelebbi|N;PSS2S;PL|közelebbijeid
közelebbi|N;PSS3P;PL|közelebbijeik
közelebbi|N;PSS3S;PL|közelebbijei
közép-ázsiai|N;PSS1P;PL|közép-ázsiaijaink
közép-ázsiai|N;PSS1S;PL|közép-ázsiaijaim
közép-ázsiai|N;PSS2P;PL|közép-ázsiaijaitok
közép-ázsiai|N;PSS2S;PL|közép-ázsiaijaid
közép-ázsiai|N;PSS3P;PL|közép-ázsiaijaik
közép-ázsiai|N;PSS3S;PL|közép-ázsiaijai
középfül|N;PSS2P;SG|középfületek
közjó|N;ACC;SG|közjót
köztisztviselői|N;ACC;PL|köztisztviselőit
köztisztviselői|N;AT+ABL;PL|köztisztviselőitől
köztisztviselői|N;AT+ALL;PL|köztisztviselőihez
köztisztviselői|N;AT+ESS;PL|köztisztviselőinél
köztisztviselői|N;DAT;PL|köztisztviselőinek
köztisztviselői|N;FRML;PL|köztisztviselőiként
köztisztviselői|N;IN+ABL;PL|köztisztviselőiből
köztisztviselői|N;IN+ALL;PL|köztisztviselőibe
köztisztviselői|N;IN+ESS;PL|köztisztviselőiben
köztisztviselői|N;INS;PL|köztisztviselőivel
köztisztviselői|N;NOM;PL|köztisztviselői
köztisztviselői|N;ON+ABL;PL|köztisztviselőiről
köztisztviselői|N;ON+ALL;PL|köztisztviselőire
köztisztviselői|N;ON+ESS;PL|köztisztviselőin
köztisztviselői|N;PRP;PL|köztisztviselőiért
köztisztviselői|N;TERM;PL|köztisztviselőiig
köztisztviselői|N;TRANS;PL|köztisztviselőivé
krapek|N;ACC;SG|krapekot
krapek|N;PSS1S;SG|krapekom
krapek|N;PSS2P;SG|krapekotok
krapek|N;PSS2S;SG|krapekod
kravátli|N;PSS1P;PL|kravátlijaink
kravátli|N;PSS1S;PL|kravátlijaim
kravátli|N;PSS2P;PL|kravátlijaitok
kravátli|N;PSS2S;PL|kravátlijaid
kravátli|N;PSS3P;PL|kravátlijaik
kravátli|N;PSS3S;PL|kravátlijai
krikett|N;AT+ABL;SG|krikettől
krumpli|N;PSS1P;PL|krumplijaink
krumpli|N;PSS1S;PL|krumplijaim
krumpli|N;PSS2P;PL|krumplijaitok
krumpli|N;PSS2S;PL|krumplijaid
krumpli|N;PSS3P;PL|krumplijaik
krumpli|N;PSS3S;PL|krumplijai
kubai|N;PSS1P;PL|kubaijaink
kubai|N;PSS1S;PL|kubaijaim
kubai|N;PSS2P;PL|kubaijaitok
kubai|N;PSS2S;PL|kubaijaid
kubai|N;PSS3P;PL|kubaijaik
kubai|N;PSS3S;PL|kubaijai
kukoricacső|N;PSS2P;SG|kukoricacsövetek
kulcsszó|N;ACC;SG|kulcsszót
kuli|N;PSS1P;PL|kulijaink
kuli|N;PSS1S;PL|kulijaim
kuli|N;PSS2P;PL|kulijaitok
kuli|N;PSS2S;PL|kulijaid
kuli|N;PSS3P;PL|kulijaik
kuli|N;PSS3S;PL|kulijai
kunsztstükk|N;FRML;SG|kunsztstükként
kurafi|N;PSS1P;PL|kurafijaink
kurafi|N;PSS1S;PL|kurafijaim
kurafi|N;PSS2P;PL|kurafijaitok
kurafi|N;PSS2S;PL|kurafijaid
kurafi|N;PSS3P;PL|kurafijaik
kurafi|N;PSS3S;PL|kurafijai
kurázsi|N;PSS1P;PL|kurázsijaink
kurázsi|N;PSS1S;PL|kurázsijaim
kurázsi|N;PSS2P;PL|kurázsijaitok
kurázsi|N;PSS2S;PL|kurázsijaid
kurázsi|N;PSS3P;PL|kurázsijaik
kurázsi|N;PSS3S;PL|kurázsijai
kurbli|N;PSS1P;PL|kurblijaink
kurbli|N;PSS1S;PL|kurblijaim
kurbli|N;PSS2P;PL|kurblijaitok
kurbli|N;PSS2S;PL|kurblijaid
kurbli|N;PSS3P;PL|kurblijaik
kurbli|N;PSS3S;PL|kurblijai
kút|N;PSS1P;PL|kútjaink
kút|N;PSS1S;PL|kútjaim
kút|N;PSS2P;PL|kútjaitok
kút|N;PSS2S;PL|kútjaid
kút|N;PSS3P;PL|kútjaik
kút|N;PSS3P;SG|kútjuk
kút|N;PSS3S;PL|kútjai
kút|N;PSS3S;SG|kútja
kutatói|N;ACC;PL|kutatóit
kutatói|N;AT+ABL;PL|kutatóitól
kutatói|N;AT+ALL;PL|kutatóihoz
kutatói|N;AT+ESS;PL|kutatóinál
kutatói|N;DAT;PL|kutatóinak
kutatói|N;FRML;PL|kutatóiként
kutatói|N;IN+ABL;PL|kutatóiból
kutatói|N;IN+ALL;PL|kutatóiba
kutatói|N;IN+ESS;PL|kutatóiban
kutatói|N;INS;PL|kutatóival
kutatói|N;NOM;PL|kutatói
kutatói|N;ON+ABL;PL|kutatóiról
kutatói|N;ON+ALL;PL|kutatóira
kutatói|N;ON+ESS;PL|kutatóin
kutatói|N;PRP;PL|kutatóiért
kutatói|N;TERM;PL|kutatóiig
kutatói|N;TRANS;PL|kutatóivá
küldött|N;AT+ABL;SG|küldöttől
küldött|N;PSS2P;SG|küldöttetek
külföld|N;PSS2P;SG|külföldetek
külföldi|N;PSS1P;PL|külföldijeink
külföldi|N;PSS1S;PL|külföldijeim
külföldi|N;PSS2P;PL|külföldijeitek
külföldi|N;PSS2S;PL|külföldijeid
külföldi|N;PSS3P;PL|külföldijeik
külföldi|N;PSS3S;PL|külföldijei
külügy|N;PSS2P;SG|külügyetek
kvartett|N;AT+ABL;SG|kvartettől
kvintett|N;AT+ABL;SG|kvintettől
labanc|N;ACC;SG|labanct
lábbeli|N;PSS1P;PL|lábbelijeink
lábbeli|N;PSS1S;PL|lábbelijeim
lábbeli|N;PSS2P;PL|lábbelijeitek
lábbeli|N;PSS2S;PL|lábbelijeid
lábbeli|N;PSS3P;PL|lábbelijeik
lábbeli|N;PSS3S;PL|lábbelijei
lábtő|N;PSS2P;SG|lábtövetek
lakk|N;FRML;SG|lakként
lakókocsi|N;PSS1P;PL|lakókocsijaink
lakókocsi|N;PSS1S;PL|lakókocsijaim
lakókocsi|N;PSS2P;PL|lakókocsijaitok
lakókocsi|N;PSS2S;PL|lakókocsijaid
lakókocsi|N;PSS3P;PL|lakókocsijaik
lakókocsi|N;PSS3S;PL|lakókocsijai
lakta|N;PSS1P;SG|laktunk
lakta|N;PSS1S;SG|laktom
lakta|N;PSS2P;SG|laktotok
lakta|N;PSS2S;SG|laktod
lakta|N;PSS3P;SG|laktuk
lakta|N;PSS3S;SG|lakta
laszti|N;PSS1P;PL|lasztijaink
laszti|N;PSS1S;PL|lasztijaim
laszti|N;PSS2P;PL|lasztijaitok
laszti|N;PSS2S;PL|lasztijaid
laszti|N;PSS3P;PL|lasztijaik
laszti|N;PSS3S;PL|lasztijai
látássérült|N;PSS2P;SG|látássérültetek
látogatói|N;ACC;PL|látogatóit
látogatói|N;AT+ABL;PL|látogatóitól
látogatói|N;AT+ALL;PL|látogatóihoz
látogatói|N;AT+ESS;PL|látogatóinál
látogatói|N;DAT;PL|látogatóinak
látogatói|N;FRML;PL|látogatóiként
látogatói|N;IN+ABL;PL|látogatóiból
látogatói|N;IN+ALL;PL|látogatóiba
látogatói|N;IN+ESS;PL|látogatóiban
látogatói|N;INS;PL|látogatóival
látogatói|N;NOM;PL|látogatói
látogatói|N;ON+ABL;PL|látogatóiról
látogatói|N;ON+ALL;PL|látogatóira
látogatói|N;ON+ESS;PL|látogatóin
látogatói|N;PRP;PL|látogatóiért
látogatói|N;TERM;PL|látogatóiig
látogatói|N;TRANS;PL|látogatóivá
látószög|N;PSS2P;SG|látószögetek
legionárius|N;PSS1P;PL|legináriusaink
legionárius|N;PSS1P;SG|legináriusunk
legionárius|N;PSS1S;PL|legináriusaim
legionárius|N;PSS1S;SG|legináriusom
legionárius|N;PSS2P;PL|legináriusaitok
legionárius|N;PSS2P;SG|legináriusotok
legionárius|N;PSS2S;PL|legináriusaid
legionárius|N;PSS2S;SG|legináriusod
legionárius|N;PSS3P;PL|legináriusaik
legionárius|N;PSS3P;SG|legináriusuk
legionárius|N;PSS3S;PL|legináriusai
legionárius|N;PSS3S;SG|legináriusa
legközelebb|N;IN+ABL;SG|legközelebből
legközelebb|N;IN+ALL;SG|legközelebbe
legközelebb|N;IN+ESS;SG|legközelebben
légyott|N;AT+ABL;SG|légyottól
lekötelezett|N;AT+ABL;SG|lekötelezettől
lesei|N;ACC;PL|leseit
lesei|N;AT+ABL;PL|leseitől
lesei|N;AT+ALL;PL|leseihez
lesei|N;AT+ESS;PL|leseinél
lesei|N;DAT;PL|leseinek
lesei|N;FRML;PL|leseiként
lesei|N;IN+ABL;PL|leseiből
lesei|N;IN+ALL;PL|leseibe
lesei|N;IN+ESS;PL|leseiben
lesei|N;INS;PL|leseivel
lesei|N;NOM;PL|lesei
lesei|N;ON+ABL;PL|leseiről
lesei|N;ON+ALL;PL|leseire
lesei|N;ON+ESS;PL|lesein
lesei|N;PRP;PL|leseiért
lesei|N;TERM;PL|leseiig
lesei|N;TRANS;PL|leseivé
lett|N;AT+ABL;SG|lettől
libanoni|N;PSS1P;PL|libanonijaink
libanoni|N;PSS1S;PL|libanonijaim
libanoni|N;PSS2P;PL|libanonijaitok
libanoni|N;PSS2S;PL|libanonijaid
libanoni|N;PSS3P;PL|libanonijaik
libanoni|N;PSS3S;PL|libanonijai
licsi|N;PSS1P;PL|licsijeink
licsi|N;PSS1S;PL|licsijeim
licsi|N;PSS2P;PL|licsijeitek
licsi|N;PSS2S;PL|licsijeid
licsi|N;PSS3P;PL|licsijeik
licsi|N;PSS3S;PL|licsijei
Łódź|N;INS;SG|Łódźdzsal
Łódź|N;TRANS;SG|Łódźdzsá
lokni|N;PSS1P;PL|loknijaink
lokni|N;PSS1S;PL|loknijaim
lokni|N;PSS2P;PL|loknijaitok
lokni|N;PSS2S;PL|loknijaid
lokni|N;PSS3P;PL|loknijaik
lokni|N;PSS3S;PL|loknijai
lombikbébi|N;PSS1P;PL|lombikbébijeink
lombikbébi|N;PSS1S;PL|lombikbébijeim
lombikbébi|N;PSS2P;PL|lombikbébijeitek
lombikbébi|N;PSS2S;PL|lombikbébijeid
lombikbébi|N;PSS3P;PL|lombikbébijeik
lombikbébi|N;PSS3S;PL|lombikbébijei
lőszerraktár|N;ACC;SG|lőszerraktárat
lúd|N;PSS1P;PL|lúdjaink
lúd|N;PSS1S;PL|lúdjaim
lúd|N;PSS2P;PL|lúdjaitok
lúd|N;PSS2S;PL|lúdjaid
lúd|N;PSS3P;PL|lúdjaik
lúd|N;PSS3P;SG|lúdjuk
lúd|N;PSS3S;PL|lúdjai
lúd|N;PSS3S;SG|lúdja
luxemburgi|N;PSS1P;PL|luxemburgijaink
luxemburgi|N;PSS1S;PL|luxemburgijaim
luxemburgi|N;PSS2P;PL|luxemburgijaitok
luxemburgi|N;PSS2S;PL|luxemburgijaid
luxemburgi|N;PSS3P;PL|luxemburgijaik
luxemburgi|N;PSS3S;PL|luxemburgijai
maci|N;PSS1P;PL|macijaink
maci|N;PSS1S;PL|macijaim
maci|N;PSS2P;PL|macijaitok
maci|N;PSS2S;PL|macijaid
maci|N;PSS3P;PL|macijaik
maci|N;PSS3S;PL|macijai
macskakő|N;PSS2P;SG|macskakövetek
madarai|N;ACC;PL|madarait
madarai|N;AT+ABL;PL|madaraitól
madarai|N;AT+ALL;PL|madaraihoz
madarai|N;AT+ESS;PL|madarainál
madarai|N;DAT;PL|madarainak
madarai|N;FRML;PL|madaraiként
madarai|N;IN+ABL;PL|madaraiból
madarai|N;IN+ALL;PL|madaraiba
madarai|N;IN+ESS;PL|madaraiban
madarai|N;INS;PL|madaraival
madarai|N;NOM;PL|madarai
madarai|N;ON+ABL;PL|madarairól
madarai|N;ON+ALL;PL|madaraira
madarai|N;ON+ESS;PL|madarain
madarai|N;PRP;PL|madaraiért
madarai|N;TERM;PL|madaraiig
madarai|N;TRANS;PL|madaraivá
máglyahalál|N;PSS1P;PL|máglyáhalálaink
máglyahalál|N;PSS1P;SG|máglyáhalálunk
máglyahalál|N;PSS1S;PL|máglyáhalálaim
máglyahalál|N;PSS1S;SG|máglyáhalálom
máglyahalál|N;PSS2P;PL|máglyáhalálaitok
máglyahalál|N;PSS2P;SG|máglyáhalálotok
máglyahalál|N;PSS2S;PL|máglyáhalálaid
máglyahalál|N;PSS2S;SG|máglyáhalálod
máglyahalál|N;PSS3P;PL|máglyáhalálaik
máglyahalál|N;PSS3P;SG|máglyáhaláluk
máglyahalál|N;PSS3S;PL|máglyáhalálai
máglyahalál|N;PSS3S;SG|máglyáhalála
maharáni|N;PSS1P;PL|maharánijaink
maharáni|N;PSS1S;PL|maharánijaim
maharáni|N;PSS2P;PL|maharánijaitok
maharáni|N;PSS2S;PL|maharánijaid
maharáni|N;PSS3P;PL|maharánijaik
maharáni|N;PSS3S;PL|maharánijai
makett|N;AT+ABL;SG|makettől
makk|N;FRML;SG|makként
malmai|N;ACC;PL|malmait
malmai|N;AT+ABL;PL|malmaitól
malmai|N;AT+ALL;PL|malmaihoz
malmai|N;AT+ESS;PL|malmainál
malmai|N;DAT;PL|malmainak
malmai|N;FRML;PL|malmaiként
malmai|N;IN+ABL;PL|malmaiból
malmai|N;IN+ALL;PL|malmaiba
malmai|N;IN+ESS;PL|malmaiban
malmai|N;INS;PL|malmaival
malmai|N;NOM;PL|malmai
malmai|N;ON+ABL;PL|malmairól
malmai|N;ON+ALL;PL|malmaira
malmai|N;ON+ESS;PL|malmain
malmai|N;PRP;PL|malmaiért
malmai|N;TERM;PL|malmaiig
malmai|N;TRANS;PL|malmaivá
máltai|N;PSS1P;PL|máltaijaink
máltai|N;PSS1S;PL|máltaijaim
máltai|N;PSS2P;PL|máltaijaitok
máltai|N;PSS2S;PL|máltaijaid
máltai|N;PSS3P;PL|máltaijaik
máltai|N;PSS3S;PL|máltaijai
mandarinréce|N;ACC;PL|mandarinrécéket
mandarinréce|N;AT+ABL;PL|mandarinrécéktől
mandarinréce|N;AT+ALL;PL|mandarinrécékhez
mandarinréce|N;AT+ESS;PL|mandarinrécéknél
mandarinréce|N;DAT;PL|mandarinrécéknek
mandarinréce|N;IN+ABL;PL|mandarinrécékből
mandarinréce|N;IN+ALL;PL|mandarinrécékbe
mandarinréce|N;IN+ESS;PL|mandarinrécékben
mandarinréce|N;INS;PL|mandarinrécékkel
mandarinréce|N;ON+ABL;PL|mandarinrécékről
mandarinréce|N;ON+ALL;PL|mandarinrécékre
mandarinréce|N;ON+ESS;PL|mandarinrécéken
mandarinréce|N;TRANS;PL|mandarinrécékké
mani|N;PSS1P;PL|manijaink
mani|N;PSS1S;PL|manijaim
mani|N;PSS2P;PL|manijaitok
mani|N;PSS2S;PL|manijaid
mani|N;PSS3P;PL|manijaik
mani|N;PSS3S;PL|manijai
manysi|N;PSS1P;PL|manysijaink
manysi|N;PSS1S;PL|manysijaim
manysi|N;PSS2P;PL|manysijaitok
manysi|N;PSS2S;PL|manysijaid
manysi|N;PSS3P;PL|manysijaik
manysi|N;PSS3S;PL|manysijai
marhasült|N;PSS2P;SG|marhasültetek
mari|N;PSS1P;PL|marijaink
mari|N;PSS1S;PL|marijaim
mari|N;PSS2P;PL|marijaitok
mari|N;PSS2S;PL|marijaid
mari|N;PSS3P;PL|marijaik
mari|N;PSS3S;PL|marijai
marionett|N;AT+ABL;SG|marionettől
márki|N;PSS1P;PL|márkijaink
márki|N;PSS1S;PL|márkijaim
márki|N;PSS2P;PL|márkijaitok
márki|N;PSS2S;PL|márkijaid
márki|N;PSS3P;PL|márkijaik
márki|N;PSS3S;PL|márkijai
maródi|N;PSS1P;PL|maródijaink
maródi|N;PSS1S;PL|maródijaim
maródi|N;PSS2P;PL|maródijaitok
maródi|N;PSS2S;PL|maródijaid
maródi|N;PSS3P;PL|maródijaik
maródi|N;PSS3S;PL|maródijai
marokkói|N;PSS1P;PL|marokkóijaink
marokkói|N;PSS1S;PL|marokkóijaim
marokkói|N;PSS2P;PL|marokkóijaitok
marokkói|N;PSS2S;PL|marokkóijaid
marokkói|N;PSS3P;PL|marokkóijaik
marokkói|N;PSS3S;PL|marokkóijai
mátrix|N;INS;SG|mátrixszal
mátrix|N;TRANS;SG|mátrixszá
mauritániai|N;PSS1P;PL|mauritániaijaink
mauritániai|N;PSS1S;PL|mauritániaijaim
mauritániai|N;PSS2P;PL|mauritániaijaitok
mauritániai|N;PSS2S;PL|mauritániaijaid
mauritániai|N;PSS3P;PL|mauritániaijaik
mauritániai|N;PSS3S;PL|mauritániaijai
mázli|N;PSS1P;PL|mázlijaink
mázli|N;PSS1S;PL|mázlijaim
mázli|N;PSS2P;PL|mázlijaitok
mázli|N;PSS2S;PL|mázlijaid
mázli|N;PSS3P;PL|mázlijaik
mázli|N;PSS3S;PL|mázlijai
mazsorett|N;AT+ABL;SG|mazsorettől
megbízott|N;AT+ABL;SG|megbízottól
megkérdezett|N;AT+ABL;SG|megkérdezettől
megszállott|N;AT+ABL;SG|megszállottól
méhészborz|N;ACC;SG|méhészborzot
melír|N;ACC;SG|melírt
melír|N;PSS1S;SG|melírom
melír|N;PSS2P;SG|melírotok
melír|N;PSS2S;SG|melírod
mellei|N;ACC;PL|melleit
mellei|N;AT+ABL;PL|melleitől
mellei|N;AT+ALL;PL|melleihez
mellei|N;AT+ESS;PL|melleinél
mellei|N;DAT;PL|melleinek
mellei|N;FRML;PL|melleiként
mellei|N;IN+ABL;PL|melleiből
mellei|N;IN+ALL;PL|melleibe
mellei|N;IN+ESS;PL|melleiben
mellei|N;INS;PL|melleivel
mellei|N;NOM;PL|mellei
mellei|N;ON+ABL;PL|melleiről
mellei|N;ON+ALL;PL|melleire
mellei|N;ON+ESS;PL|mellein
mellei|N;PRP;PL|melleiért
mellei|N;TERM;PL|melleiig
mellei|N;TRANS;PL|melleivé
mellékszög|N;AT+ALL;SG|mellékszöghez
mellékszög|N;ON+ESS;SG|mellékszögen
menedékjog|N;AT+ABL;SG|hmenedékjogtól
menedékjog|N;AT+ALL;SG|hmenedékjoghoz
menedékjog|N;AT+ESS;SG|hmenedékjognál
menedékjog|N;DAT;SG|hmenedékjognak
menedékjog|N;IN+ABL;SG|hmenedékjogból
menedékjog|N;IN+ALL;SG|hmenedékjogba
menedékjog|N;IN+ESS;SG|hmenedékjogban
menedékjog|N;INS;SG|hmenedékjoggal
menedékjog|N;ON+ABL;SG|hmenedékjogról
menedékjog|N;ON+ALL;SG|hmenedékjogra
menedékjog|N;PRP;SG|hmenedékjogért
menedékjog|N;TERM;SG|hmenedékjogig
menedékjog|N;TRANS;SG|hmenedékjoggá
menekült|N;PSS2P;SG|menekültetek
mérföld|N;PSS2P;SG|mérföldetek
mesterei|N;ACC;PL|mestereit
mesterei|N;AT+ABL;PL|mestereitől
mesterei|N;AT+ALL;PL|mestereihez
mesterei|N;AT+ESS;PL|mestereinél
mesterei|N;DAT;PL|mestereinek
mesterei|N;FRML;PL|mestereiként
mesterei|N;IN+ABL;PL|mestereiből
mesterei|N;IN+ALL;PL|mestereibe
mesterei|N;IN+ESS;PL|mestereiben
mesterei|N;INS;PL|mestereivel
mesterei|N;NOM;PL|mesterei
mesterei|N;ON+ABL;PL|mestereiről
mesterei|N;ON+ALL;PL|mestereire
mesterei|N;ON+ESS;PL|mesterein
mesterei|N;PRP;PL|mestereiért
mesterei|N;TERM;PL|mestereiig
mesterei|N;TRANS;PL|mestereivé
mestermű|N;PSS2P;SG|mesterművetek
mészkő|N;PSS2P;SG|mészkövetek
mexikói|N;PSS1P;PL|mexikóijaink
mexikói|N;PSS1S;PL|mexikóijaim
mexikói|N;PSS2P;PL|mexikóijaitok
mexikói|N;PSS2S;PL|mexikóijaid
mexikói|N;PSS3P;PL|mexikóijaik
mexikói|N;PSS3S;PL|mexikóijai
mini|N;PSS1P;PL|minijeink
mini|N;PSS1S;PL|minijeim
mini|N;PSS2P;PL|minijeitek
mini|N;PSS2S;PL|minijeid
mini|N;PSS3P;PL|minijeik
mini|N;PSS3S;PL|minijei
módi|N;PSS1P;PL|módijaink
módi|N;PSS1S;PL|módijaim
módi|N;PSS2P;PL|módijaitok
módi|N;PSS2S;PL|módijaid
módi|N;PSS3P;PL|módijaik
módi|N;PSS3S;PL|módijai
monitorai|N;ACC;PL|monitorait
monitorai|N;AT+ABL;PL|monitoraitól
monitorai|N;AT+ALL;PL|monitoraihoz
monitorai|N;AT+ESS;PL|monitorainál
monitorai|N;DAT;PL|monitorainak
monitorai|N;FRML;PL|monitoraiként
monitorai|N;IN+ABL;PL|monitoraiból
monitorai|N;IN+ALL;PL|monitoraiba
monitorai|N;IN+ESS;PL|monitoraiban
monitorai|N;INS;PL|monitoraival
monitorai|N;NOM;PL|monitorai
monitorai|N;ON+ABL;PL|monitorairól
monitorai|N;ON+ALL;PL|monitoraira
monitorai|N;ON+ESS;PL|monitorain
monitorai|N;PRP;PL|monitoraiért
monitorai|N;TERM;PL|monitoraiig
monitorai|N;TRANS;PL|monitoraivá
mordvin|N;ACC;SG|mordvinot
mostohaanya|N;PSS3P;SG|mostohaanyjuk
mostohaanya|N;PSS3S;SG|mostohaanyja
mostohaapa|N;PSS3P;SG|mostohaapjuk
mostohaapa|N;PSS3S;SG|mostohaapja
mozambiki|N;PSS1P;PL|mozambikijaink
mozambiki|N;PSS1S;PL|mozambikijaim
mozambiki|N;PSS2P;PL|mozambikijaitok
mozambiki|N;PSS2S;PL|mozambikijaid
mozambiki|N;PSS3P;PL|mozambikijaik
mozambiki|N;PSS3S;PL|mozambikijai
mozgáskorlátozott|N;AT+ABL;SG|mozgáskorlátozottól
mozi|N;PSS1P;PL|mozijaink
mozi|N;PSS1S;PL|mozijaim
mozi|N;PSS2P;PL|mozijaitok
mozi|N;PSS2S;PL|mozijaid
mozi|N;PSS3P;PL|mozijaik
mozi|N;PSS3S;PL|mozijai
mudi|N;PSS1P;PL|mudijaink
mudi|N;PSS1S;PL|mudijaim
mudi|N;PSS2P;PL|mudijaitok
mudi|N;PSS2S;PL|mudijaid
mudi|N;PSS3P;PL|mudijaik
mudi|N;PSS3S;PL|mudijai
mufti|N;PSS1P;PL|muftijaink
mufti|N;PSS1S;PL|muftijaim
mufti|N;PSS2P;PL|muftijaitok
mufti|N;PSS2S;PL|muftijaid
mufti|N;PSS3P;PL|muftijaik
mufti|N;PSS3S;PL|muftijai
multi|N;PSS1P;PL|multijaink
multi|N;PSS1S;PL|multijaim
multi|N;PSS2P;PL|multijaitok
multi|N;PSS2S;PL|multijaid
multi|N;PSS3P;PL|multijaik
multi|N;PSS3S;PL|multijai
mumpsz|N;ACC;SG|mumpszot
munkáltatói|N;ACC;PL|munkáltatóit
munkáltatói|N;AT+ABL;PL|munkáltatóitól
munkáltatói|N;AT+ALL;PL|munkáltatóihoz
munkáltatói|N;AT+ESS;PL|munkáltatóinál
munkáltatói|N;DAT;PL|munkáltatóinak
munkáltatói|N;FRML;PL|munkáltatóiként
munkáltatói|N;IN+ABL;PL|munkáltatóiból
munkáltatói|N;IN+ALL;PL|munkáltatóiba
munkáltatói|N;IN+ESS;PL|munkáltatóiban
munkáltatói|N;INS;PL|munkáltatóival
munkáltatói|N;NOM;PL|munkáltatói
munkáltatói|N;ON+ABL;PL|munkáltatóiról
munkáltatói|N;ON+ALL;PL|munkáltatóira
munkáltatói|N;ON+ESS;PL|munkáltatóin
munkáltatói|N;PRP;PL|munkáltatóiért
munkáltatói|N;TERM;PL|munkáltatóiig
munkáltatói|N;TRANS;PL|munkáltatóivá
muszkli|N;PSS1P;PL|muszklijaink
muszkli|N;PSS1S;PL|muszklijaim
muszkli|N;PSS2P;PL|muszklijaitok
muszkli|N;PSS2S;PL|muszklijaid
muszkli|N;PSS3P;PL|muszklijaik
muszkli|N;PSS3S;PL|muszklijai
műbarát|N;PSS3P;SG|műbarátjuk
műbarát|N;PSS3S;SG|műbarátja
műkő|N;PSS2P;SG|műkövetek
műszaki|N;PSS1P;PL|műszakijaink
műszaki|N;PSS1S;PL|műszakijaim
műszaki|N;PSS2P;PL|műszakijaitok
műszaki|N;PSS2S;PL|műszakijaid
műszaki|N;PSS3P;PL|műszakijaik
műszaki|N;PSS3S;PL|műszakijai
műút|N;PSS1P;PL|műútjaink
műút|N;PSS1S;PL|műútjaim
műút|N;PSS2P;PL|műútjaitok
műút|N;PSS2S;PL|műútjaid
műút|N;PSS3P;PL|műútjaik
műút|N;PSS3P;SG|műútjuk
műút|N;PSS3S;PL|műútjai
műút|N;PSS3S;SG|műútja
müzli|N;PSS1P;PL|müzlijeink
müzli|N;PSS1S;PL|müzlijeim
müzli|N;PSS2P;PL|müzlijeitek
müzli|N;PSS2S;PL|müzlijeid
müzli|N;PSS3P;PL|müzlijeik
müzli|N;PSS3S;PL|müzlijei
naci|N;PSS1P;PL|nacijaink
náci|N;PSS1P;PL|nácijaink
naci|N;PSS1S;PL|nacijaim
náci|N;PSS1S;PL|nácijaim
naci|N;PSS2P;PL|nacijaitok
náci|N;PSS2P;PL|nácijaitok
naci|N;PSS2S;PL|nacijaid
náci|N;PSS2S;PL|nácijaid
naci|N;PSS3P;PL|nacijaik
náci|N;PSS3P;PL|nácijaik
naci|N;PSS3S;PL|nacijai
náci|N;PSS3S;PL|nácijai
nagyanya|N;PSS3P;SG|nagyanyjuk
nagyanya|N;PSS3S;SG|nagyanyja
nagyapa|N;PSS3P;SG|nagyapjuk
nagyapa|N;PSS3S;SG|nagyapja
nagybácsi|N;PSS1P;PL|nagybácsijaink
nagybácsi|N;PSS1S;PL|nagybácsijaim
nagybácsi|N;PSS2P;PL|nagybácsijaitok
nagybácsi|N;PSS2S;PL|nagybácsijaid
nagybácsi|N;PSS3P;PL|nagybácsijaik
nagybácsi|N;PSS3S;PL|nagybácsijai
nagybáty|N;PSS1P;PL|nagybátyáink
nagybáty|N;PSS1P;SG|nagybátyánk
nagybáty|N;PSS1S;PL|nagybátyáim
nagybáty|N;PSS1S;SG|nagybátyám
nagybáty|N;PSS2P;PL|nagybátyáitok
nagybáty|N;PSS2P;SG|nagybátyátok
nagybáty|N;PSS2S;PL|nagybátyáid
nagybáty|N;PSS2S;SG|nagybátyád
nagybáty|N;PSS3P;PL|nagybátyáik
nagybáty|N;PSS3S;PL|nagybátyái
nagybátya|N;PSS1P;PL|nagybátyjaink
nagybátya|N;PSS1S;PL|nagybátyjaim
nagybátya|N;PSS2P;PL|nagybátyjaitok
nagybátya|N;PSS2S;PL|nagybátyjaid
nagybátya|N;PSS3P;PL|nagybátyjaik
nagybátya|N;PSS3P;SG|nagybátyjuk
nagybátya|N;PSS3S;PL|nagybátyjai
nagybátya|N;PSS3S;SG|nagybátyja
nagyestélyi|N;PSS1P;PL|nagyestélyijeink
nagyestélyi|N;PSS1S;PL|nagyestélyijeim
nagyestélyi|N;PSS2P;PL|nagyestélyijeitek
nagyestélyi|N;PSS2S;PL|nagyestélyijeid
nagyestélyi|N;PSS3P;PL|nagyestélyijeik
nagyestélyi|N;PSS3S;PL|nagyestélyijei
nagymise|N;ACC;PL|nagymiséket
nagymise|N;AT+ABL;PL|nagymiséktől
nagymise|N;AT+ALL;PL|nagymisékhez
nagymise|N;AT+ESS;PL|nagymiséknél
nagymise|N;DAT;PL|nagymiséknek
nagymise|N;IN+ABL;PL|nagymisékből
nagymise|N;IN+ALL;PL|nagymisékbe
nagymise|N;IN+ESS;PL|nagymisékben
nagymise|N;INS;PL|nagymisékkel
nagymise|N;ON+ABL;PL|nagymisékről
nagymise|N;ON+ALL;PL|nagymisékre
nagymise|N;ON+ESS;PL|nagymiséken
nagymise|N;TRANS;PL|nagymisékké
nagynéni|N;PSS1P;PL|nagynénijeink
nagynéni|N;PSS1S;PL|nagynénijeim
nagynéni|N;PSS2P;PL|nagynénijeitek
nagynéni|N;PSS2S;PL|nagynénijeid
nagynéni|N;PSS3P;PL|nagynénijeik
nagynéni|N;PSS3S;PL|nagynénijei
nagyvak|N;PSS1P;PL|nagyakjaink
nagyvak|N;PSS1P;SG|nagyakunk
nagyvak|N;PSS1S;PL|nagyakjaim
nagyvak|N;PSS1S;SG|nagyakom
nagyvak|N;PSS2P;PL|nagyakjaitok
nagyvak|N;PSS2P;SG|nagyakotok
nagyvak|N;PSS2S;PL|nagyakjaid
nagyvak|N;PSS2S;SG|nagyakod
nagyvak|N;PSS3P;PL|nagyakjaik
nagyvak|N;PSS3P;SG|nagyakjuk
nagyvak|N;PSS3S;PL|nagyakjai
nagyvak|N;PSS3S;SG|nagyakja
namíbiai|N;PSS1P;PL|namíbiaijaink
namíbiai|N;PSS1S;PL|namíbiaijaim
namíbiai|N;PSS2P;PL|namíbiaijaitok
namíbiai|N;PSS2S;PL|namíbiaijaid
namíbiai|N;PSS3P;PL|namíbiaijaik
namíbiai|N;PSS3S;PL|namíbiaijai
nápolyi|N;PSS1P;PL|nápolyijaink
nápolyi|N;PSS1S;PL|nápolyijaim
nápolyi|N;PSS2P;PL|nápolyijaitok
nápolyi|N;PSS2S;PL|nápolyijaid
nápolyi|N;PSS3P;PL|nápolyijaik
nápolyi|N;PSS3S;PL|nápolyijai
nappali|N;PSS1P;PL|nappalijaink
nappali|N;PSS1S;PL|nappalijaim
nappali|N;PSS2P;PL|nappalijaitok
nappali|N;PSS2S;PL|nappalijaid
nappali|N;PSS3P;PL|nappalijaik
nappali|N;PSS3S;PL|nappalijai
nászút|N;PSS1P;PL|nászútjaink
nászút|N;PSS1S;PL|nászútjaim
nászút|N;PSS2P;PL|nászútjaitok
nászút|N;PSS2S;PL|nászútjaid
nászút|N;PSS3P;PL|nászútjaik
nászút|N;PSS3P;SG|nászútjuk
nászút|N;PSS3S;PL|nászútjai
nászút|N;PSS3S;SG|nászútja
nemei|N;ACC;PL|nemeit
nemei|N;AT+ABL;PL|nemeitől
nemei|N;AT+ALL;PL|nemeihez
nemei|N;AT+ESS;PL|nemeinél
nemei|N;DAT;PL|nemeinek
nemei|N;FRML;PL|nemeiként
nemei|N;IN+ABL;PL|nemeiből
nemei|N;IN+ALL;PL|nemeibe
nemei|N;IN+ESS;PL|nemeiben
nemei|N;INS;PL|nemeivel
nemei|N;NOM;PL|nemei
nemei|N;ON+ABL;PL|nemeiről
nemei|N;ON+ALL;PL|nemeire
nemei|N;ON+ESS;PL|nemein
nemei|N;PRP;PL|nemeiért
nemei|N;TERM;PL|nemeiig
nemei|N;TRANS;PL|nemeivé
néni|N;PSS1P;PL|nénijeink
néni|N;PSS1S;PL|nénijeim
néni|N;PSS2P;PL|nénijeitek
néni|N;PSS2S;PL|nénijeid
néni|N;PSS3P;PL|nénijeik
néni|N;PSS3S;PL|nénijei
nepáli|N;PSS1P;PL|nepálijaink
nepáli|N;PSS1S;PL|nepálijaim
nepáli|N;PSS2P;PL|nepálijaitok
nepáli|N;PSS2S;PL|nepálijaid
nepáli|N;PSS3P;PL|nepálijaik
nepáli|N;PSS3S;PL|nepálijai
néprajz|N;ACC;SG|néprajzot
netovább|N;IN+ABL;SG|netovábból
netovább|N;IN+ALL;SG|netovábba
netovább|N;IN+ESS;SG|netovábban
nevei|N;ACC;PL|neveit
nevei|N;AT+ABL;PL|neveitől
nevei|N;AT+ALL;PL|neveihez
nevei|N;AT+ESS;PL|neveinél
nevei|N;DAT;PL|neveinek
nevei|N;FRML;PL|neveiként
nevei|N;IN+ABL;PL|neveiből
nevei|N;IN+ALL;PL|neveibe
nevei|N;IN+ESS;PL|neveiben
nevei|N;INS;PL|neveivel
nevei|N;NOM;PL|nevei
nevei|N;ON+ABL;PL|neveiről
nevei|N;ON+ALL;PL|neveire
nevei|N;ON+ESS;PL|nevein
nevei|N;PRP;PL|neveiért
nevei|N;TERM;PL|neveiig
nevei|N;TRANS;PL|neveivé
nevelőszülő|N;PSS1P;PL|nevelőszüleink
nevelőszülő|N;PSS1S;PL|nevelőszüleim
nevelőszülő|N;PSS2P;PL|nevelőszüleitek
nevelőszülő|N;PSS2S;PL|nevelőszüleid
nevelőszülő|N;PSS3P;PL|nevelőszüleik
nevelőszülő|N;PSS3S;PL|nevelőszülei
nevetség|N;ACC;SG|nevetségt
nicaraguai|N;PSS1P;PL|nicaraguaijaink
nicaraguai|N;PSS1S;PL|nicaraguaijaim
nicaraguai|N;PSS2P;PL|nicaraguaijaitok
nicaraguai|N;PSS2S;PL|nicaraguaijaid
nicaraguai|N;PSS3P;PL|nicaraguaijaik
nicaraguai|N;PSS3S;PL|nicaraguaijai
nokedli|N;PSS1P;PL|nokedlijeink
nokedli|N;PSS1S;PL|nokedlijeim
nokedli|N;PSS2P;PL|nokedlijeitek
nokedli|N;PSS2S;PL|nokedlijeid
nokedli|N;PSS3P;PL|nokedlijeik
nokedli|N;PSS3S;PL|nokedlijei
norvégiai|N;PSS1P;PL|norvégiaijaink
norvégiai|N;PSS1S;PL|norvégiaijaim
norvégiai|N;PSS2P;PL|norvégiaijaitok
norvégiai|N;PSS2S;PL|norvégiaijaid
norvégiai|N;PSS3P;PL|norvégiaijaik
norvégiai|N;PSS3S;PL|norvégiaijai
nudli|N;PSS1P;PL|nudlijaink
nudli|N;PSS1S;PL|nudlijaim
nudli|N;PSS2P;PL|nudlijaitok
nudli|N;PSS2S;PL|nudlijaid
nudli|N;PSS3P;PL|nudlijaik
nudli|N;PSS3S;PL|nudlijai
nyakörv|N;PSS2P;SG|nyakörvetek
nyersolaj|N;ACC;SG|nyersolajat
nyolcadik|N;ACC;SG|nyolcadikat
nyolcszög|N;PSS2P;SG|nyolcszögetek
nyuszi|N;PSS1P;PL|nyuszijaink
nyuszi|N;PSS1S;PL|nyuszijaim
nyuszi|N;PSS2P;PL|nyuszijaitok
nyuszi|N;PSS2S;PL|nyuszijaid
nyuszi|N;PSS3P;PL|nyuszijaik
nyuszi|N;PSS3S;PL|nyuszijai
obi|N;PSS1P;PL|obijaink
obi|N;PSS1S;PL|obijaim
obi|N;PSS2P;PL|obijaitok
obi|N;PSS2S;PL|obijaid
obi|N;PSS3P;PL|obijaik
obi|N;PSS3S;PL|obijai
ókori|N;PSS1P;PL|ókorijaink
ókori|N;PSS1S;PL|ókorijaim
ókori|N;PSS2P;PL|ókorijaitok
ókori|N;PSS2S;PL|ókorijaid
ókori|N;PSS3P;PL|ókorijaik
ókori|N;PSS3S;PL|ókorijai
oktatói|N;ACC;PL|oktatóit
oktatói|N;AT+ABL;PL|oktatóitól
oktatói|N;AT+ALL;PL|oktatóihoz
oktatói|N;AT+ESS;PL|oktatóinál
oktatói|N;DAT;PL|oktatóinak
oktatói|N;FRML;PL|oktatóiként
oktatói|N;IN+ABL;PL|oktatóiból
oktatói|N;IN+ALL;PL|oktatóiba
oktatói|N;IN+ESS;PL|oktatóiban
oktatói|N;INS;PL|oktatóival
oktatói|N;NOM;PL|oktatói
oktatói|N;ON+ABL;PL|oktatóiról
oktatói|N;ON+ALL;PL|oktatóira
oktatói|N;ON+ESS;PL|oktatóin
oktatói|N;PRP;PL|oktatóiért
oktatói|N;TERM;PL|oktatóiig
oktatói|N;TRANS;PL|oktatóivá
oldal|N;ACC;SG|oldalt
oldalkocsi|N;PSS1P;PL|oldalkocsijaink
oldalkocsi|N;PSS1S;PL|oldalkocsijaim
oldalkocsi|N;PSS2P;PL|oldalkocsijaitok
oldalkocsi|N;PSS2S;PL|oldalkocsijaid
oldalkocsi|N;PSS3P;PL|oldalkocsijaik
oldalkocsi|N;PSS3S;PL|oldalkocsijai
olvasói|N;ACC;PL|olvasóit
olvasói|N;AT+ABL;PL|olvasóitól
olvasói|N;AT+ALL;PL|olvasóihoz
olvasói|N;AT+ESS;PL|olvasóinál
olvasói|N;DAT;PL|olvasóinak
olvasói|N;FRML;PL|olvasóiként
olvasói|N;IN+ABL;PL|olvasóiból
olvasói|N;IN+ALL;PL|olvasóiba
olvasói|N;IN+ESS;PL|olvasóiban
olvasói|N;INS;PL|olvasóival
olvasói|N;NOM;PL|olvasói
olvasói|N;ON+ABL;PL|olvasóiról
olvasói|N;ON+ALL;PL|olvasóira
olvasói|N;ON+ESS;PL|olvasóin
olvasói|N;PRP;PL|olvasóiért
olvasói|N;TERM;PL|olvasóiig
olvasói|N;TRANS;PL|olvasóivá
omlett|N;AT+ABL;SG|omlettől
operett|N;AT+ABL;SG|operettől
óráid|N;ACC;PL|óráidat
óráid|N;AT+ABL;PL|óráidtól
óráid|N;AT+ALL;PL|óráidhoz
óráid|N;AT+ESS;PL|óráidnál
óráid|N;DAT;PL|óráidnak
óráid|N;FRML;PL|óráidként
óráid|N;IN+ABL;PL|óráidból
óráid|N;IN+ALL;PL|óráidba
óráid|N;IN+ESS;PL|óráidban
óráid|N;INS;PL|óráiddal
óráid|N;NOM;PL|óráid
óráid|N;ON+ABL;PL|óráidról
óráid|N;ON+ALL;PL|óráidra
óráid|N;ON+ESS;PL|óráidon
óráid|N;PRP;PL|óráidért
óráid|N;TERM;PL|óráidig
óráid|N;TRANS;PL|óráiddá
orr|N;ACC;SG|orrot
orr|N;ON+ABL;SG|orról
orr|N;ON+ALL;SG|orra
országút|N;PSS1P;PL|országútjaink
országút|N;PSS1S;PL|országútjaim
országút|N;PSS2P;PL|országútjaitok
országút|N;PSS2S;PL|országútjaid
országút|N;PSS3P;PL|országútjaik
országút|N;PSS3P;SG|országútjuk
országút|N;PSS3S;PL|országútjai
országút|N;PSS3S;SG|országútja
ortodox|N;INS;SG|ortodoxszal
ortodox|N;TRANS;SG|ortodoxszá
otthonülő|N;ACC;PL|hotthonülőket
otthonülő|N;ACC;SG|hotthonülőt
otthonülő|N;AT+ABL;PL|hotthonülőktől
otthonülő|N;AT+ABL;SG|hotthonülőtől
otthonülő|N;AT+ALL;PL|hotthonülőkhöz
otthonülő|N;AT+ALL;SG|hotthonülőhöz
otthonülő|N;AT+ESS;PL|hotthonülőknél
otthonülő|N;AT+ESS;SG|hotthonülőnél
otthonülő|N;DAT;PL|hotthonülőknek
otthonülő|N;DAT;SG|hotthonülőnek
otthonülő|N;IN+ABL;PL|hotthonülőkből
otthonülő|N;IN+ABL;SG|hotthonülőből
otthonülő|N;IN+ALL;PL|hotthonülőkbe
otthonülő|N;IN+ALL;SG|hotthonülőbe
otthonülő|N;IN+ESS;PL|hotthonülőkben
otthonülő|N;IN+ESS;SG|hotthonülőben
otthonülő|N;INS;PL|hotthonülőkkel
otthonülő|N;INS;SG|hotthonülővel
otthonülő|N;NOM;PL|hotthonülők
otthonülő|N;ON+ABL;PL|hotthonülőkről
otthonülő|N;ON+ABL;SG|hotthonülőről
otthonülő|N;ON+ALL;PL|hotthonülőkre
otthonülő|N;ON+ALL;SG|hotthonülőre
otthonülő|N;ON+ESS;PL|hotthonülőkön
otthonülő|N;ON+ESS;SG|hotthonülőn
otthonülő|N;PRP;PL|hotthonülőkért
otthonülő|N;PRP;SG|hotthonülőért
otthonülő|N;TERM;PL|hotthonülőkig
otthonülő|N;TERM;SG|hotthonülőig
otthonülő|N;TRANS;PL|hotthonülőkké
otthonülő|N;TRANS;SG|hotthonülővé
ovi|N;PSS1P;PL|ovijaink
ovi|N;PSS1S;PL|ovijaim
ovi|N;PSS2P;PL|ovijaitok
ovi|N;PSS2S;PL|ovijaid
ovi|N;PSS3P;PL|ovijaik
ovi|N;PSS3S;PL|ovijai
oxigén|N;PSS3P;SG|oxigénjük
oxigén|N;PSS3S;SG|oxigénje
öcs|N;PSS1P;PL|öcséink
öcs|N;PSS1P;SG|öcsénk
öcs|N;PSS1S;PL|öcséim
öcs|N;PSS1S;SG|öcsém
öcs|N;PSS2P;PL|öcséitek
öcs|N;PSS2P;SG|öcsétek
öcs|N;PSS2S;PL|öcséid
öcs|N;PSS2S;SG|öcséd
öcs|N;PSS3P;PL|öccseik
öcs|N;PSS3P;SG|öccsük
öcs|N;PSS3S;PL|öccsei
öcs|N;PSS3S;SG|öccse
öl|N;PSS2P;SG|öletek
ölyv|N;PSS2P;SG|ölyvetek
önéletrajz|N;ACC;SG|önéletrajzot
örökzöld|N;PSS2P;SG|örökzöldetek
őrs|N;ACC;SG|őrsöt
őrült|N;PSS2P;SG|őrültetek
örv|N;PSS2P;SG|örvetek
ötszög|N;PSS2P;SG|ötszögetek
öv|N;PSS2P;SG|övetek
őz|N;PSS2P;SG|őzetek
paci|N;PSS1P;PL|pacijaink
paci|N;PSS1S;PL|pacijaim
paci|N;PSS2P;PL|pacijaitok
paci|N;PSS2S;PL|pacijaid
paci|N;PSS3P;PL|pacijaik
paci|N;PSS3S;PL|pacijai
pacsuli|N;PSS1P;PL|pacsulijaink
pacsuli|N;PSS1S;PL|pacsulijaim
pacsuli|N;PSS2P;PL|pacsulijaitok
pacsuli|N;PSS2S;PL|pacsulijaid
pacsuli|N;PSS3P;PL|pacsulijaik
pacsuli|N;PSS3S;PL|pacsulijai
pajzs|N;ACC;SG|pajzsot
pakisztáni|N;PSS1P;PL|pakisztánijaink
pakisztáni|N;PSS1S;PL|pakisztánijaim
pakisztáni|N;PSS2P;PL|pakisztánijaitok
pakisztáni|N;PSS2S;PL|pakisztánijaid
pakisztáni|N;PSS3P;PL|pakisztánijaik
pakisztáni|N;PSS3S;PL|pakisztánijai
pakli|N;PSS1P;PL|paklijaink
pakli|N;PSS1S;PL|paklijaim
pakli|N;PSS2P;PL|paklijaitok
pakli|N;PSS2S;PL|paklijaid
pakli|N;PSS3P;PL|paklijaik
pakli|N;PSS3S;PL|paklijai
palesztin|N;ACC;SG|palesztint
palesztin|N;PSS1S;SG|palesztinom
palesztin|N;PSS2P;SG|palesztinotok
palesztin|N;PSS2S;SG|palesztinod
pali|N;PSS1P;PL|palijaink
pali|N;PSS1S;PL|palijaim
pali|N;PSS2P;PL|palijaitok
pali|N;PSS2S;PL|palijaid
pali|N;PSS3P;PL|palijaik
pali|N;PSS3S;PL|palijai
pántli|N;PSS1P;PL|pántlijaink
pántli|N;PSS1S;PL|pántlijaim
pántli|N;PSS2P;PL|pántlijaitok
pántli|N;PSS2S;PL|pántlijaid
pántli|N;PSS3P;PL|pántlijaik
pántli|N;PSS3S;PL|pántlijai
papi|N;PSS1P;PL|papijaink
papi|N;PSS1S;PL|papijaim
papi|N;PSS2P;PL|papijaitok
papi|N;PSS2S;PL|papijaid
papi|N;PSS3P;PL|papijaik
papi|N;PSS3S;PL|papijai
paratölgy|N;PSS2P;SG|paratölgyetek
parti|N;PSS1P;PL|partijaink
parti|N;PSS1S;PL|partijaim
parti|N;PSS2P;PL|partijaitok
parti|N;PSS2S;PL|partijaid
parti|N;PSS3P;PL|partijaik
parti|N;PSS3S;PL|partijai
pasi|N;PSS1P;PL|pasijaink
pasi|N;PSS1S;PL|pasijaim
pasi|N;PSS2P;PL|pasijaitok
pasi|N;PSS2S;PL|pasijaid
pasi|N;PSS3P;PL|pasijaik
pasi|N;PSS3S;PL|pasijai
patni|N;PSS1P;PL|patnijaink
patni|N;PSS1S;PL|patnijaim
patni|N;PSS2P;PL|patnijaitok
patni|N;PSS2S;PL|patnijaid
patni|N;PSS3P;PL|patnijaik
patni|N;PSS3S;PL|patnijai
pénzügy|N;PSS2P;SG|pénzügyetek
perecei|N;ACC;PL|pereceit
perecei|N;AT+ABL;PL|pereceitől
perecei|N;AT+ALL;PL|pereceihez
perecei|N;AT+ESS;PL|pereceinél
perecei|N;DAT;PL|pereceinek
perecei|N;FRML;PL|pereceiként
perecei|N;IN+ABL;PL|pereceiből
perecei|N;IN+ALL;PL|pereceibe
perecei|N;IN+ESS;PL|pereceiben
perecei|N;INS;PL|pereceivel
perecei|N;NOM;PL|perecei
perecei|N;ON+ABL;PL|pereceiről
perecei|N;ON+ALL;PL|pereceire
perecei|N;ON+ESS;PL|perecein
perecei|N;PRP;PL|pereceiért
perecei|N;TERM;PL|pereceiig
perecei|N;TRANS;PL|pereceivé
pesti|N;PSS1P;PL|pestijeink
pesti|N;PSS1S;PL|pestijeim
pesti|N;PSS2P;PL|pestijeitek
pesti|N;PSS2S;PL|pestijeid
pesti|N;PSS3P;PL|pestijeik
pesti|N;PSS3S;PL|pestijei
piccolo|N;AT+ABL;SG|piccoltól
piccolo|N;AT+ALL;SG|piccolhoz
piccolo|N;AT+ESS;SG|piccolnál
piccolo|N;DAT;SG|piccolnak
piccolo|N;FRML;SG|piccolként
piccolo|N;IN+ABL;SG|piccolból
piccolo|N;IN+ALL;SG|piccolba
piccolo|N;IN+ESS;SG|piccolban
piccolo|N;INS;SG|piccollal
piccolo|N;ON+ABL;SG|piccolról
piccolo|N;ON+ALL;SG|piccolra
piccolo|N;PRP;SG|piccolért
piccolo|N;TERM;SG|piccolig
piccolo|N;TRANS;SG|piccollá
pici|N;PSS1P;PL|picijeink
pici|N;PSS1S;PL|picijeim
pici|N;PSS2P;PL|picijeitek
pici|N;PSS2S;PL|picijeid
pici|N;PSS3P;PL|picijeik
pici|N;PSS3S;PL|picijei
pikk|N;FRML;SG|pikként
pillangóféle|N;ACC;PL|pillangóféléket
pillangóféle|N;AT+ABL;PL|pillangóféléktől
pillangóféle|N;AT+ALL;PL|pillangófélékhez
pillangóféle|N;AT+ESS;PL|pillangóféléknél
pillangóféle|N;DAT;PL|pillangóféléknek
pillangóféle|N;IN+ABL;PL|pillangófélékből
pillangóféle|N;IN+ALL;PL|pillangófélékbe
pillangóféle|N;IN+ESS;PL|pillangófélékben
pillangóféle|N;INS;PL|pillangófélékkel
pillangóféle|N;ON+ABL;PL|pillangófélékről
pillangóféle|N;ON+ALL;PL|pillangófélékre
pillangóféle|N;ON+ESS;PL|pillangóféléken
pillangóféle|N;TRANS;PL|pillangófélékké
pillangóhatás|N;ACC;SG|pillangóhatásot
pír|N;ACC;SG|pírt
pír|N;PSS1S;SG|pírom
pír|N;PSS2P;SG|pírotok
pír|N;PSS2S;SG|pírod
piruett|N;AT+ABL;SG|piruettől
pisi|N;PSS1P;PL|pisijeink
pisi|N;PSS1S;PL|pisijeim
pisi|N;PSS2P;PL|pisijeitek
pisi|N;PSS2S;PL|pisijeid
pisi|N;PSS3P;PL|pisijeik
pisi|N;PSS3S;PL|pisijei
placebo|N;ACC;PL|placebókat
placebo|N;ACC;SG|placebót
placebo|N;AT+ABL;PL|placebóktól
placebo|N;AT+ABL;SG|placebótól
placebo|N;AT+ALL;PL|placebókhoz
placebo|N;AT+ALL;SG|placebóhoz
placebo|N;AT+ESS;PL|placebóknál
placebo|N;AT+ESS;SG|placebónál
placebo|N;DAT;PL|placebóknak
placebo|N;DAT;SG|placebónak
placebo|N;IN+ABL;PL|placebókból
placebo|N;IN+ABL;SG|placebóból
placebo|N;IN+ALL;PL|placebókba
placebo|N;IN+ALL;SG|placebóba
placebo|N;IN+ESS;PL|placebókban
placebo|N;IN+ESS;SG|placebóban
placebo|N;INS;PL|placebókkal
placebo|N;INS;SG|placebóval
placebo|N;NOM;PL|placebók
placebo|N;ON+ABL;PL|placebókról
placebo|N;ON+ABL;SG|placebóról
placebo|N;ON+ALL;PL|placebókra
placebo|N;ON+ALL;SG|placebóra
placebo|N;ON+ESS;PL|placebókon
placebo|N;ON+ESS;SG|placebón
placebo|N;PRP;PL|placebókért
placebo|N;PRP;SG|placebóért
placebo|N;TERM;PL|placebókig
placebo|N;TERM;SG|placebóig
placebo|N;TRANS;PL|placebókká
placebo|N;TRANS;SG|placebóvá
póni|N;PSS1P;PL|pónijaink
póni|N;PSS1S;PL|pónijaim
póni|N;PSS2P;PL|pónijaitok
póni|N;PSS2S;PL|pónijaid
póni|N;PSS3P;PL|pónijaik
póni|N;PSS3S;PL|pónijai
popsi|N;PSS1P;PL|popsijaink
popsi|N;PSS1S;PL|popsijaim
popsi|N;PSS2P;PL|popsijaitok
popsi|N;PSS2S;PL|popsijaid
popsi|N;PSS3P;PL|popsijaik
popsi|N;PSS3S;PL|popsijai
postakocsi|N;PSS1P;PL|postakocsijaink
postakocsi|N;PSS1S;PL|postakocsijaim
postakocsi|N;PSS2P;PL|postakocsijaitok
postakocsi|N;PSS2S;PL|postakocsijaid
postakocsi|N;PSS3P;PL|postakocsijaik
postakocsi|N;PSS3S;PL|postakocsijai
préri|N;PSS1P;PL|prérijeink
préri|N;PSS1S;PL|prérijeim
préri|N;PSS2P;PL|prérijeitek
préri|N;PSS2S;PL|prérijeid
préri|N;PSS3P;PL|prérijeik
préri|N;PSS3S;PL|prérijei
privi|N;PSS1P;PL|privijeink
privi|N;PSS1S;PL|privijeim
privi|N;PSS2P;PL|privijeitek
privi|N;PSS2S;PL|privijeid
privi|N;PSS3P;PL|privijeik
privi|N;PSS3S;PL|privijei
profi|N;PSS1P;PL|profijaink
profi|N;PSS1S;PL|profijaim
profi|N;PSS2P;PL|profijaitok
profi|N;PSS2S;PL|profijaid
profi|N;PSS3P;PL|profijaik
profi|N;PSS3S;PL|profijai
prosti|N;PSS1P;PL|prostijaink
prosti|N;PSS1S;PL|prostijaim
prosti|N;PSS2P;PL|prostijaitok
prosti|N;PSS2S;PL|prostijaid
prosti|N;PSS3P;PL|prostijaik
prosti|N;PSS3S;PL|prostijai
prüdéria|N;ACC;PL|prüdáriákat
prüdéria|N;ACC;SG|prüdáriát
prüdéria|N;AT+ABL;PL|prüdáriáktól
prüdéria|N;AT+ABL;SG|prüdáriától
prüdéria|N;AT+ALL;PL|prüdáriákhoz
prüdéria|N;AT+ALL;SG|prüdáriához
prüdéria|N;AT+ESS;PL|prüdáriáknál
prüdéria|N;AT+ESS;SG|prüdáriánál
prüdéria|N;DAT;PL|prüdáriáknak
prüdéria|N;DAT;SG|prüdáriának
prüdéria|N;IN+ABL;PL|prüdáriákból
prüdéria|N;IN+ABL;SG|prüdáriából
prüdéria|N;IN+ALL;PL|prüdáriákba
prüdéria|N;IN+ALL;SG|prüdáriába
prüdéria|N;IN+ESS;PL|prüdáriákban
prüdéria|N;IN+ESS;SG|prüdáriában
prüdéria|N;INS;PL|prüdáriákkal
prüdéria|N;INS;SG|prüdáriával
prüdéria|N;NOM;PL|prüdáriák
prüdéria|N;ON+ABL;PL|prüdáriákról
prüdéria|N;ON+ABL;SG|prüdáriáról
prüdéria|N;ON+ALL;PL|prüdáriákra
prüdéria|N;ON+ALL;SG|prüdáriára
prüdéria|N;ON+ESS;PL|prüdáriákon
prüdéria|N;ON+ESS;SG|prüdárián
prüdéria|N;PRP;PL|prüdáriákért
prüdéria|N;PRP;SG|prüdáriáért
prüdéria|N;TERM;PL|prüdáriákig
prüdéria|N;TERM;SG|prüdáriáig
prüdéria|N;TRANS;PL|prüdáriákká
prüdéria|N;TRANS;SG|prüdáriává
pszi|N;PSS1P;PL|pszijeink
pszi|N;PSS1S;PL|pszijeim
pszi|N;PSS2P;PL|pszijeitek
pszi|N;PSS2S;PL|pszijeid
pszi|N;PSS3P;PL|pszijeik
pszi|N;PSS3S;PL|pszijei
pukedli|N;PSS1P;PL|pukedlijaink
pukedli|N;PSS1S;PL|pukedlijaim
pukedli|N;PSS2P;PL|pukedlijaitok
pukedli|N;PSS2S;PL|pukedlijaid
pukedli|N;PSS3P;PL|pukedlijaik
pukedli|N;PSS3S;PL|pukedlijai
pulcsi|N;PSS1P;PL|pulcsijaink
pulcsi|N;PSS1S;PL|pulcsijaim
pulcsi|N;PSS2P;PL|pulcsijaitok
pulcsi|N;PSS2S;PL|pulcsijaid
pulcsi|N;PSS3P;PL|pulcsijaik
pulcsi|N;PSS3S;PL|pulcsijai
puli|N;PSS1P;PL|pulijaink
puli|N;PSS1S;PL|pulijaim
puli|N;PSS2P;PL|pulijaitok
puli|N;PSS2S;PL|pulijaid
puli|N;PSS3P;PL|pulijaik
puli|N;PSS3S;PL|pulijai
punci|N;PSS1P;PL|puncijaink
punci|N;PSS1S;PL|puncijaim
punci|N;PSS2P;PL|puncijaitok
punci|N;PSS2S;PL|puncijaid
punci|N;PSS3P;PL|puncijaik
punci|N;PSS3S;PL|puncijai
rabbi|N;PSS1P;PL|rabbijaink
rabbi|N;PSS1S;PL|rabbijaim
rabbi|N;PSS2P;PL|rabbijaitok
rabbi|N;PSS2S;PL|rabbijaid
rabbi|N;PSS3P;PL|rabbijaik
rabbi|N;PSS3S;PL|rabbijai
radírgumi|N;PSS1P;PL|radírgumijaink
radírgumi|N;PSS1S;PL|radírgumijaim
radírgumi|N;PSS2P;PL|radírgumijaitok
radírgumi|N;PSS2S;PL|radírgumijaid
radírgumi|N;PSS3P;PL|radírgumijaik
radírgumi|N;PSS3S;PL|radírgumijai
rágógumi|N;PSS1P;PL|rágógumijaink
rágógumi|N;PSS1S;PL|rágógumijaim
rágógumi|N;PSS2P;PL|rágógumijaitok
rágógumi|N;PSS2S;PL|rágógumijaid
rágógumi|N;PSS3P;PL|rágógumijaik
rágógumi|N;PSS3S;PL|rágógumijai
rajongói|N;ACC;PL|rajongóit
rajongói|N;AT+ABL;PL|rajongóitól
rajongói|N;AT+ALL;PL|rajongóihoz
rajongói|N;AT+ESS;PL|rajongóinál
rajongói|N;DAT;PL|rajongóinak
rajongói|N;FRML;PL|rajongóiként
rajongói|N;IN+ABL;PL|rajongóiból
rajongói|N;IN+ALL;PL|rajongóiba
rajongói|N;IN+ESS;PL|rajongóiban
rajongói|N;INS;PL|rajongóival
rajongói|N;NOM;PL|rajongói
rajongói|N;ON+ABL;PL|rajongóiról
rajongói|N;ON+ALL;PL|rajongóira
rajongói|N;ON+ESS;PL|rajongóin
rajongói|N;PRP;PL|rajongóiért
rajongói|N;TERM;PL|rajongóiig
rajongói|N;TRANS;PL|rajongóivá
rajz|N;ACC;SG|rajzot
randi|N;PSS1P;PL|randijaink
randi|N;PSS1S;PL|randijaim
randi|N;PSS2P;PL|randijaitok
randi|N;PSS2S;PL|randijaid
randi|N;PSS3P;PL|randijaik
randi|N;PSS3S;PL|randijai
ráni|N;PSS1P;PL|ránijaink
ráni|N;PSS1S;PL|ránijaim
ráni|N;PSS2P;PL|ránijaitok
ráni|N;PSS2S;PL|ránijaid
ráni|N;PSS3P;PL|ránijaik
ráni|N;PSS3S;PL|ránijai
raponc|N;PSS3P;SG|raponcauk
raponc|N;PSS3S;SG|raponcaa
reflex|N;INS;SG|reflexszel
reflex|N;TRANS;SG|reflexszé
reggeli|N;PSS1P;PL|reggelijeink
reggeli|N;PSS1S;PL|reggelijeim
reggeli|N;PSS2P;PL|reggelijeitek
reggeli|N;PSS2S;PL|reggelijeid
reggeli|N;PSS3P;PL|reggelijeik
reggeli|N;PSS3S;PL|reggelijei
remekmű|N;PSS2P;SG|remekművetek
rémtett|N;AT+ABL;SG|rémtettől
rendezői|N;ACC;PL|rendezőit
rendezői|N;AT+ABL;PL|rendezőitől
rendezői|N;AT+ALL;PL|rendezőihez
rendezői|N;AT+ESS;PL|rendezőinél
rendezői|N;DAT;PL|rendezőinek
rendezői|N;FRML;PL|rendezőiként
rendezői|N;IN+ABL;PL|rendezőiből
rendezői|N;IN+ALL;PL|rendezőibe
rendezői|N;IN+ESS;PL|rendezőiben
rendezői|N;INS;PL|rendezőivel
rendezői|N;NOM;PL|rendezői
rendezői|N;ON+ABL;PL|rendezőiről
rendezői|N;ON+ALL;PL|rendezőire
rendezői|N;ON+ESS;PL|rendezőin
rendezői|N;PRP;PL|rendezőiért
rendezői|N;TERM;PL|rendezőiig
rendezői|N;TRANS;PL|rendezőivé
rendőrkocsi|N;PSS1P;PL|rendőrkocsijaink
rendőrkocsi|N;PSS1S;PL|rendőrkocsijaim
rendőrkocsi|N;PSS2P;PL|rendőrkocsijaitok
rendőrkocsi|N;PSS2S;PL|rendőrkocsijaid
rendőrkocsi|N;PSS3P;PL|rendőrkocsijaik
rendőrkocsi|N;PSS3S;PL|rendőrkocsijai
rendőrőrs|N;ACC;SG|rendőrőrsöt
rezsi|N;PSS1P;PL|rezsijeink
rezsi|N;PSS1S;PL|rezsijeim
rezsi|N;PSS2P;PL|rezsijeitek
rezsi|N;PSS2S;PL|rezsijeid
rezsi|N;PSS3P;PL|rezsijeik
rezsi|N;PSS3S;PL|rezsijei
ribizli|N;PSS1P;PL|ribizlijeink
ribizli|N;PSS1S;PL|ribizlijeim
ribizli|N;PSS2P;PL|ribizlijeitek
ribizli|N;PSS2S;PL|ribizlijeid
ribizli|N;PSS3P;PL|ribizlijeik
ribizli|N;PSS3S;PL|ribizlijei
rigai|N;PSS1P;PL|rigaijaink
rigai|N;PSS1S;PL|rigaijaim
rigai|N;PSS2P;PL|rigaijaitok
rigai|N;PSS2S;PL|rigaijaid
rigai|N;PSS3P;PL|rigaijaik
rigai|N;PSS3S;PL|rigaijai
rigóféle|N;ACC;PL|rigóféléket
rigóféle|N;AT+ABL;PL|rigóféléktől
rigóféle|N;AT+ALL;PL|rigófélékhez
rigóféle|N;AT+ESS;PL|rigóféléknél
rigóféle|N;DAT;PL|rigóféléknek
rigóféle|N;IN+ABL;PL|rigófélékből
rigóféle|N;IN+ALL;PL|rigófélékbe
rigóféle|N;IN+ESS;PL|rigófélékben
rigóféle|N;INS;PL|rigófélékkel
rigóféle|N;ON+ABL;PL|rigófélékről
rigóféle|N;ON+ALL;PL|rigófélékre
rigóféle|N;ON+ESS;PL|rigóféléken
rigóféle|N;TRANS;PL|rigófélékké
riporterei|N;ACC;PL|riportereit
riporterei|N;AT+ABL;PL|riportereitől
riporterei|N;AT+ALL;PL|riportereihez
riporterei|N;AT+ESS;PL|riportereinél
riporterei|N;DAT;PL|riportereinek
riporterei|N;FRML;PL|riportereiként
riporterei|N;IN+ABL;PL|riportereiből
riporterei|N;IN+ALL;PL|riportereibe
riporterei|N;IN+ESS;PL|riportereiben
riporterei|N;INS;PL|riportereivel
riporterei|N;NOM;PL|riporterei
riporterei|N;ON+ABL;PL|riportereiről
riporterei|N;ON+ALL;PL|riportereire
riporterei|N;ON+ESS;PL|riporterein
riporterei|N;PRP;PL|riportereiért
riporterei|N;TERM;PL|riportereiig
riporterei|N;TRANS;PL|riportereivé
rizsföld|N;PSS2P;SG|rizsföldetek
ródli|N;PSS1P;PL|ródlijaink
ródli|N;PSS1S;PL|ródlijaim
ródli|N;PSS2P;PL|ródlijaitok
ródli|N;PSS2S;PL|ródlijaid
ródli|N;PSS3P;PL|ródlijaik
ródli|N;PSS3S;PL|ródlijai
róid|N;ACC;PL|róidat
róid|N;AT+ABL;PL|róidtól
róid|N;AT+ALL;PL|róidhoz
róid|N;AT+ESS;PL|róidnál
róid|N;DAT;PL|róidnak
róid|N;FRML;PL|róidként
róid|N;IN+ABL;PL|róidból
róid|N;IN+ALL;PL|róidba
róid|N;IN+ESS;PL|róidban
róid|N;INS;PL|róiddal
róid|N;NOM;PL|róid
róid|N;ON+ABL;PL|róidról
róid|N;ON+ALL;PL|róidra
róid|N;ON+ESS;PL|róidon
róid|N;PRP;PL|róidért
róid|N;TERM;PL|róidig
róid|N;TRANS;PL|róiddá
rovar|N;ACC;SG|rovarot
rúd|N;PSS1P;PL|rúdjaink
rúd|N;PSS1S;PL|rúdjaim
rúd|N;PSS2P;PL|rúdjaitok
rúd|N;PSS2S;PL|rúdjaid
rúd|N;PSS3P;PL|rúdjaik
rúd|N;PSS3P;SG|rúdjuk
rúd|N;PSS3S;PL|rúdjai
rúd|N;PSS3S;SG|rúdja
ruhaféle|N;ACC;PL|ruhaféléket
ruhaféle|N;AT+ABL;PL|ruhaféléktől
ruhaféle|N;AT+ALL;PL|ruhafélékhez
ruhaféle|N;AT+ESS;PL|ruhaféléknél
ruhaféle|N;DAT;PL|ruhaféléknek
ruhaféle|N;IN+ABL;PL|ruhafélékből
ruhaféle|N;IN+ALL;PL|ruhafélékbe
ruhaféle|N;IN+ESS;PL|ruhafélékben
ruhaféle|N;INS;PL|ruhafélékkel
ruhaféle|N;ON+ABL;PL|ruhafélékről
ruhaféle|N;ON+ALL;PL|ruhafélékre
ruhaféle|N;ON+ESS;PL|ruhaféléken
ruhaféle|N;TRANS;PL|ruhafélékké
rulett|N;AT+ABL;SG|rulettől
ruszki|N;PSS1P;PL|ruszkijaink
ruszki|N;PSS1S;PL|ruszkijaim
ruszki|N;PSS2P;PL|ruszkijaitok
ruszki|N;PSS2S;PL|ruszkijaid
ruszki|N;PSS3P;PL|ruszkijaik
ruszki|N;PSS3S;PL|ruszkijai
rügy|N;PSS2P;SG|rügyetek
sakk-matt|N;AT+ABL;SG|sakk-mattól
sakk|N;FRML;SG|sakként
salavári|N;PSS1P;PL|salavárijaink
salavári|N;PSS1S;PL|salavárijaim
salavári|N;PSS2P;PL|salavárijaitok
salavári|N;PSS2S;PL|salavárijaid
salavári|N;PSS3P;PL|salavárijaik
salavári|N;PSS3S;PL|salavárijai
sámli|N;PSS1P;PL|sámlijaink
sámli|N;PSS1S;PL|sámlijaim
sámli|N;PSS2P;PL|sámlijaitok
sámli|N;PSS2S;PL|sámlijaid
sámli|N;PSS3P;PL|sámlijaik
sámli|N;PSS3S;PL|sámlijai
sárgadinnye|N;ACC;PL|sárgadinnyéket
sárgadinnye|N;AT+ABL;PL|sárgadinnyéktől
sárgadinnye|N;AT+ALL;PL|sárgadinnyékhez
sárgadinnye|N;AT+ESS;PL|sárgadinnyéknél
sárgadinnye|N;DAT;PL|sárgadinnyéknek
sárgadinnye|N;IN+ABL;PL|sárgadinnyékből
sárgadinnye|N;IN+ALL;PL|sárgadinnyékbe
sárgadinnye|N;IN+ESS;PL|sárgadinnyékben
sárgadinnye|N;INS;PL|sárgadinnyékkel
sárgadinnye|N;ON+ABL;PL|sárgadinnyékről
sárgadinnye|N;ON+ALL;PL|sárgadinnyékre
sárgadinnye|N;ON+ESS;PL|sárgadinnyéken
sárgadinnye|N;TRANS;PL|sárgadinnyékké
sarzsi|N;PSS1P;PL|sarzsijaink
sarzsi|N;PSS1S;PL|sarzsijaim
sarzsi|N;PSS2P;PL|sarzsijaitok
sarzsi|N;PSS2S;PL|sarzsijaid
sarzsi|N;PSS3P;PL|sarzsijaik
sarzsi|N;PSS3S;PL|sarzsijai
savai|N;ACC;PL|savait
savai|N;AT+ABL;PL|savaitól
savai|N;AT+ALL;PL|savaihoz
savai|N;AT+ESS;PL|savainál
savai|N;DAT;PL|savainak
savai|N;FRML;PL|savaiként
savai|N;IN+ABL;PL|savaiból
savai|N;IN+ALL;PL|savaiba
savai|N;IN+ESS;PL|savaiban
savai|N;INS;PL|savaival
savai|N;NOM;PL|savai
savai|N;ON+ABL;PL|savairól
savai|N;ON+ALL;PL|savaira
savai|N;ON+ESS;PL|savain
savai|N;PRP;PL|savaiért
savai|N;TERM;PL|savaiig
savai|N;TRANS;PL|savaivá
sci-fi|N;PSS1P;PL|sci-fijeink
sci-fi|N;PSS1S;PL|sci-fijeim
sci-fi|N;PSS2P;PL|sci-fijeitek
sci-fi|N;PSS2S;PL|sci-fijeid
sci-fi|N;PSS3P;PL|sci-fijeik
sci-fi|N;PSS3S;PL|sci-fijei
scsí|N;PSS1P;PL|scsíjeink
scsí|N;PSS1S;PL|scsíjeim
scsí|N;PSS2P;PL|scsíjeitek
scsí|N;PSS2S;PL|scsíjeid
scsí|N;PSS3P;PL|scsíjeik
scsí|N;PSS3S;PL|scsíjei
serbli|N;PSS1P;PL|serblijeink
serbli|N;PSS1S;PL|serblijeim
serbli|N;PSS2P;PL|serblijeitek
serbli|N;PSS2S;PL|serblijeid
serbli|N;PSS3P;PL|serblijeik
serbli|N;PSS3S;PL|serblijei
sercli|N;PSS1P;PL|serclijeink
sercli|N;PSS1S;PL|serclijeim
sercli|N;PSS2P;PL|serclijeitek
sercli|N;PSS2S;PL|serclijeid
sercli|N;PSS3P;PL|serclijeik
sercli|N;PSS3S;PL|serclijei
sertészsír|N;ACC;SG|sertészsírt
sertészsír|N;PSS1S;SG|sertészsírom
sertészsír|N;PSS2P;SG|sertészsírotok
sertészsír|N;PSS2S;SG|sertészsírod
sértett|N;AT+ABL;SG|sértettől
sérült|N;PSS2P;SG|sérültetek
sí|N;PSS1P;PL|síjeink
sí|N;PSS1S;PL|síjeim
sí|N;PSS2P;PL|síjeitek
sí|N;PSS2S;PL|síjeid
sí|N;PSS3P;PL|síjeik
sí|N;PSS3S;PL|síjei
sík|N;ACC;SG|síkot
sík|N;PSS1S;SG|síkom
sík|N;PSS2P;SG|síkotok
sík|N;PSS2S;SG|síkod
sikk|N;FRML;SG|sikként
síp|N;ACC;SG|sípot
síp|N;PSS1S;SG|sípom
síp|N;PSS2P;SG|sípotok
síp|N;PSS2S;SG|sípod
sírkő|N;PSS2P;SG|sírkövetek
sitt|N;AT+ABL;SG|sittől
smokk|N;FRML;SG|smokként
snitt|N;AT+ABL;SG|snittől
sodor|N;ON+ESS;SG|sodron
sokk|N;FRML;SG|sokként
sokszög|N;PSS2P;SG|sokszögetek
sólyomféle|N;ACC;PL|sólyomféléket
sólyomféle|N;AT+ABL;PL|sólyomféléktől
sólyomféle|N;AT+ALL;PL|sólyomfélékhez
sólyomféle|N;AT+ESS;PL|sólyomféléknél
sólyomféle|N;DAT;PL|sólyomféléknek
sólyomféle|N;IN+ABL;PL|sólyomfélékből
sólyomféle|N;IN+ALL;PL|sólyomfélékbe
sólyomféle|N;IN+ESS;PL|sólyomfélékben
sólyomféle|N;INS;PL|sólyomfélékkel
sólyomféle|N;ON+ABL;PL|sólyomfélékről
sólyomféle|N;ON+ALL;PL|sólyomfélékre
sólyomféle|N;ON+ESS;PL|sólyomféléken
sólyomféle|N;TRANS;PL|sólyomfélékké
sombrero|N;ACC;PL|sombrerókat
sombrero|N;ACC;SG|sombrerót
sombrero|N;AT+ABL;PL|sombreróktól
sombrero|N;AT+ABL;SG|sombrerótól
sombrero|N;AT+ALL;PL|sombrerókhoz
sombrero|N;AT+ALL;SG|sombreróhoz
sombrero|N;AT+ESS;PL|sombreróknál
sombrero|N;AT+ESS;SG|sombrerónál
sombrero|N;DAT;PL|sombreróknak
sombrero|N;DAT;SG|sombrerónak
sombrero|N;IN+ABL;PL|sombrerókból
sombrero|N;IN+ABL;SG|sombreróból
sombrero|N;IN+ALL;PL|sombrerókba
sombrero|N;IN+ALL;SG|sombreróba
sombrero|N;IN+ESS;PL|sombrerókban
sombrero|N;IN+ESS;SG|sombreróban
sombrero|N;INS;PL|sombrerókkal
sombrero|N;INS;SG|sombreróval
sombrero|N;NOM;PL|sombrerók
sombrero|N;ON+ABL;PL|sombrerókról
sombrero|N;ON+ABL;SG|sombreróról
sombrero|N;ON+ALL;PL|sombrerókra
sombrero|N;ON+ALL;SG|sombreróra
sombrero|N;ON+ESS;PL|sombrerókon
sombrero|N;ON+ESS;SG|sombrerón
sombrero|N;PRP;PL|sombrerókért
sombrero|N;PRP;SG|sombreróért
sombrero|N;TERM;PL|sombrerókig
sombrero|N;TERM;SG|sombreróig
sombrero|N;TRANS;PL|sombrerókká
sombrero|N;TRANS;SG|sombreróvá
soproni|N;PSS1P;PL|sopronijaink
soproni|N;PSS1S;PL|sopronijaim
soproni|N;PSS2P;PL|sopronijaitok
soproni|N;PSS2S;PL|sopronijaid
soproni|N;PSS3P;PL|sopronijaik
soproni|N;PSS3S;PL|sopronijai
sors|N;ACC;SG|sorsot
spicli|N;PSS1P;PL|spiclijeink
spicli|N;PSS1S;PL|spiclijeim
spicli|N;PSS2P;PL|spiclijeitek
spicli|N;PSS2S;PL|spiclijeid
spicli|N;PSS3P;PL|spiclijeik
spicli|N;PSS3S;PL|spiclijei
stájsz|N;ACC;SG|stájszot
strici|N;PSS1P;PL|stricijeink
strici|N;PSS1S;PL|stricijeim
strici|N;PSS2P;PL|stricijeitek
strici|N;PSS2S;PL|stricijeid
strici|N;PSS3P;PL|stricijeik
strici|N;PSS3S;PL|stricijei
suli|N;PSS1P;PL|sulijaink
suli|N;PSS1S;PL|sulijaim
suli|N;PSS2P;PL|sulijaitok
suli|N;PSS2S;PL|sulijaid
suli|N;PSS3P;PL|sulijaik
suli|N;PSS3S;PL|sulijai
súrlódás|N;ACC;SG|súrlódásot
sült|N;PSS2P;SG|sültetek
süti|N;PSS1P;PL|sütijeink
süti|N;PSS1S;PL|sütijeim
süti|N;PSS2P;PL|sütijeitek
süti|N;PSS2S;PL|sütijeid
süti|N;PSS3P;PL|sütijeik
süti|N;PSS3S;PL|sütijei
svájci|N;PSS1P;PL|svájcijaink
svájci|N;PSS1S;PL|svájcijaim
svájci|N;PSS2P;PL|svájcijaitok
svájci|N;PSS2S;PL|svájcijaid
svájci|N;PSS3P;PL|svájcijaik
svájci|N;PSS3S;PL|svájcijai
svindli|N;PSS1P;PL|svindlijeink
svindli|N;PSS1S;PL|svindlijeim
svindli|N;PSS2P;PL|svindlijeitek
svindli|N;PSS2S;PL|svindlijeid
svindli|N;PSS3P;PL|svindlijeik
svindli|N;PSS3S;PL|svindlijei
szakácskönyv|N;PSS2P;SG|szakácskönyvetek
szakáll|N;ACC;SG|szakállt
szakértői|N;ACC;PL|szakértőit
szakértői|N;AT+ABL;PL|szakértőitől
szakértői|N;AT+ALL;PL|szakértőihez
szakértői|N;AT+ESS;PL|szakértőinél
szakértői|N;DAT;PL|szakértőinek
szakértői|N;FRML;PL|szakértőiként
szakértői|N;IN+ABL;PL|szakértőiből
szakértői|N;IN+ALL;PL|szakértőibe
szakértői|N;IN+ESS;PL|szakértőiben
szakértői|N;INS;PL|szakértőivel
szakértői|N;NOM;PL|szakértői
szakértői|N;ON+ABL;PL|szakértőiről
szakértői|N;ON+ALL;PL|szakértőire
szakértői|N;ON+ESS;PL|szakértőin
szakértői|N;PRP;PL|szakértőiért
szakértői|N;TERM;PL|szakértőiig
szakértői|N;TRANS;PL|szakértőivé
szakkönyv|N;PSS2P;SG|szakkönyvetek
szalámi|N;PSS1P;PL|szalámijaink
szalámi|N;PSS1S;PL|szalámijaim
szalámi|N;PSS2P;PL|szalámijaitok
szalámi|N;PSS2S;PL|szalámijaid
szalámi|N;PSS3P;PL|szalámijaik
szalámi|N;PSS3S;PL|szalámijai
szállóige|N;ACC;PL|szállóigéket
szállóige|N;AT+ABL;PL|szállóigéktől
szállóige|N;AT+ALL;PL|szállóigékhez
szállóige|N;AT+ESS;PL|szállóigéknél
szállóige|N;DAT;PL|szállóigéknek
szállóige|N;IN+ABL;PL|szállóigékből
szállóige|N;IN+ALL;PL|szállóigékbe
szállóige|N;IN+ESS;PL|szállóigékben
szállóige|N;INS;PL|szállóigékkel
szállóige|N;ON+ABL;PL|szállóigékről
szállóige|N;ON+ALL;PL|szállóigékre
szállóige|N;ON+ESS;PL|szállóigéken
szállóige|N;TRANS;PL|szállóigékké
szalonkocsi|N;PSS1P;PL|szalonkocsijaink
szalonkocsi|N;PSS1S;PL|szalonkocsijaim
szalonkocsi|N;PSS2P;PL|szalonkocsijaitok
szalonkocsi|N;PSS2S;PL|szalonkocsijaid
szalonkocsi|N;PSS3P;PL|szalonkocsijaik
szalonkocsi|N;PSS3S;PL|szalonkocsijai
száműzött|N;AT+ABL;SG|száműzöttől
száműzött|N;PSS2P;SG|száműzöttetek
szárazföld|N;PSS2P;SG|szárazföldetek
szári|N;PSS1P;PL|szárijaink
szári|N;PSS1S;PL|szárijaim
szári|N;PSS2P;PL|szárijaitok
szári|N;PSS2S;PL|szárijaid
szári|N;PSS3P;PL|szárijaik
szári|N;PSS3S;PL|szárijai
századik|N;ACC;SG|századikat
szeánsz|N;ACC;SG|szeánszot
szegedi|N;PSS1P;PL|szegedijeink
szegedi|N;PSS1S;PL|szegedijeim
szegedi|N;PSS2P;PL|szegedijeitek
szegedi|N;PSS2S;PL|szegedijeid
szegedi|N;PSS3P;PL|szegedijeik
szegedi|N;PSS3S;PL|szegedijei
székesfehérvári|N;PSS1P;PL|székesfehérvárijaink
székesfehérvári|N;PSS1S;PL|székesfehérvárijaim
székesfehérvári|N;PSS2P;PL|székesfehérvárijaitok
székesfehérvári|N;PSS2S;PL|székesfehérvárijaid
székesfehérvári|N;PSS3P;PL|székesfehérvárijaik
székesfehérvári|N;PSS3S;PL|székesfehérvárijai
szelfi|N;PSS1P;PL|szelfijeink
szelfi|N;PSS1S;PL|szelfijeim
szelfi|N;PSS2P;PL|szelfijeitek
szelfi|N;PSS2S;PL|szelfijeid
szelfi|N;PSS3P;PL|szelfijeik
szelfi|N;PSS3S;PL|szelfijei
személygépkocsi|N;PSS1P;PL|személygépkocsijaink
személygépkocsi|N;PSS1S;PL|személygépkocsijaim
személygépkocsi|N;PSS2P;PL|személygépkocsijaitok
személygépkocsi|N;PSS2S;PL|személygépkocsijaid
személygépkocsi|N;PSS3P;PL|személygépkocsijaik
személygépkocsi|N;PSS3S;PL|személygépkocsijai
személyi|N;PSS1P;PL|személyijeink
személyi|N;PSS1S;PL|személyijeim
személyi|N;PSS2P;PL|személyijeitek
személyi|N;PSS2S;PL|személyijeid
személyi|N;PSS3P;PL|személyijeik
személyi|N;PSS3S;PL|személyijei
szemszög|N;PSS2P;SG|szemszögetek
szemügy|N;PSS2P;SG|szemügyetek
szenegáli|N;PSS1P;PL|szenegálijaink
szenegáli|N;PSS1S;PL|szenegálijaim
szenegáli|N;PSS2P;PL|szenegálijaitok
szenegáli|N;PSS2S;PL|szenegálijaid
szenegáli|N;PSS3P;PL|szenegálijaik
szenegáli|N;PSS3S;PL|szenegálijai
szerencsesüti|N;PSS1P;PL|szerencsesütijeink
szerencsesüti|N;PSS1S;PL|szerencsesütijeim
szerencsesüti|N;PSS2P;PL|szerencsesütijeitek
szerencsesüti|N;PSS2S;PL|szerencsesütijeid
szerencsesüti|N;PSS3P;PL|szerencsesütijeik
szerencsesüti|N;PSS3S;PL|szerencsesütijei
szerette|N;PSS1P;PL|szeretteink
szerette|N;PSS1P;SG|szerettünk
szerette|N;PSS1S;PL|szeretteim
szerette|N;PSS1S;SG|szerettem
szerette|N;PSS2P;PL|szeretteitek
szerette|N;PSS2P;SG|szerettetek
szerette|N;PSS2S;PL|szeretteid
szerette|N;PSS2S;SG|szeretted
szerette|N;PSS3P;PL|szeretteik
szerette|N;PSS3P;SG|szerettük
szerette|N;PSS3S;PL|szerettei
szerette|N;PSS3S;SG|szerette
szerzői|N;ACC;PL|szerzőit
szerzői|N;AT+ABL;PL|szerzőitől
szerzői|N;AT+ALL;PL|szerzőihez
szerzői|N;AT+ESS;PL|szerzőinél
szerzői|N;DAT;PL|szerzőinek
szerzői|N;FRML;PL|szerzőiként
szerzői|N;IN+ABL;PL|szerzőiből
szerzői|N;IN+ALL;PL|szerzőibe
szerzői|N;IN+ESS;PL|szerzőiben
szerzői|N;INS;PL|szerzőivel
szerzői|N;NOM;PL|szerzői
szerzői|N;ON+ABL;PL|szerzőiről
szerzői|N;ON+ALL;PL|szerzőire
szerzői|N;ON+ESS;PL|szerzőin
szerzői|N;PRP;PL|szerzőiért
szerzői|N;TERM;PL|szerzőiig
szerzői|N;TRANS;PL|szerzőivé
szett|N;AT+ABL;SG|szettől
szex|N;INS;SG|szexszel
szex|N;TRANS;SG|szexszé
szfinx|N;INS;SG|szfinxszel
szfinx|N;TRANS;SG|szfinxszé
sziámi|N;PSS1P;PL|sziámijaink
sziámi|N;PSS1S;PL|sziámijaim
sziámi|N;PSS2P;PL|sziámijaitok
sziámi|N;PSS2S;PL|sziámijaid
sziámi|N;PSS3P;PL|sziámijaik
sziámi|N;PSS3S;PL|sziámijai
szibériai|N;PSS1P;PL|szibériaijaink
szibériai|N;PSS1S;PL|szibériaijaim
szibériai|N;PSS2P;PL|szibériaijaitok
szibériai|N;PSS2S;PL|szibériaijaid
szibériai|N;PSS3P;PL|szibériaijaik
szibériai|N;PSS3S;PL|szibériaijai
szicíliai|N;PSS1P;PL|szicíliaijaink
szicíliai|N;PSS1S;PL|szicíliaijaim
szicíliai|N;PSS2P;PL|szicíliaijaitok
szicíliai|N;PSS2S;PL|szicíliaijaid
szicíliai|N;PSS3P;PL|szicíliaijaik
szicíliai|N;PSS3S;PL|szicíliaijai
szigeti|N;PSS1P;PL|szigetijeink
szigeti|N;PSS1S;PL|szigetijeim
szigeti|N;PSS2P;PL|szigetijeitek
szigeti|N;PSS2S;PL|szigetijeid
szigeti|N;PSS3P;PL|szigetijeik
szigeti|N;PSS3S;PL|szigetijei
szikh|N;INS;SG|szikhkel
szikh|N;TRANS;SG|szikhké
szingapúri|N;PSS1P;PL|szingapúrijaink
szingapúri|N;PSS1S;PL|szingapúrijaim
szingapúri|N;PSS2P;PL|szingapúrijaitok
szingapúri|N;PSS2S;PL|szingapúrijaid
szingapúri|N;PSS3P;PL|szingapúrijaik
szingapúri|N;PSS3S;PL|szingapúrijai
szinti|N;PSS1P;PL|szintijeink
szinti|N;PSS1S;PL|szintijeim
szinti|N;PSS2P;PL|szintijeitek
szinti|N;PSS2S;PL|szintijeid
szinti|N;PSS3P;PL|szintijeik
szinti|N;PSS3S;PL|szintijei
szláv|N;PSS3P;SG|szlávjuk
szláv|N;PSS3S;SG|szlávja
szó|N;ACC;PL|szavakat
szó|N;DAT;PL|szavaknak
szó|N;IN+ESS;PL|szavakban
szó|N;INS;PL|szavakkal
szó|N;NOM;PL|szavak
szóbeli|N;PSS1P;PL|szóbelijeink
szóbeli|N;PSS1S;PL|szóbelijeim
szóbeli|N;PSS2P;PL|szóbelijeitek
szóbeli|N;PSS2S;PL|szóbelijeid
szóbeli|N;PSS3P;PL|szóbelijeik
szóbeli|N;PSS3S;PL|szóbelijei
szócikk|N;FRML;SG|szócikként
szomszéd|N;PSS3P;SG|szomszédjuk
szomszéd|N;PSS3S;SG|szomszédja
szonett|N;AT+ABL;SG|szonettől
szótő|N;PSS2P;SG|szótövetek
szög|N;PSS2P;SG|szögetek
szökőkút|N;PSS1P;PL|szökőkútjaink
szökőkút|N;PSS1S;PL|szökőkútjaim
szökőkút|N;PSS2P;PL|szökőkútjaitok
szökőkút|N;PSS2S;PL|szökőkútjaid
szökőkút|N;PSS3P;PL|szökőkútjaik
szökőkút|N;PSS3P;SG|szökőkútjuk
szökőkút|N;PSS3S;PL|szökőkútjai
szökőkút|N;PSS3S;SG|szökőkútja
szökött|N;AT+ABL;SG|szököttől
szökött|N;PSS2P;SG|szököttetek
szőlőzsír|N;ACC;SG|szőlőzsírt
szőlőzsír|N;PSS1S;SG|szőlőzsírom
szőlőzsír|N;PSS2P;SG|szőlőzsírotok
szőlőzsír|N;PSS2S;SG|szőlőzsírod
szőrme|N;PSS2P;PL|szőrméitok
szőrme|N;PSS2P;SG|szőrmétok
szőrme|N;PSS3P;SG|szőrméjuk
szőrme|N;PSS3S;SG|szőrméja
szörny|N;PSS2P;SG|szörnyetek
sztori|N;PSS1P;PL|sztorijaink
sztori|N;PSS1S;PL|sztorijaim
sztori|N;PSS2P;PL|sztorijaitok
sztori|N;PSS2S;PL|sztorijaid
sztori|N;PSS3P;PL|sztorijaik
sztori|N;PSS3S;PL|sztorijai
szüfrazsett|N;AT+ABL;SG|szüfrazsettől
szügy|N;PSS2P;SG|szügyetek
szülő|N;PSS1P;PL|szüleink
szülő|N;PSS1S;PL|szüleim
szülő|N;PSS2P;PL|szüleitek
szülő|N;PSS2S;PL|szüleid
szülő|N;PSS3P;PL|szüleik
szülő|N;PSS3S;PL|szülei
szülőföld|N;PSS2P;SG|szülőföldetek
szülött|N;AT+ABL;SG|szülöttől
szűz|N;PSS2P;SG|szüzetek
tábortűz|N;PSS2P;SG|tábortüzetek
tabui|N;ACC;PL|tabuit
tabui|N;AT+ABL;PL|tabuitól
tabui|N;AT+ALL;PL|tabuihoz
tabui|N;AT+ESS;PL|tabuinál
tabui|N;DAT;PL|tabuinak
tabui|N;FRML;PL|tabuiként
tabui|N;IN+ABL;PL|tabuiból
tabui|N;IN+ALL;PL|tabuiba
tabui|N;IN+ESS;PL|tabuiban
tabui|N;INS;PL|tabuival
tabui|N;NOM;PL|tabui
tabui|N;ON+ABL;PL|tabuiról
tabui|N;ON+ALL;PL|tabuira
tabui|N;ON+ESS;PL|tabuin
tabui|N;PRP;PL|tabuiért
tabui|N;TERM;PL|tabuiig
tabui|N;TRANS;PL|tabuivá
tacepao|N;ACC;PL|tacepaókat
tacepao|N;ACC;SG|tacepaót
tacepao|N;AT+ABL;PL|tacepaóktól
tacepao|N;AT+ABL;SG|tacepaótól
tacepao|N;AT+ALL;PL|tacepaókhoz
tacepao|N;AT+ALL;SG|tacepaóhoz
tacepao|N;AT+ESS;PL|tacepaóknál
tacepao|N;AT+ESS;SG|tacepaónál
tacepao|N;DAT;PL|tacepaóknak
tacepao|N;DAT;SG|tacepaónak
tacepao|N;IN+ABL;PL|tacepaókból
tacepao|N;IN+ABL;SG|tacepaóból
tacepao|N;IN+ALL;PL|tacepaókba
tacepao|N;IN+ALL;SG|tacepaóba
tacepao|N;IN+ESS;PL|tacepaókban
tacepao|N;IN+ESS;SG|tacepaóban
tacepao|N;INS;PL|tacepaókkal
tacepao|N;INS;SG|tacepaóval
tacepao|N;NOM;PL|tacepaók
tacepao|N;ON+ABL;PL|tacepaókról
tacepao|N;ON+ABL;SG|tacepaóról
tacepao|N;ON+ALL;PL|tacepaókra
tacepao|N;ON+ALL;SG|tacepaóra
tacepao|N;ON+ESS;PL|tacepaókon
tacepao|N;ON+ESS;SG|tacepaón
tacepao|N;PRP;PL|tacepaókért
tacepao|N;PRP;SG|tacepaóért
tacepao|N;TERM;PL|tacepaókig
tacepao|N;TERM;SG|tacepaóig
tacepao|N;TRANS;PL|tacepaókká
tacepao|N;TRANS;SG|tacepaóvá
taekwondo|N;ACC;PL|taekwondókat
taekwondo|N;ACC;SG|taekwondót
taekwondo|N;AT+ABL;PL|taekwondóktól
taekwondo|N;AT+ABL;SG|taekwondótól
taekwondo|N;AT+ALL;PL|taekwondókhoz
taekwondo|N;AT+ALL;SG|taekwondóhoz
taekwondo|N;AT+ESS;PL|taekwondóknál
taekwondo|N;AT+ESS;SG|taekwondónál
taekwondo|N;DAT;PL|taekwondóknak
taekwondo|N;DAT;SG|taekwondónak
taekwondo|N;IN+ABL;PL|taekwondókból
taekwondo|N;IN+ABL;SG|taekwondóból
taekwondo|N;IN+ALL;PL|taekwondókba
taekwondo|N;IN+ALL;SG|taekwondóba
taekwondo|N;IN+ESS;PL|taekwondókban
taekwondo|N;IN+ESS;SG|taekwondóban
taekwondo|N;INS;PL|taekwondókkal
taekwondo|N;INS;SG|taekwondóval
taekwondo|N;NOM;PL|taekwondók
taekwondo|N;ON+ABL;PL|taekwondókról
taekwondo|N;ON+ABL;SG|taekwondóról
taekwondo|N;ON+ALL;PL|taekwondókra
taekwondo|N;ON+ALL;SG|taekwondóra
taekwondo|N;ON+ESS;PL|taekwondókon
taekwondo|N;ON+ESS;SG|taekwondón
taekwondo|N;PRP;PL|taekwondókért
taekwondo|N;PRP;SG|taekwondóért
taekwondo|N;TERM;PL|taekwondókig
taekwondo|N;TERM;SG|taekwondóig
taekwondo|N;TRANS;PL|taekwondókká
taekwondo|N;TRANS;SG|taekwondóvá
tagjelölt|N;AT+ALL;SG|tagjelölthez
tagjelölt|N;ON+ESS;SG|tagjelölten
tagjelölt|N;PSS2P;SG|tagjelöltetek
tajvani|N;PSS1P;PL|tajvanijaink
tajvani|N;PSS1S;PL|tajvanijaim
tajvani|N;PSS2P;PL|tajvanijaitok
tajvani|N;PSS2S;PL|tajvanijaid
tajvani|N;PSS3P;PL|tajvanijaik
tajvani|N;PSS3S;PL|tajvanijai
tali|N;PSS1P;PL|talijaink
tali|N;PSS1S;PL|talijaim
tali|N;PSS2P;PL|talijaitok
tali|N;PSS2S;PL|talijaid
tali|N;PSS3P;PL|talijaik
tali|N;PSS3S;PL|talijai
támogatói|N;ACC;PL|támogatóit
támogatói|N;AT+ABL;PL|támogatóitól
támogatói|N;AT+ALL;PL|támogatóihoz
támogatói|N;AT+ESS;PL|támogatóinál
támogatói|N;DAT;PL|támogatóinak
támogatói|N;FRML;PL|támogatóiként
támogatói|N;IN+ABL;PL|támogatóiból
támogatói|N;IN+ALL;PL|támogatóiba
támogatói|N;IN+ESS;PL|támogatóiban
támogatói|N;INS;PL|támogatóival
támogatói|N;NOM;PL|támogatói
támogatói|N;ON+ABL;PL|támogatóiról
támogatói|N;ON+ALL;PL|támogatóira
támogatói|N;ON+ESS;PL|támogatóin
támogatói|N;PRP;PL|támogatóiért
támogatói|N;TERM;PL|támogatóiig
támogatói|N;TRANS;PL|támogatóivá
tanári|N;PSS1P;PL|tanárijaink
tanári|N;PSS1S;PL|tanárijaim
tanári|N;PSS2P;PL|tanárijaitok
tanári|N;PSS2S;PL|tanárijaid
tanári|N;PSS3P;PL|tanárijaik
tanári|N;PSS3S;PL|tanárijai
táncparkett|N;AT+ABL;SG|táncparkettől
tangó|N;PSS1P;SG|tangnk
tangó|N;PSS1S;SG|tangm
tangó|N;PSS2P;SG|tangtok
tangó|N;PSS2S;SG|tangd
tangó|N;PSS3P;SG|tangjuk
tangó|N;PSS3S;SG|tangja
tankönyv|N;PSS2P;SG|tankönyvetek
tanti|N;PSS1P;PL|tantijaink
tanti|N;PSS1S;PL|tantijaim
tanti|N;PSS2P;PL|tantijaitok
tanti|N;PSS2S;PL|tantijaid
tanti|N;PSS3P;PL|tantijaik
tanti|N;PSS3S;PL|tantijai
tanúi|N;ACC;PL|tanúit
tanúi|N;AT+ABL;PL|tanúitól
tanúi|N;AT+ALL;PL|tanúihoz
tanúi|N;AT+ESS;PL|tanúinál
tanúi|N;DAT;PL|tanúinak
tanúi|N;FRML;PL|tanúiként
tanúi|N;IN+ABL;PL|tanúiból
tanúi|N;IN+ALL;PL|tanúiba
tanúi|N;IN+ESS;PL|tanúiban
tanúi|N;INS;PL|tanúival
tanúi|N;NOM;PL|tanúi
tanúi|N;ON+ABL;PL|tanúiról
tanúi|N;ON+ALL;PL|tanúira
tanúi|N;ON+ESS;PL|tanúin
tanúi|N;PRP;PL|tanúiért
tanúi|N;TERM;PL|tanúiig
tanúi|N;TRANS;PL|tanúivá
tanulói|N;ACC;PL|tanulóit
tanulói|N;AT+ABL;PL|tanulóitól
tanulói|N;AT+ALL;PL|tanulóihoz
tanulói|N;AT+ESS;PL|tanulóinál
tanulói|N;DAT;PL|tanulóinak
tanulói|N;FRML;PL|tanulóiként
tanulói|N;IN+ABL;PL|tanulóiból
tanulói|N;IN+ALL;PL|tanulóiba
tanulói|N;IN+ESS;PL|tanulóiban
tanulói|N;INS;PL|tanulóival
tanulói|N;NOM;PL|tanulói
tanulói|N;ON+ABL;PL|tanulóiról
tanulói|N;ON+ALL;PL|tanulóira
tanulói|N;ON+ESS;PL|tanulóin
tanulói|N;PRP;PL|tanulóiért
tanulói|N;TERM;PL|tanulóiig
tanulói|N;TRANS;PL|tanulóivá
tanzániai|N;PSS1P;PL|tanzániaijaink
tanzániai|N;PSS1S;PL|tanzániaijaim
tanzániai|N;PSS2P;PL|tanzániaijaitok
tanzániai|N;PSS2S;PL|tanzániaijaid
tanzániai|N;PSS3P;PL|tanzániaijaik
tanzániai|N;PSS3S;PL|tanzániaijai
tao|N;ACC;PL|taókat
tao|N;ACC;SG|taót
tao|N;AT+ABL;PL|taóktól
tao|N;AT+ABL;SG|taótól
tao|N;AT+ALL;PL|taókhoz
tao|N;AT+ALL;SG|taóhoz
tao|N;AT+ESS;PL|taóknál
tao|N;AT+ESS;SG|taónál
tao|N;DAT;PL|taóknak
tao|N;DAT;SG|taónak
tao|N;IN+ABL;PL|taókból
tao|N;IN+ABL;SG|taóból
tao|N;IN+ALL;PL|taókba
tao|N;IN+ALL;SG|taóba
tao|N;IN+ESS;PL|taókban
tao|N;IN+ESS;SG|taóban
tao|N;INS;PL|taókkal
tao|N;INS;SG|taóval
tao|N;NOM;PL|taók
tao|N;ON+ABL;PL|taókról
tao|N;ON+ABL;SG|taóról
tao|N;ON+ALL;PL|taókra
tao|N;ON+ALL;SG|taóra
tao|N;ON+ESS;PL|taókon
tao|N;ON+ESS;SG|taón
tao|N;PRP;PL|taókért
tao|N;PRP;SG|taóért
tao|N;TERM;PL|taókig
tao|N;TERM;SG|taóig
tao|N;TRANS;PL|taókká
tao|N;TRANS;SG|taóvá
taps|N;ACC;SG|tapsot
társai|N;ACC;PL|társait
társai|N;AT+ABL;PL|társaitól
társai|N;AT+ALL;PL|társaihoz
társai|N;AT+ESS;PL|társainál
társai|N;DAT;PL|társainak
társai|N;FRML;PL|társaiként
társai|N;IN+ABL;PL|társaiból
társai|N;IN+ALL;PL|társaiba
társai|N;IN+ESS;PL|társaiban
társai|N;INS;PL|társaival
társai|N;NOM;PL|társai
társai|N;ON+ABL;PL|társairól
társai|N;ON+ALL;PL|társaira
társai|N;ON+ESS;PL|társain
társai|N;PRP;PL|társaiért
társai|N;TERM;PL|társaiig
társai|N;TRANS;PL|társaivá
távcső|N;PSS2P;SG|távcsövetek
taxi|N;PSS1P;PL|taxijaink
taxi|N;PSS1S;PL|taxijaim
taxi|N;PSS2P;PL|taxijaitok
taxi|N;PSS2S;PL|taxijaid
taxi|N;PSS3P;PL|taxijaik
taxi|N;PSS3S;PL|taxijai
tegnapelőtt|N;AT+ABL;SG|tegnapelőttől
telefonérme|N;ACC;PL|telefonérméket
telefonérme|N;AT+ABL;PL|telefonérméktől
telefonérme|N;AT+ALL;PL|telefonérmékhez
telefonérme|N;AT+ESS;PL|telefonérméknél
telefonérme|N;DAT;PL|telefonérméknek
telefonérme|N;IN+ABL;PL|telefonérmékből
telefonérme|N;IN+ALL;PL|telefonérmékbe
telefonérme|N;IN+ESS;PL|telefonérmékben
telefonérme|N;INS;PL|telefonérmékkel
telefonérme|N;ON+ABL;PL|telefonérmékről
telefonérme|N;ON+ALL;PL|telefonérmékre
telefonérme|N;ON+ESS;PL|telefonérméken
telefonérme|N;TRANS;PL|telefonérmékké
telei|N;ACC;PL|teleit
telei|N;AT+ABL;PL|teleitől
telei|N;AT+ALL;PL|teleihez
telei|N;AT+ESS;PL|teleinél
telei|N;DAT;PL|teleinek
telei|N;FRML;PL|teleiként
telei|N;IN+ABL;PL|teleiből
telei|N;IN+ALL;PL|teleibe
telei|N;IN+ESS;PL|teleiben
telei|N;INS;PL|teleivel
telei|N;NOM;PL|telei
telei|N;ON+ABL;PL|teleiről
telei|N;ON+ALL;PL|teleire
telei|N;ON+ESS;PL|telein
telei|N;PRP;PL|teleiért
telei|N;TERM;PL|teleiig
telei|N;TRANS;PL|teleivé
tepsi|N;PSS1P;PL|tepsijeink
tepsi|N;PSS1S;PL|tepsijeim
tepsi|N;PSS2P;PL|tepsijeitek
tepsi|N;PSS2S;PL|tepsijeid
tepsi|N;PSS3P;PL|tepsijeik
tepsi|N;PSS3S;PL|tepsijei
térdreflex|N;INS;SG|térdreflexszel
térdreflex|N;TRANS;SG|térdreflexszé
térdzokni|N;PSS1P;PL|térdzoknijaink
térdzokni|N;PSS1S;PL|térdzoknijaim
térdzokni|N;PSS2P;PL|térdzoknijaitok
térdzokni|N;PSS2S;PL|térdzoknijaid
térdzokni|N;PSS3P;PL|térdzoknijaik
térdzokni|N;PSS3S;PL|térdzoknijai
terei|N;ACC;PL|tereit
terei|N;AT+ABL;PL|tereitől
terei|N;AT+ALL;PL|tereihez
terei|N;AT+ESS;PL|tereinél
terei|N;DAT;PL|tereinek
terei|N;FRML;PL|tereiként
terei|N;IN+ABL;PL|tereiből
terei|N;IN+ALL;PL|tereibe
terei|N;IN+ESS;PL|tereiben
terei|N;INS;PL|tereivel
terei|N;NOM;PL|terei
terei|N;ON+ABL;PL|tereiről
terei|N;ON+ALL;PL|tereire
terei|N;ON+ESS;PL|terein
terei|N;PRP;PL|tereiért
terei|N;TERM;PL|tereiig
terei|N;TRANS;PL|tereivé
természetföldrajz|N;ACC;SG|természetföldrajzot
térszög|N;AT+ALL;SG|térszöghez
térszög|N;ON+ESS;SG|térszögen
tervrajz|N;ACC;SG|tervrajzot
testei|N;ACC;PL|testeit
testei|N;AT+ABL;PL|testeitől
testei|N;AT+ALL;PL|testeihez
testei|N;AT+ESS;PL|testeinél
testei|N;DAT;PL|testeinek
testei|N;FRML;PL|testeiként
testei|N;IN+ABL;PL|testeiből
testei|N;IN+ALL;PL|testeibe
testei|N;IN+ESS;PL|testeiben
testei|N;INS;PL|testeivel
testei|N;NOM;PL|testei
testei|N;ON+ABL;PL|testeiről
testei|N;ON+ALL;PL|testeire
testei|N;ON+ESS;PL|testein
testei|N;PRP;PL|testeiért
testei|N;TERM;PL|testeiig
testei|N;TRANS;PL|testeivé
testtömegindex|N;INS;SG|testtömegindexszel
testtömegindex|N;TRANS;SG|testtömegindexszé
tett|N;AT+ABL;SG|tettől
tévút|N;PSS1P;PL|tévútjaink
tévút|N;PSS1S;PL|tévútjaim
tévút|N;PSS2P;PL|tévútjaitok
tévút|N;PSS2S;PL|tévútjaid
tévút|N;PSS3P;PL|tévútjaik
tévút|N;PSS3P;SG|tévútjuk
tévút|N;PSS3S;PL|tévútjai
tévút|N;PSS3S;SG|tévútja
thai|N;INS;SG|thaijal
thai|N;ON+ESS;SG|thaion
thai|N;PSS1P;PL|thaiaink
thai|N;PSS1P;SG|thaiunk
thai|N;PSS1S;PL|thaiaim
thai|N;PSS1S;SG|thaiom
thai|N;PSS2P;PL|thaiaitok
thai|N;PSS2P;SG|thaiotok
thai|N;PSS2S;PL|thaiaid
thai|N;PSS2S;SG|thaiod
thai|N;PSS3P;PL|thaiaik
thai|N;PSS3P;SG|thaiuk
thai|N;PSS3S;PL|thaiai
thai|N;PSS3S;SG|thaia
thai|N;TRANS;SG|thaijá
ti|N;PSS1P;PL|tijeink
ti|N;PSS1S;PL|tijeim
ti|N;PSS2P;PL|tijeitek
ti|N;PSS2S;PL|tijeid
ti|N;PSS3P;PL|tijeik
ti|N;PSS3S;PL|tijei
tini|N;PSS1P;PL|tinijeink
tini|N;PSS1S;PL|tinijeim
tini|N;PSS2P;PL|tinijeitek
tini|N;PSS2S;PL|tinijeid
tini|N;PSS3P;PL|tinijeik
tini|N;PSS3S;PL|tinijei
titokzokni|N;PSS1P;PL|titokzoknijaink
titokzokni|N;PSS1S;PL|titokzoknijaim
titokzokni|N;PSS2P;PL|titokzoknijaitok
titokzokni|N;PSS2S;PL|titokzoknijaid
titokzokni|N;PSS3P;PL|titokzoknijaik
titokzokni|N;PSS3S;PL|titokzoknijai
tizenháromszög|N;PSS2P;SG|tizenháromszögetek
tízórai|N;PSS1P;PL|tízóraijaink
tízórai|N;PSS1S;PL|tízóraijaim
tízórai|N;PSS2P;PL|tízóraijaitok
tízórai|N;PSS2S;PL|tízóraijaid
tízórai|N;PSS3P;PL|tízóraijaik
tízórai|N;PSS3S;PL|tízóraijai
toalett|N;AT+ABL;SG|toalettől
tokaji|N;PSS1P;PL|tokajijaink
tokaji|N;PSS1S;PL|tokajijaim
tokaji|N;PSS2P;PL|tokajijaitok
tokaji|N;PSS2S;PL|tokajijaid
tokaji|N;PSS3P;PL|tokajijaik
tokaji|N;PSS3S;PL|tokajijai
tompaszög|N;PSS2P;SG|tompaszögetek
tory|N;ACC;PL|torykat
tory|N;ACC;SG|toryt
tory|N;AT+ABL;PL|toryktól
tory|N;AT+ALL;PL|torykhoz
tory|N;AT+ESS;PL|toryknál
tory|N;DAT;PL|toryknak
tory|N;FRML;PL|torykként
tory|N;IN+ABL;PL|torykból
tory|N;IN+ALL;PL|torykba
tory|N;IN+ESS;PL|torykban
tory|N;INS;PL|torykkal
tory|N;INS;SG|toryval
tory|N;NOM;PL|toryk
tory|N;ON+ABL;PL|torykról
tory|N;ON+ALL;PL|torykra
tory|N;ON+ESS;PL|torykon
tory|N;ON+ESS;SG|toryn
tory|N;PRP;PL|torykért
tory|N;PSS1P;SG|torynk
tory|N;PSS1S;SG|torym
tory|N;PSS2P;SG|torytok
tory|N;PSS2S;SG|toryd
tory|N;TERM;PL|torykig
tory|N;TRANS;PL|torykká
tory|N;TRANS;SG|toryvá
tő|N;PSS2P;SG|tövetek
több|N;IN+ABL;SG|többől
több|N;IN+ALL;SG|többe
több|N;IN+ESS;SG|többen
több|N;PSS2P;SG|többetek
többi|N;PSS1P;PL|többijeink
többi|N;PSS1S;PL|többijeim
többi|N;PSS2P;PL|többijeitek
többi|N;PSS2S;PL|többijeid
többi|N;PSS3P;PL|többijeik
többi|N;PSS3S;PL|többijei
tőgy|N;PSS2P;SG|tőgyetek
tölgy|N;PSS2P;SG|tölgyetek
tömegsír|N;ACC;SG|tömegsírt
tömegsír|N;PSS1S;SG|tömegsírom
tömegsír|N;PSS2P;SG|tömegsírotok
tömegsír|N;PSS2S;SG|tömegsírod
tömzs|N;ACC;SG|tömzsöt
töri|N;PSS1P;PL|törijeink
töri|N;PSS1S;PL|törijeim
töri|N;PSS2P;PL|törijeitek
töri|N;PSS2S;PL|törijeid
töri|N;PSS3P;PL|törijeik
töri|N;PSS3S;PL|törijei
tört|N;PSS2P;SG|törtetek
törvénykönyv|N;PSS2P;SG|törvénykönyvetek
törzs|N;PSS2P;SG|törzsetek
trampli|N;PSS1P;PL|tramplijaink
trampli|N;PSS1S;PL|tramplijaim
trampli|N;PSS2P;PL|tramplijaitok
trampli|N;PSS2S;PL|tramplijaid
trampli|N;PSS3P;PL|tramplijaik
trampli|N;PSS3S;PL|tramplijai
tréfli|N;PSS1P;PL|tréflijeink
tréfli|N;PSS1S;PL|tréflijeim
tréfli|N;PSS2P;PL|tréflijeitek
tréfli|N;PSS2S;PL|tréflijeid
tréfli|N;PSS3P;PL|tréflijeik
tréfli|N;PSS3S;PL|tréflijei
triolett|N;AT+ABL;SG|triolettől
trójai|N;PSS1P;PL|trójaijaink
trójai|N;PSS1S;PL|trójaijaim
trójai|N;PSS2P;PL|trójaijaitok
trójai|N;PSS2S;PL|trójaijaid
trójai|N;PSS3P;PL|trójaijaik
trójai|N;PSS3S;PL|trójaijai
trükk|N;FRML;SG|trükként
tuti|N;PSS1P;PL|tutijaink
tuti|N;PSS1S;PL|tutijaim
tuti|N;PSS2P;PL|tutijaitok
tuti|N;PSS2S;PL|tutijaid
tuti|N;PSS3P;PL|tutijaik
tuti|N;PSS3S;PL|tutijai
türbe|N;PSS1P;PL|tübéink
türbe|N;PSS1P;SG|tübénk
türbe|N;PSS1S;PL|tübéim
türbe|N;PSS1S;SG|tübém
türbe|N;PSS2P;PL|tübéitek
türbe|N;PSS2P;SG|tübétek
türbe|N;PSS2S;PL|tübéid
türbe|N;PSS2S;SG|tübéd
türbe|N;PSS3P;PL|tübéik
türbe|N;PSS3P;SG|tübéjük
türbe|N;PSS3S;PL|tübéi
türbe|N;PSS3S;SG|tübéje
tűz|N;PSS2P;SG|tüzetek
udvarhölgy|N;PSS2P;SG|udvarhölgyetek
újságcikk|N;FRML;SG|újságcikként
újszülött|N;AT+ABL;SG|újszülöttől
újszülött|N;PSS2P;SG|újszülöttetek
ulti|N;PSS1P;PL|ultijaink
ulti|N;PSS1S;PL|ultijaim
ulti|N;PSS2P;PL|ultijaitok
ulti|N;PSS2S;PL|ultijaid
ulti|N;PSS3P;PL|ultijaik
ulti|N;PSS3S;PL|ultijai
unokaöcs|N;PSS1P;PL|unokaöcséink
unokaöcs|N;PSS1P;SG|unokaöcsénk
unokaöcs|N;PSS1S;PL|unokaöcséim
unokaöcs|N;PSS1S;SG|unokaöcsém
unokaöcs|N;PSS2P;PL|unokaöcséitek
unokaöcs|N;PSS2P;SG|unokaöcsétek
unokaöcs|N;PSS2S;PL|unokaöcséid
unokaöcs|N;PSS2S;SG|unokaöcséd
unokaöcs|N;PSS3P;PL|unokaöccseik
unokaöcs|N;PSS3P;SG|unokaöccsük
unokaöcs|N;PSS3S;PL|unokaöccsei
unokaöcs|N;PSS3S;SG|unokaöccse
uradalom|N;AT+ABL;SG|urodalomtól
uradalom|N;AT+ALL;SG|urodalomhoz
uradalom|N;AT+ESS;SG|urodalomnál
uradalom|N;DAT;SG|urodalomnak
uradalom|N;IN+ABL;SG|urodalomból
uradalom|N;IN+ALL;SG|urodalomba
uradalom|N;IN+ESS;SG|urodalomban
uradalom|N;INS;SG|urodalommal
uradalom|N;ON+ABL;SG|urodalomról
uradalom|N;ON+ALL;SG|urodalomra
uradalom|N;PRP;SG|urodalomért
uradalom|N;TERM;SG|urodalomig
uradalom|N;TRANS;SG|urodalommá
uraim|N;ACC;PL|uraimat
uraim|N;AT+ABL;PL|uraimtól
uraim|N;AT+ALL;PL|uraimhoz
uraim|N;AT+ESS;PL|uraimnál
uraim|N;DAT;PL|uraimnak
uraim|N;FRML;PL|uraimként
uraim|N;IN+ABL;PL|uraimból
uraim|N;IN+ALL;PL|uraimba
uraim|N;IN+ESS;PL|uraimban
uraim|N;INS;PL|uraimmal
uraim|N;NOM;PL|uraim
uraim|N;ON+ABL;PL|uraimról
uraim|N;ON+ALL;PL|uraimra
uraim|N;ON+ESS;PL|uraimon
uraim|N;PRP;PL|uraimért
uraim|N;TERM;PL|uraimig
uraim|N;TRANS;PL|uraimmá
úszógumi|N;PSS1P;PL|úszógumijaink
úszógumi|N;PSS1S;PL|úszógumijaim
úszógumi|N;PSS2P;PL|úszógumijaitok
úszógumi|N;PSS2S;PL|úszógumijaid
úszógumi|N;PSS3P;PL|úszógumijaik
úszógumi|N;PSS3S;PL|úszógumijai
út|N;PSS3P;SG|útjuk
út|N;PSS3S;SG|útja
útikönyv|N;PSS2P;SG|útikönyvetek
ügy|N;PSS2P;SG|ügyetek
ügyvéd|N;PSS3P;SG|ügyvédjük
ügyvéd|N;PSS3S;SG|ügyvédje
ükanya|N;PSS3P;SG|ükanyjuk
ükanya|N;PSS3S;SG|ükanyja
ükapa|N;PSS3P;SG|ükapjuk
ükapa|N;PSS3S;SG|ükapja
ürügy|N;PSS2P;SG|ürügyetek
űrügy|N;PSS2P;SG|űrügyetek
üzi|N;PSS1P;PL|üzijeink
üzi|N;PSS1S;PL|üzijeim
üzi|N;PSS2P;PL|üzijeitek
üzi|N;PSS2S;PL|üzijeid
üzi|N;PSS3P;PL|üzijeik
üzi|N;PSS3S;PL|üzijei
vádi|N;PSS1P;PL|vádijaink
vádi|N;PSS1S;PL|vádijaim
vádi|N;PSS2P;PL|vádijaitok
vádi|N;PSS2S;PL|vádijaid
vádi|N;PSS3P;PL|vádijaik
vádi|N;PSS3S;PL|vádijai
vádli|N;PSS1P;PL|vádlijaink
vádli|N;PSS1S;PL|vádlijaim
vádli|N;PSS2P;PL|vádlijaitok
vádli|N;PSS2S;PL|vádlijaid
vádli|N;PSS3P;PL|vádlijaik
vádli|N;PSS3S;PL|vádlijai
vágóhíd|N;PSS1P;PL|vágóhídjaink
vágóhíd|N;PSS1S;PL|vágóhídjaim
vágóhíd|N;PSS2P;PL|vágóhídjaitok
vágóhíd|N;PSS2S;PL|vágóhídjaid
vágóhíd|N;PSS3P;PL|vágóhídjaik
vágóhíd|N;PSS3P;SG|vágóhídjuk
vágóhíd|N;PSS3S;PL|vágóhídjai
vágóhíd|N;PSS3S;SG|vágóhídja
vaker|N;ACC;SG|vakert
vaker|N;PSS1S;SG|vakerom
vaker|N;PSS2P;SG|vakerotok
vaker|N;PSS2S;SG|vakerod
választott|N;AT+ABL;SG|választottól
válogatott|N;AT+ABL;SG|válogatottól
varázsige|N;ACC;PL|varázsigéket
varázsige|N;AT+ABL;PL|varázsigéktől
varázsige|N;AT+ALL;PL|varázsigékhez
varázsige|N;AT+ESS;PL|varázsigéknél
varázsige|N;DAT;PL|varázsigéknek
varázsige|N;IN+ABL;PL|varázsigékből
varázsige|N;IN+ALL;PL|varázsigékbe
varázsige|N;IN+ESS;PL|varázsigékben
varázsige|N;INS;PL|varázsigékkel
varázsige|N;ON+ABL;PL|varázsigékről
varázsige|N;ON+ALL;PL|varázsigékre
varázsige|N;ON+ESS;PL|varázsigéken
varázsige|N;TRANS;PL|varázsigékké
városi|N;PSS1P;PL|városijaink
városi|N;PSS1S;PL|városijaim
városi|N;PSS2P;PL|városijaitok
városi|N;PSS2S;PL|városijaid
városi|N;PSS3P;PL|városijaik
városi|N;PSS3S;PL|városijai
vasai|N;ACC;PL|vasait
vasai|N;AT+ABL;PL|vasaitól
vasai|N;AT+ALL;PL|vasaihoz
vasai|N;AT+ESS;PL|vasainál
vasai|N;DAT;PL|vasainak
vasai|N;FRML;PL|vasaiként
vasai|N;IN+ABL;PL|vasaiból
vasai|N;IN+ALL;PL|vasaiba
vasai|N;IN+ESS;PL|vasaiban
vasai|N;INS;PL|vasaival
vasai|N;NOM;PL|vasai
vasai|N;ON+ABL;PL|vasairól
vasai|N;ON+ALL;PL|vasaira
vasai|N;ON+ESS;PL|vasain
vasai|N;PRP;PL|vasaiért
vasai|N;TERM;PL|vasaiig
vasai|N;TRANS;PL|vasaivá
vásárlói|N;ACC;PL|vásárlóit
vásárlói|N;AT+ABL;PL|vásárlóitól
vásárlói|N;AT+ALL;PL|vásárlóihoz
vásárlói|N;AT+ESS;PL|vásárlóinál
vásárlói|N;DAT;PL|vásárlóinak
vásárlói|N;FRML;PL|vásárlóiként
vásárlói|N;IN+ABL;PL|vásárlóiból
vásárlói|N;IN+ALL;PL|vásárlóiba
vásárlói|N;IN+ESS;PL|vásárlóiban
vásárlói|N;INS;PL|vásárlóival
vásárlói|N;NOM;PL|vásárlói
vásárlói|N;ON+ABL;PL|vásárlóiról
vásárlói|N;ON+ALL;PL|vásárlóira
vásárlói|N;ON+ESS;PL|vásárlóin
vásárlói|N;PRP;PL|vásárlóiért
vásárlói|N;TERM;PL|vásárlóiig
vásárlói|N;TRANS;PL|vásárlóivá
vastaps|N;ACC;SG|vastapsot
vasút|N;PSS1P;PL|vasútjaink
vasút|N;PSS1S;PL|vasútjaim
vasút|N;PSS2P;PL|vasútjaitok
vasút|N;PSS2S;PL|vasútjaid
vasút|N;PSS3P;PL|vasútjaik
vasút|N;PSS3P;SG|vasútjuk
vasút|N;PSS3S;PL|vasútjai
vasút|N;PSS3S;SG|vasútja
velencei|N;PSS1P;PL|velenceijeink
velencei|N;PSS1S;PL|velenceijeim
velencei|N;PSS2P;PL|velenceijeitek
velencei|N;PSS2S;PL|velenceijeid
velencei|N;PSS3P;PL|velenceijeik
velencei|N;PSS3S;PL|velenceijei
versei|N;ACC;PL|verseit
versei|N;AT+ABL;PL|verseitől
versei|N;AT+ALL;PL|verseihez
versei|N;AT+ESS;PL|verseinél
versei|N;DAT;PL|verseinek
versei|N;FRML;PL|verseiként
versei|N;IN+ABL;PL|verseiből
versei|N;IN+ALL;PL|verseibe
versei|N;IN+ESS;PL|verseiben
versei|N;INS;PL|verseivel
versei|N;NOM;PL|versei
versei|N;ON+ABL;PL|verseiről
versei|N;ON+ALL;PL|verseire
versei|N;ON+ESS;PL|versein
versei|N;PRP;PL|verseiért
versei|N;TERM;PL|verseiig
versei|N;TRANS;PL|verseivé
versenymű|N;PSS2P;SG|versenyművetek
vesekő|N;PSS2P;SG|vesekövetek
veszte|N;PSS1P;SG|vesztünk
veszte|N;PSS1S;SG|vesztem
veszte|N;PSS2P;SG|vesztetek
veszte|N;PSS2S;SG|veszted
veszte|N;PSS3P;SG|vesztük
veszte|N;PSS3S;SG|veszte
vezércikk|N;FRML;SG|vezércikként
vezetői|N;ACC;PL|vezetőit
vezetői|N;AT+ABL;PL|vezetőitől
vezetői|N;AT+ALL;PL|vezetőihez
vezetői|N;AT+ESS;PL|vezetőinél
vezetői|N;DAT;PL|vezetőinek
vezetői|N;FRML;PL|vezetőiként
vezetői|N;IN+ABL;PL|vezetőiből
vezetői|N;IN+ALL;PL|vezetőibe
vezetői|N;IN+ESS;PL|vezetőiben
vezetői|N;INS;PL|vezetőivel
vezetői|N;NOM;PL|vezetői
vezetői|N;ON+ABL;PL|vezetőiről
vezetői|N;ON+ALL;PL|vezetőire
vezetői|N;ON+ESS;PL|vezetőin
vezetői|N;PRP;PL|vezetőiért
vezetői|N;TERM;PL|vezetőiig
vezetői|N;TRANS;PL|vezetőivé
videoklip|N;PSS3P;SG|videoklipjük
videoklip|N;PSS3S;SG|videoklipje
vietnami|N;PSS1P;PL|vietnamijaink
vietnámi|N;PSS1P;PL|vietnámijaink
vietnami|N;PSS1S;PL|vietnamijaim
vietnámi|N;PSS1S;PL|vietnámijaim
vietnami|N;PSS2P;PL|vietnamijaitok
vietnámi|N;PSS2P;PL|vietnámijaitok
vietnami|N;PSS2S;PL|vietnamijaid
vietnámi|N;PSS2S;PL|vietnámijaid
vietnami|N;PSS3P;PL|vietnamijaik
vietnámi|N;PSS3P;PL|vietnámijaik
vietnami|N;PSS3S;PL|vietnamijai
vietnámi|N;PSS3S;PL|vietnámijai
világbéke|N;ACC;PL|világbékéket
világbéke|N;AT+ABL;PL|világbékéktől
világbéke|N;AT+ALL;PL|világbékékhez
világbéke|N;AT+ESS;PL|világbékéknél
világbéke|N;DAT;PL|világbékéknek
világbéke|N;IN+ABL;PL|világbékékből
világbéke|N;IN+ALL;PL|világbékékbe
világbéke|N;IN+ESS;PL|világbékékben
világbéke|N;INS;PL|világbékékkel
világbéke|N;ON+ABL;PL|világbékékről
világbéke|N;ON+ALL;PL|világbékékre
világbéke|N;ON+ESS;PL|világbékéken
világbéke|N;TRANS;PL|világbékékké
világítócső|N;PSS2P;SG|világítócsövetek
világvége|N;ACC;PL|világvégéket
világvége|N;AT+ABL;PL|világvégéktől
világvége|N;AT+ALL;PL|világvégékhez
világvége|N;AT+ESS;PL|világvégéknél
világvége|N;DAT;PL|világvégéknek
világvége|N;IN+ABL;PL|világvégékből
világvége|N;IN+ALL;PL|világvégékbe
világvége|N;IN+ESS;PL|világvégékben
világvége|N;INS;PL|világvégékkel
világvége|N;ON+ABL;PL|világvégékről
világvége|N;ON+ALL;PL|világvégékre
világvége|N;ON+ESS;PL|világvégéken
világvége|N;TRANS;PL|világvégékké
villásreggeli|N;PSS1P;PL|villásreggelijeink
villásreggeli|N;PSS1S;PL|villásreggelijeim
villásreggeli|N;PSS2P;PL|villásreggelijeitek
villásreggeli|N;PSS2S;PL|villásreggelijeid
villásreggeli|N;PSS3P;PL|villásreggelijeik
villásreggeli|N;PSS3S;PL|villásreggelijei
villi|N;PSS1P;PL|villijeink
villi|N;PSS1S;PL|villijeim
villi|N;PSS2P;PL|villijeitek
villi|N;PSS2S;PL|villijeid
villi|N;PSS3P;PL|villijeik
villi|N;PSS3S;PL|villijei
vilniusi|N;PSS1P;PL|vilniusijaink
vilniusi|N;PSS1S;PL|vilniusijaim
vilniusi|N;PSS2P;PL|vilniusijaitok
vilniusi|N;PSS2S;PL|vilniusijaid
vilniusi|N;PSS3P;PL|vilniusijaik
vilniusi|N;PSS3S;PL|vilniusijai
virsli|N;PSS1P;PL|virslijeink
virsli|N;PSS1S;PL|virslijeim
virsli|N;PSS2P;PL|virslijeitek
virsli|N;PSS2S;PL|virslijeid
virsli|N;PSS3P;PL|virslijeik
virsli|N;PSS3S;PL|virslijei
vízkő|N;PSS2P;SG|vízkövetek
vízrajz|N;ACC;SG|vízrajzot
vízügy|N;PSS2P;SG|vízügyetek
voks|N;ACC;SG|voksot
volta|N;PSS1P;SG|voltunk
volta|N;PSS1S;SG|voltom
volta|N;PSS2P;SG|voltotok
volta|N;PSS2S;SG|voltod
volta|N;PSS3P;SG|voltuk
volta|N;PSS3S;SG|volta
võro|N;ACC;PL|võrókat
võro|N;ACC;SG|võrót
võro|N;AT+ABL;PL|võróktól
võro|N;AT+ABL;SG|võrótól
võro|N;AT+ALL;PL|võrókhoz
võro|N;AT+ALL;SG|võróhoz
võro|N;AT+ESS;PL|võróknál
võro|N;AT+ESS;SG|võrónál
võro|N;DAT;PL|võróknak
võro|N;DAT;SG|võrónak
võro|N;IN+ABL;PL|võrókból
võro|N;IN+ABL;SG|võróból
võro|N;IN+ALL;PL|võrókba
võro|N;IN+ALL;SG|võróba
võro|N;IN+ESS;PL|võrókban
võro|N;IN+ESS;SG|võróban
võro|N;INS;PL|võrókkal
võro|N;INS;SG|võróval
võro|N;NOM;PL|võrók
võro|N;ON+ABL;PL|võrókról
võro|N;ON+ABL;SG|võróról
võro|N;ON+ALL;PL|võrókra
võro|N;ON+ALL;SG|võróra
võro|N;ON+ESS;PL|võrókon
võro|N;ON+ESS;SG|võrón
võro|N;PRP;PL|võrókért
võro|N;PRP;SG|võróért
võro|N;TERM;PL|võrókig
võro|N;TERM;SG|võróig
võro|N;TRANS;PL|võrókká
võro|N;TRANS;SG|võróvá
völgy|N;PSS2P;SG|völgyetek
walesi|N;PSS1P;PL|walesijeink
walesi|N;PSS1S;PL|walesijeim
walesi|N;PSS2P;PL|walesijeitek
walesi|N;PSS2S;PL|walesijeid
walesi|N;PSS3P;PL|walesijeik
walesi|N;PSS3S;PL|walesijei
watt|N;AT+ABL;SG|wattól
weboldal|N;ACC;SG|weboldalt
whisky|N;ACC;PL|whiskyket
whisky|N;ACC;SG|whiskyt
whisky|N;AT+ABL;PL|whiskyktől
whisky|N;AT+ALL;PL|whiskykhez
whisky|N;AT+ESS;PL|whiskyknél
whisky|N;DAT;PL|whiskyknek
whisky|N;IN+ABL;PL|whiskykből
whisky|N;IN+ALL;PL|whiskykbe
whisky|N;IN+ESS;PL|whiskykben
whisky|N;INS;PL|whiskykkel
whisky|N;INS;SG|whiskyvel
whisky|N;NOM;PL|whiskyk
whisky|N;ON+ABL;PL|whiskykről
whisky|N;ON+ALL;PL|whiskykre
whisky|N;ON+ESS;PL|whiskyken
whisky|N;ON+ESS;SG|whiskyn
whisky|N;PRP;PL|whiskykért
whisky|N;TERM;PL|whiskykig
whisky|N;TRANS;PL|whiskykké
whisky|N;TRANS;SG|whiskyvé
xerox|N;INS;SG|xeroxszal
xerox|N;TRANS;SG|xeroxszá
zokni|N;PSS1P;PL|zoknijaink
zokni|N;PSS1S;PL|zoknijaim
zokni|N;PSS2P;PL|zoknijaitok
zokni|N;PSS2S;PL|zoknijaid
zokni|N;PSS3P;PL|zoknijaik
zokni|N;PSS3S;PL|zoknijai
zombi|N;PSS1P;PL|zombijaink
zombi|N;PSS1S;PL|zombijaim
zombi|N;PSS2P;PL|zombijaitok
zombi|N;PSS2S;PL|zombijaid
zombi|N;PSS3P;PL|zombijaik
zombi|N;PSS3S;PL|zombijai
zsakett|N;AT+ABL;SG|zsakettől
zseni|N;PSS1P;PL|zsenijeink
zseni|N;PSS1S;PL|zsenijeim
zseni|N;PSS2P;PL|zsenijeitek
zseni|N;PSS2S;PL|zsenijeid
zseni|N;PSS3P;PL|zsenijeik
zseni|N;PSS3S;PL|zsenijei
zsírkő|N;PSS2P;SG|zsírkövetek
zsoltárkönyv|N;PSS2P;SG|zsoltárkönyvetek
zsoltároskönyv|N;PSS2P;SG|zsoltároskönyvetek
zsorzsett|N;AT+ABL;SG|zsorzsettől
zsűri|N;PSS1P;PL|zsűrijeink
zsűri|N;PSS1S;PL|zsűrijeim
zsűri|N;PSS2P;PL|zsűrijeitek
zsűri|N;PSS2S;PL|zsűrijeid
zsűri|N;PSS3P;PL|zsűrijeik
zsűri|N;PSS3S;PL|zsűrijei
`;

const HYPHEN_CLASS_DATA = `0|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:ral,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:jaink,N;PSS1P;SG:unk,N;PSS1S;PL:jaim,N;PSS1S;SG:om,N;PSS2P;PL:jaitok,N;PSS2P;SG:otok,N;PSS2S;PL:jaid,N;PSS2S;SG:od,N;PSS3P;PL:jaik,N;PSS3P;SG:juk,N;PSS3S;PL:jai,N;PSS3S;SG:ja,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:rá
1|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:zal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:om,N;PSS2P;PL:aitok,N;PSS2P;SG:otok,N;PSS2S;PL:aid,N;PSS2S;SG:od,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:zá
2|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:val,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:jaink,N;PSS1P;SG:unk,N;PSS1S;PL:jaim,N;PSS1S;SG:om,N;PSS2P;PL:jaitok,N;PSS2P;SG:otok,N;PSS2S;PL:jaid,N;PSS2S;SG:od,N;PSS3P;PL:jaik,N;PSS3P;SG:juk,N;PSS3S;PL:jai,N;PSS3S;SG:ja,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:vá
3|N;ACC;PL:eket,N;ACC;SG:t,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;FRML;PL:ekként,N;FRML;SG:ként,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:sel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;PSS1P;PL:eink,N;PSS1P;SG:ünk,N;PSS1S;PL:eim,N;PSS1S;SG:em,N;PSS2P;PL:eitek,N;PSS2P;SG:etek,N;PSS2S;PL:eid,N;PSS2S;SG:ed,N;PSS3P;PL:eik,N;PSS3P;SG:ük,N;PSS3S;PL:ei,N;PSS3S;SG:e,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:sé
4|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;FRML;PL:ekként,N;FRML;SG:ként,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:tel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;PSS1P;PL:jeink,N;PSS1P;SG:ünk,N;PSS1S;PL:jeim,N;PSS1S;SG:em,N;PSS2P;PL:jeitek,N;PSS2P;SG:etek,N;PSS2S;PL:jeid,N;PSS2S;SG:ed,N;PSS3P;PL:jeik,N;PSS3P;SG:jük,N;PSS3S;PL:jei,N;PSS3S;SG:je,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:té
5|N;ACC;PL:kat,N;ACC;SG:t,N;AT+ABL;PL:któl,N;AT+ABL;SG:tól,N;AT+ALL;PL:khoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:knál,N;AT+ESS;SG:nál,N;DAT;PL:knak,N;DAT;SG:nak,N;FRML;PL:kként,N;FRML;SG:ként,N;IN+ABL;PL:kból,N;IN+ABL;SG:ból,N;IN+ALL;PL:kba,N;IN+ALL;SG:ba,N;IN+ESS;PL:kban,N;IN+ESS;SG:ban,N;INS;PL:kkal,N;INS;SG:val,N;NOM;PL:k,N;ON+ABL;PL:król,N;ON+ABL;SG:ról,N;ON+ALL;PL:kra,N;ON+ALL;SG:ra,N;ON+ESS;PL:kon,N;ON+ESS;SG:n,N;PRP;PL:kért,N;PRP;SG:ért,N;PSS1P;PL:ink,N;PSS1P;SG:nk,N;PSS1S;PL:im,N;PSS1S;SG:m,N;PSS2P;PL:itok,N;PSS2P;SG:tok,N;PSS2S;PL:id,N;PSS2S;SG:d,N;PSS3P;PL:ik,N;PSS3P;SG:juk,N;PSS3S;PL:i,N;PSS3S;SG:ja,N;TERM;PL:kig,N;TERM;SG:ig,N;TRANS;PL:kká,N;TRANS;SG:vá
6|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:szal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:om,N;PSS2P;PL:aitok,N;PSS2P;SG:otok,N;PSS2S;PL:aid,N;PSS2S;SG:od,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:szá
7|N;ACC;PL:ket,N;ACC;SG:t,N;AT+ABL;PL:ktől,N;AT+ABL;SG:től,N;AT+ALL;PL:khez,N;AT+ALL;SG:hez,N;AT+ESS;PL:knél,N;AT+ESS;SG:nél,N;DAT;PL:knek,N;DAT;SG:nek,N;FRML;PL:kként,N;FRML;SG:ként,N;IN+ABL;PL:kből,N;IN+ABL;SG:ből,N;IN+ALL;PL:kbe,N;IN+ALL;SG:be,N;IN+ESS;PL:kben,N;IN+ESS;SG:ben,N;INS;PL:kkel,N;INS;SG:vel,N;NOM;PL:k,N;ON+ABL;PL:kről,N;ON+ABL;SG:ről,N;ON+ALL;PL:kre,N;ON+ALL;SG:re,N;ON+ESS;PL:ken,N;ON+ESS;SG:n,N;PRP;PL:kért,N;PRP;SG:ért,N;PSS1P;PL:ink,N;PSS1P;SG:nk,N;PSS1S;PL:im,N;PSS1S;SG:m,N;PSS2P;PL:itek,N;PSS2P;SG:tek,N;PSS2S;PL:id,N;PSS2S;SG:d,N;PSS3P;PL:ik,N;PSS3P;SG:jük,N;PSS3S;PL:i,N;PSS3S;SG:je,N;TERM;PL:kig,N;TERM;SG:ig,N;TRANS;PL:kké,N;TRANS;SG:vé
8|N;ACC;PL:eket,N;ACC;SG:t,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;FRML;PL:ekként,N;FRML;SG:ként,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:rel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;PSS1P;PL:eink,N;PSS1P;SG:ünk,N;PSS1S;PL:eim,N;PSS1S;SG:em,N;PSS2P;PL:eitek,N;PSS2P;SG:etek,N;PSS2S;PL:eid,N;PSS2S;SG:ed,N;PSS3P;PL:eik,N;PSS3P;SG:ük,N;PSS3S;PL:ei,N;PSS3S;SG:e,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:ré
9|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:sal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:om,N;PSS2P;PL:aitok,N;PSS2P;SG:otok,N;PSS2S;PL:aid,N;PSS2S;SG:od,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:sá
10|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:ral,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:om,N;PSS2P;PL:aitok,N;PSS2P;SG:otok,N;PSS2S;PL:aid,N;PSS2S;SG:od,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:rá
11|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:pal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:pá
12|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;FRML;PL:ekként,N;FRML;SG:ként,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:cel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;PSS1P;PL:eink,N;PSS1P;SG:ünk,N;PSS1S;PL:eim,N;PSS1S;SG:em,N;PSS2P;PL:eitek,N;PSS2P;SG:etek,N;PSS2S;PL:eid,N;PSS2S;SG:ed,N;PSS3P;PL:eik,N;PSS3P;SG:ük,N;PSS3S;PL:ei,N;PSS3S;SG:e,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:cé
13|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:kal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:jaink,N;PSS1P;SG:unk,N;PSS1S;PL:jaim,N;PSS1S;SG:om,N;PSS2P;PL:jaitok,N;PSS2P;SG:otok,N;PSS2S;PL:jaid,N;PSS2S;SG:od,N;PSS3P;PL:jaik,N;PSS3P;SG:juk,N;PSS3S;PL:jai,N;PSS3S;SG:ja,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:ká
14|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:tal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:jaink,N;PSS1P;SG:unk,N;PSS1S;PL:jaim,N;PSS1S;SG:om,N;PSS2P;PL:jaitok,N;PSS2P;SG:otok,N;PSS2S;PL:jaid,N;PSS2S;SG:od,N;PSS3P;PL:jaik,N;PSS3P;SG:juk,N;PSS3S;PL:jai,N;PSS3S;SG:ja,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:tá
15|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:mal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:jaink,N;PSS1P;SG:unk,N;PSS1S;PL:jaim,N;PSS1S;SG:om,N;PSS2P;PL:jaitok,N;PSS2P;SG:otok,N;PSS2S;PL:jaid,N;PSS2S;SG:od,N;PSS3P;PL:jaik,N;PSS3P;SG:juk,N;PSS3S;PL:jai,N;PSS3S;SG:ja,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:má
16|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;FRML;PL:ekként,N;FRML;SG:ként,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:tel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:té
17|N;ACC;PL:akat,N;ACC;SG:t,N;AT+ABL;PL:aktól,N;AT+ABL;SG:tól,N;AT+ALL;PL:akhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:aknál,N;AT+ESS;SG:nál,N;DAT;PL:aknak,N;DAT;SG:nak,N;FRML;PL:akként,N;FRML;SG:ként,N;IN+ABL;PL:akból,N;IN+ABL;SG:ból,N;IN+ALL;PL:akba,N;IN+ALL;SG:ba,N;IN+ESS;PL:akban,N;IN+ESS;SG:ban,N;INS;PL:akkal,N;INS;SG:lal,N;NOM;PL:ak,N;ON+ABL;PL:akról,N;ON+ABL;SG:ról,N;ON+ALL;PL:akra,N;ON+ALL;SG:ra,N;ON+ESS;PL:akon,N;ON+ESS;SG:on,N;PRP;PL:akért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:am,N;PSS2P;PL:aitok,N;PSS2P;SG:atok,N;PSS2S;PL:aid,N;PSS2S;SG:ad,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:akig,N;TERM;SG:ig,N;TRANS;PL:akká,N;TRANS;SG:lá
18|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:dal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:om,N;PSS2P;PL:aitok,N;PSS2P;SG:otok,N;PSS2S;PL:aid,N;PSS2S;SG:od,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:dá
19|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;FRML;PL:ekként,N;FRML;SG:ként,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:fel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;PSS1P;PL:jeink,N;PSS1P;SG:ünk,N;PSS1S;PL:jeim,N;PSS1S;SG:em,N;PSS2P;PL:jeitek,N;PSS2P;SG:etek,N;PSS2S;PL:jeid,N;PSS2S;SG:ed,N;PSS3P;PL:jeik,N;PSS3P;SG:jük,N;PSS3S;PL:jei,N;PSS3S;SG:je,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:fé
20|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;FRML;PL:okként,N;FRML;SG:ként,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:mal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;PSS1P;PL:aink,N;PSS1P;SG:unk,N;PSS1S;PL:aim,N;PSS1S;SG:om,N;PSS2P;PL:aitok,N;PSS2P;SG:otok,N;PSS2S;PL:aid,N;PSS2S;SG:od,N;PSS3P;PL:aik,N;PSS3P;SG:uk,N;PSS3S;PL:ai,N;PSS3S;SG:a,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:má
21|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:lal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:lá
22|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:tal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:tá
23|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:ral,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:rá
24|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:bal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:bá
25|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:nal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:ná
26|N;ACC;PL:öket,N;ACC;SG:öt,N;AT+ABL;PL:öktől,N;AT+ABL;SG:től,N;AT+ALL;PL:ökhöz,N;AT+ALL;SG:höz,N;AT+ESS;PL:öknél,N;AT+ESS;SG:nél,N;DAT;PL:öknek,N;DAT;SG:nek,N;IN+ABL;PL:ökből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ökbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ökben,N;IN+ESS;SG:ben,N;INS;PL:ökkel,N;INS;SG:tel,N;NOM;PL:ök,N;ON+ABL;PL:ökről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ökre,N;ON+ALL;SG:re,N;ON+ESS;PL:ökön,N;ON+ESS;SG:ön,N;PRP;PL:ökért,N;PRP;SG:ért,N;TERM;PL:ökig,N;TERM;SG:ig,N;TRANS;PL:ökké,N;TRANS;SG:té
27|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:vel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:vé
28|N;ACC;PL:ket,N;ACC;SG:t,N;AT+ABL;PL:ktől,N;AT+ABL;SG:től,N;AT+ALL;PL:khez,N;AT+ALL;SG:hez,N;AT+ESS;PL:knél,N;AT+ESS;SG:nél,N;DAT;PL:knek,N;DAT;SG:nek,N;IN+ABL;PL:kből,N;IN+ABL;SG:ből,N;IN+ALL;PL:kbe,N;IN+ALL;SG:be,N;IN+ESS;PL:kben,N;IN+ESS;SG:ben,N;INS;PL:kkel,N;INS;SG:vel,N;NOM;PL:k,N;ON+ABL;PL:kről,N;ON+ABL;SG:ről,N;ON+ALL;PL:kre,N;ON+ALL;SG:re,N;ON+ESS;PL:ken,N;ON+ESS;SG:n,N;PRP;PL:kért,N;PRP;SG:ért,N;TERM;PL:kig,N;TERM;SG:ig,N;TRANS;PL:kké,N;TRANS;SG:vé
29|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:tel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:té
30|N;ACC;PL:kat,N;ACC;SG:t,N;AT+ABL;PL:któl,N;AT+ABL;SG:tól,N;AT+ALL;PL:khoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:knál,N;AT+ESS;SG:nál,N;DAT;PL:knak,N;DAT;SG:nak,N;IN+ABL;PL:kból,N;IN+ABL;SG:ból,N;IN+ALL;PL:kba,N;IN+ALL;SG:ba,N;IN+ESS;PL:kban,N;IN+ESS;SG:ban,N;INS;PL:kkal,N;INS;SG:val,N;NOM;PL:k,N;ON+ABL;PL:król,N;ON+ABL;SG:ról,N;ON+ALL;PL:kra,N;ON+ALL;SG:ra,N;ON+ESS;PL:kon,N;ON+ESS;SG:n,N;PRP;PL:kért,N;PRP;SG:ért,N;TERM;PL:kig,N;TERM;SG:ig,N;TRANS;PL:kká,N;TRANS;SG:vá
31|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:mal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:má
32|N;ACC;PL:eket,N;ACC;SG:t,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:sel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:sé
33|N;ACC;PL:okat,N;ACC;SG:t,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:nyal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:nyá
34|N;ACC;PL:eket,N;ACC;SG:t,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:nyel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:nyé
35|N;ACC;PL:eket,N;ACC;SG:t,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:szel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:szé
36|N;ACC;PL:akat,N;ACC;SG:at,N;AT+ABL;PL:aktól,N;AT+ABL;SG:tól,N;AT+ALL;PL:akhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:aknál,N;AT+ESS;SG:nál,N;DAT;PL:aknak,N;DAT;SG:nak,N;IN+ABL;PL:akból,N;IN+ABL;SG:ból,N;IN+ALL;PL:akba,N;IN+ALL;SG:ba,N;IN+ESS;PL:akban,N;IN+ESS;SG:ban,N;INS;PL:akkal,N;INS;SG:tal,N;NOM;PL:ak,N;ON+ABL;PL:akról,N;ON+ABL;SG:ról,N;ON+ALL;PL:akra,N;ON+ALL;SG:ra,N;ON+ESS;PL:akon,N;ON+ESS;SG:on,N;PRP;PL:akért,N;PRP;SG:ért,N;TERM;PL:akig,N;TERM;SG:ig,N;TRANS;PL:akká,N;TRANS;SG:tá
37|N;ACC;PL:eket,N;ACC;SG:et,N;AT+ABL;PL:ektől,N;AT+ABL;SG:től,N;AT+ALL;PL:ekhez,N;AT+ALL;SG:hez,N;AT+ESS;PL:eknél,N;AT+ESS;SG:nél,N;DAT;PL:eknek,N;DAT;SG:nek,N;IN+ABL;PL:ekből,N;IN+ABL;SG:ből,N;IN+ALL;PL:ekbe,N;IN+ALL;SG:be,N;IN+ESS;PL:ekben,N;IN+ESS;SG:ben,N;INS;PL:ekkel,N;INS;SG:gel,N;NOM;PL:ek,N;ON+ABL;PL:ekről,N;ON+ABL;SG:ről,N;ON+ALL;PL:ekre,N;ON+ALL;SG:re,N;ON+ESS;PL:eken,N;ON+ESS;SG:en,N;PRP;PL:ekért,N;PRP;SG:ért,N;TERM;PL:ekig,N;TERM;SG:ig,N;TRANS;PL:ekké,N;TRANS;SG:gé
38|N;ACC;PL:okat,N;ACC;SG:ot,N;AT+ABL;PL:októl,N;AT+ABL;SG:tól,N;AT+ALL;PL:okhoz,N;AT+ALL;SG:hoz,N;AT+ESS;PL:oknál,N;AT+ESS;SG:nál,N;DAT;PL:oknak,N;DAT;SG:nak,N;IN+ABL;PL:okból,N;IN+ABL;SG:ból,N;IN+ALL;PL:okba,N;IN+ALL;SG:ba,N;IN+ESS;PL:okban,N;IN+ESS;SG:ban,N;INS;PL:okkal,N;INS;SG:dal,N;NOM;PL:ok,N;ON+ABL;PL:okról,N;ON+ABL;SG:ról,N;ON+ALL;PL:okra,N;ON+ALL;SG:ra,N;ON+ESS;PL:okon,N;ON+ESS;SG:on,N;PRP;PL:okért,N;PRP;SG:ért,N;TERM;PL:okig,N;TERM;SG:ig,N;TRANS;PL:okká,N;TRANS;SG:dá
`;

const HYPHEN_LEMMA_DATA = `alez.|3
ápr.|9
ászf|19
aug.|9
bek.|32
bokeh|5
byte|22
cs.|14
db|24
de.|26
dec.|8
dkg|15
dr.|23
du.|25
em.|29
évf.|31
febr.|0
fej.|29
fn.|27
fszt.|4
g|15
gimn.|31
house|1
hsz.|5
igh.|32
iPhone|25
isk.|30
ism.|32
jan.|0
júl.|9
jún.|9
k.|16
ker.|29
kft.|28
kht.|30
kkv|30
korm.|33
krt.|36
ktg.|37
l.|11
m.|28
m|8
máj.|9
márc.|9
max.|20
mousse|6
mp|12
nov.|8
nyrt.|28
o.|17
okt.|8
op.|6
orrspray|28
p.|14
p|12
pendrive|2
poli(vinil-klorid)|38
prof.|10
pu.|23
puzzle|21
röv.|32
rt.|7
show|5
spray|7
stroke|13
sz.|18
szept.|8
tb|7
tbc|28
tel.|25
tsz|35
tv.|34
tv|7
valóságshow|30
vb|7
zrt.|28
`;

const UNSAFE_HEAD_DATA = `agy
ágy
alom
bácsi
chat
cisz
csi
cső
dér
ész
essz
fark
föl
haj
hely
helyesség
hossz
iker
ing
írom
kapor
láz
légy
lék
lik
mész
olaj
oldal
sár
szár
szék
székhely
tál
tár
vaj
vár
vas
zár
`;

function parseStemData(data: string): {
  flags: Map<string, StemFlags>;
  back: Set<string>;
} {
  const flags = new Map<string, StemFlags>();
  const back = new Set<string>();
  for (const line of data.split("\n")) {
    if (line.length === 0) continue;
    const [lemma, spec] = line.split("|") as [string, string];
    const entry: StemFlags = {};
    let regular = false;
    for (const flag of spec.split(",")) {
      if (flag === "r") regular = true;
      else if (flag === "l") entry.lowering = "both";
      else if (flag === "la") entry.lowering = "accusative";
      else if (flag === "lp") entry.lowering = "plural";
      else if (flag === "k") entry.vowelPlural = "linking";
      else if (flag === "j") entry.possessiveJ = true;
      else if (flag === "b") back.add(lemma);
      else if (flag === "h:b") entry.harmony = "back";
      else if (flag === "h:f") entry.harmony = "front";
      else if (flag.startsWith("s:")) entry.shortening = flag.slice(2);
      else if (flag.startsWith("v:")) entry.vStem = flag.slice(2);
      else if (flag.startsWith("f:")) entry.fleeting = flag.slice(2);
    }
    if (regular || Object.keys(entry).length > 0) flags.set(lemma, entry);
  }
  return { flags, back };
}

function parseHyphenData(
  classData: string,
  lemmaData: string,
): Map<string, ReadonlyMap<string, string>> {
  const classes = new Map<string, Map<string, string>>();
  for (const line of classData.split("\n")) {
    if (line.length === 0) continue;
    const [id, pairs] = line.split("|") as [string, string];
    const bundle = new Map<string, string>();
    for (const pair of pairs.split(",")) {
      const colon = pair.lastIndexOf(":");
      bundle.set(pair.slice(0, colon), pair.slice(colon + 1));
    }
    classes.set(id, bundle);
  }
  const lemmas = new Map<string, ReadonlyMap<string, string>>();
  for (const line of lemmaData.split("\n")) {
    if (line.length === 0) continue;
    const [lemma, id] = line.split("|") as [string, string];
    const bundle = classes.get(id);
    if (bundle) lemmas.set(lemma, bundle);
  }
  return lemmas;
}

const parsed = parseStemData(STEM_DATA);

/** Per-lemma stem alternation flags. */
export const STEM_FLAGS: ReadonlyMap<string, StemFlags> = parsed.flags;

/** All-neutral-vowel lemmas with back harmony (legacy `b` flag lines). */
export const BACK_LEMMAS: ReadonlySet<string> = parsed.back;

/** Residual full-form overrides, keyed by `lemma|tag`. */
export const FORM_OVERRIDES: ReadonlyMap<string, string> = new Map(
  OVERRIDE_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, tag, form] = line.split("|") as [string, string, string];
      return [`${lemma}|${tag}`, form] as const;
    }),
);

/**
 * Hyphen-suffixing lemmas (abbreviations, foreign spellings: "tv-vel",
 * "house-t"): lemma → tag → suffix written after the hyphen.
 */
export const HYPHEN_SUFFIXES: ReadonlyMap<string, ReadonlyMap<string, string>> = parseHyphenData(
  HYPHEN_CLASS_DATA,
  HYPHEN_LEMMA_DATA,
);

/**
 * Lemmas that look like compound heads but are really derivational suffixes
 * (`régész` is `rég` + `-ész`, not a compound with `ész`). Measured, not
 * guessed: each one loses more forms than it fixes across the corpus.
 */
export const UNSAFE_COMPOUND_HEADS: ReadonlySet<string> = new Set(
  UNSAFE_HEAD_DATA.split("\n").filter((line) => line.length > 0),
);
